// This file was automatically generated from Excel data
// src/components/CreatureDatabase.js

// Pre-populated creature database
export const creatureDatabase = [
  {
    "id": "DOP-57/232",
    "displayName": "Ekuud",
    "name": "Ekuud",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Noble",
    "ability": "Hive: Ekuud has an additional 5 Energy for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "\"Fear the enemy, yes. But fear me more!\" — Ekuud",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "57/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 70,
      "wisdom": 40,
      "speed": 50,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Pwargnn.png"
  },
  {
    "id": "DOP-58/232",
    "displayName": "Formicidor",
    "name": "Formicidor",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Squadleader Scout",
    "ability": "Hive: Formicidor has an additional 10 :courage:Courage for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "Because he dares to roam the UnderWorld, Formicidor knows secrets even some UnderWorlders do not.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "58/232",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 50,
      "wisdom": 45,
      "speed": 50,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/2B8OhdP.png"
  },
  {
    "id": "DOP-59/232",
    "displayName": "Galin",
    "name": "Galin",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "Hive: Galin has an additional 10 :speed:Speed for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "Galin believes he can speak with his Danian ancestors, who have yet to tell him anything of much use.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "59/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 80,
      "wisdom": 50,
      "speed": 75,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/HVCDIsF.png"
  },
  {
    "id": "DOP-60/232",
    "displayName": "Hota",
    "name": "Hota",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Mandiblor Muge",
    "ability": "",
    "flavorText": "\"Hota is the least ‘Danian’ Danian I know.\" — Ibiaan",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Kanilla Tripp",
    "serialNumber": "60/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 65,
      "wisdom": 45,
      "speed": 40,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/1o3IOVF.png"
  },
  {
    "id": "DOP-61/232",
    "displayName": "Ibiaan",
    "name": "Ibiaan",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "Hive: Ibiaan has an additional 5 :wisdom:Wisdom for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "\"If Ibiaan’s so smart, why is he still a Mandiblor?\" — Hota",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "61/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 70,
      "wisdom": 75,
      "speed": 40,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/OtSfPnv.png"
  },
  {
    "id": "DOP-62/232",
    "displayName": "Junda",
    "name": "Junda",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Squadleader",
    "ability": ":danianmugic:: Activate Hive.",
    "flavorText": "Every Mandiblor aspires to be a Squadleader. So, even while Junda faces the enemy, he’s also watching his back.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "62/232",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 65,
      "wisdom": 60,
      "speed": 50,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/HQ1P7JY.png"
  },
  {
    "id": "DOP-63/232",
    "displayName": "Kannen",
    "name": "Kannen",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Battlemaster",
    "ability": ":danianmugic:: Activate Hive.\r\nSacrifice Kannen: Return a Mandiblor Creature Card from your general discard pile to play to any unoccupied space on the Battleboard.",
    "flavorText": "\"My life is my Tribe!\" — Kannen",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "63/232",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 30,
      "wisdom": 80,
      "speed": 35,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/B5rmX6t.png"
  },
  {
    "id": "DOP-64/232",
    "displayName": "Kebna",
    "name": "Kebna",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Battlemaster",
    "ability": "Hive: Kebna has an additional 5 Energy for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "There’s a fine line between bravery and insanity. Kebna crosses that line daily.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "64/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 40,
      "wisdom": 65,
      "speed": 45,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Ud4W1Pm.png"
  },
  {
    "id": "DOP-65/232",
    "displayName": "Lhad",
    "name": "Lhad",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "",
    "flavorText": "\"Unless we become one, we will become none.\" — Mandiblor war cry",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "65/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 75,
      "wisdom": 80,
      "speed": 35,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ssgABuy.png"
  },
  {
    "id": "DOP-66/232",
    "displayName": "Lore",
    "name": "Lore",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Muge",
    "ability": ":danianmugic:: Deal 10 damage to target Creature and heal 10 damage to Lore.",
    "flavorText": "As a spirit leader of the Danians, many believe this shaman may one day lead his Tribe to the Cothica.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "66/232",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 45,
      "wisdom": 80,
      "speed": 40,
      "energy": 30,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/goOFSMi.png"
  },
  {
    "id": "DOP-67/232",
    "displayName": "Mallash",
    "name": "Mallash",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Battlemaster",
    "ability": "Hive: Mallash has an additional 5 Energy for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "\"Irresponsible? It’s self-preservation.\" — Mallash, rebuffing critics of his \"Attack-first, make-sure-it’s-an-enemy-later\" policy",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "67/232",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 35,
      "wisdom": 55,
      "speed": 45,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/rVM0J5m.png"
  },
  {
    "id": "DOP-68/232",
    "displayName": "Odu-Bathax",
    "name": "Odu-Bathax",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Warrior",
    "ability": "Odu-Bathax has an additional 5 Energy for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "Odu-Bathax is the defender of the North Gate at Mount Pillar.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "68/232",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 70,
      "wisdom": 60,
      "speed": 50,
      "energy": 40,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/QcLprFn.png"
  },
  {
    "id": "DOP-69/232",
    "displayName": "Skartalas",
    "name": "Skartalas",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Controller",
    "ability": "Sacrifice Skartalas: Activate Hive.",
    "flavorText": "It’s rumored that Skartalas has had secret dealings with Van Bloot and that their bitter feud is simply an act to hide an alliance.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Jose Velasco, Edwin Nebres, Jimmy Tran",
    "serialNumber": "69/232",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 55,
      "wisdom": 50,
      "speed": 65,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/kh7lGGz.png"
  },
  {
    "id": "DOP-70/232",
    "displayName": "Valanii Levaan",
    "name": "Valanii Levaan",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Noble",
    "ability": "Hive: Valanii Levaan has an additional 10 :power:Power for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "When his Squadleaders don’t execute orders, Valanii Levaan orders executions.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "70/232",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 25,
      "speed": 35,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/IsPYken.png"
  },
  {
    "id": "DOP-71/232",
    "displayName": "Wamma",
    "name": "Wamma",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "Hive: Wamma has an additional 5 Energy for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "Most Mandiblors are diligent, dedicated warriors. Wamma is not like most Mandiblors.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "71/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 65,
      "wisdom": 40,
      "speed": 35,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/E5iPNDn.png"
  },
  {
    "id": "ZOTH-16/100",
    "displayName": "Balaan",
    "name": "Balaan",
    "subname": "",
    "set": "zoth",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Squadleader",
    "ability": "Sacrifice Balaan: Activate Hive.\r\nWhen Balaan is put into your general discard pile, Infect target Uninfected Creature.",
    "flavorText": "As his enemy sprouted antennae, Balaan knew his queen would be proud.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, Imaginary Friends Studios",
    "serialNumber": "16/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 45,
      "wisdom": 60,
      "speed": 35,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/HAe9qvS.png"
  },
  {
    "id": "ZOTH-17/100",
    "displayName": "Bierk",
    "name": "Bierk",
    "subname": "",
    "set": "zoth",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Squadleader",
    "ability": "At the beginning of each turn, if your opponent controls an UnderWorld Creature, Activate Hive.\r\nHive: Fireproof 10.",
    "flavorText": "Bierk was once seen cannonballing into the Lava Pond.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "17/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 60,
      "wisdom": 60,
      "speed": 50,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/T9pg3jT.png"
  },
  {
    "id": "ZOTH-18/100",
    "displayName": "Daj Huun",
    "name": "Daj Huun",
    "subname": "",
    "set": "zoth",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "Swift 2.\r\nHive: Daj Huun cannot move and has an additional 10 Energy.",
    "flavorText": "\"Look up Look around Never forget To look down\" — UnderWorld nursery rhyme",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "18/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 60,
      "wisdom": 45,
      "speed": 80,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Z3QUNTm.png"
  },
  {
    "id": "ZOTH-19/100",
    "displayName": "Dasalin",
    "name": "Dasalin",
    "subname": "",
    "set": "zoth",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": ":water:Water 5.\r\nHive: Dasalin does not have \":water:Water 5\" and has \":danianmugic:: Heal 10 damage to target Mandiblor Creature\".",
    "flavorText": "Quench your spirit as well as your thirst.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Emilio Lopez",
    "serialNumber": "19/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 45,
      "wisdom": 75,
      "speed": 35,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/SB0AlAY.png"
  },
  {
    "id": "ZOTH-20/100",
    "displayName": "Dubin",
    "name": "Dubin",
    "subname": "",
    "set": "zoth",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Controller",
    "ability": ":danianmugic:: Infect target Uninfected Creature.\r\nIf an opponent controls an Infected Creature, Dubin has an additional 5 Energy.",
    "flavorText": "How does the parasite take control? Who knows... who cares?!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "20/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 45,
      "wisdom": 60,
      "speed": 35,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/XndzlWU.png"
  },
  {
    "id": "ZOTH-21/100",
    "displayName": "Faash",
    "name": "Faash",
    "subname": "",
    "set": "zoth",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Elementalist",
    "ability": "Deactivate Hive: Faash gains \":fire:Fire 5.\" Hive cannot be Activated again this turn. (Hive must be active to Deactivate it.)",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "21/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 75,
      "wisdom": 45,
      "speed": 65,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/2nrAHLa.png"
  },
  {
    "id": "ZOTH-22/100",
    "displayName": "Illexia, The Danian Queen",
    "name": "Illexia",
    "subname": "The Danian Queen",
    "set": "zoth",
    "rarity": "ultra rare",
    "tribe": "danian",
    "subtype": "Noble",
    "ability": "Your adjacent Creatures have \"Defender.\"\r\nWhen a Mandiblor Creature or an Infected Creature is put into a general discard pile, put a Mugic counter on Illexia.\r\n:danianmugic:: Activate Hive.\r\nHive: Mugic counters on Illexia count as Mandiblors you control when counting Mandiblors.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "22/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 75,
      "wisdom": 75,
      "speed": 35,
      "energy": 60,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/yI8sL0h.png"
  },
  {
    "id": "ZOTH-23/100",
    "displayName": "Jaal",
    "name": "Jaal",
    "subname": "",
    "set": "zoth",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Warrior",
    "ability": "When Jaal deals :earth:Earth damage to an Uninfected Creature, Infect that Creature.\r\nIf engaged with an Infected Creature, Jaal has \":earth:Earth 5.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "23/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 45,
      "wisdom": 75,
      "speed": 40,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/5Tbl1jC.png"
  },
  {
    "id": "ZOTH-24/100",
    "displayName": "Kelvedran",
    "name": "Kelvedran",
    "subname": "",
    "set": "zoth",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "Fireproof 10.\r\nEarthproof 10.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, Khary Randolph, Etienne St.Laurent",
    "serialNumber": "24/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 60,
      "wisdom": 45,
      "speed": 65,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/SSSJtHd.png"
  },
  {
    "id": "ZOTH-25/100",
    "displayName": "Khavakk",
    "name": "Khavakk",
    "subname": "",
    "set": "zoth",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Muge",
    "ability": ":danianmugic:: Deal 5 damage to target Creature.\r\n:danianmugic:, Deactivate Hive: Deal 15 damage to target Creature.",
    "flavorText": "\"Power, strength and stamina? Overrated.\" — Khavakk",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "25/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 60,
      "wisdom": 45,
      "speed": 35,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/xu9S0c8.png"
  },
  {
    "id": "ZOTH-26/100",
    "displayName": "Khritlaan",
    "name": "Khritlaan",
    "subname": "",
    "set": "zoth",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Noble",
    "ability": "If Khritlaan is in your general discard pile, Mandiblor Creature Cards in your general discard pile count as Mandiblors you control when counting Mandiblors.",
    "flavorText": "\"Even from the grave shall you serve Illexia.\" — Khritlaan",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "26/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 60,
      "wisdom": 75,
      "speed": 35,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/DQqkJnU.png"
  },
  {
    "id": "ZOTH-27/100",
    "displayName": "Mahrrant",
    "name": "Mahrrant",
    "subname": "",
    "set": "zoth",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Mandiblor Muge",
    "ability": "When an Infected Creature is put into a general discard pile, put a Mugic counter on Mahrrant.\r\n:danianmugic:: Activate Hive.",
    "flavorText": "Never let anything go to waste - including your fallen foes.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Steve Ellis",
    "serialNumber": "27/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 70,
      "wisdom": 75,
      "speed": 35,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/pt1CiE0.png"
  },
  {
    "id": "ZOTH-28/100",
    "displayName": "Ramarhvir, The Danian Hivebringer",
    "name": "Ramarhvir",
    "subname": "The Danian Hivebringer",
    "set": "zoth",
    "rarity": "ultra rare",
    "tribe": "danian",
    "subtype": "Noble Mandiblor Muge",
    "ability": "When Hive is activated, you can remove a Mugic counter from a Danian Creature you control, if you do put a Mugic counter on Ramarhvir, the Danian Hivebringer.\r\n:danianmugic::danianmugic:: Return target Mandiblor Creature Card in your general discard pile to play to any unoccupied space on the Battleboard.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, David Curiel",
    "serialNumber": "28/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 75,
      "wisdom": 60,
      "speed": 35,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/857kNg0.png"
  },
  {
    "id": "ZOTH-29/100",
    "displayName": "Tassanil",
    "name": "Tassanil",
    "subname": "",
    "set": "zoth",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Noble Elementalist",
    "ability": ":water:Water 5.\r\nHive: Tassanil has an additional 5 Energy for each Elemental Type opposing Creatures have.\r\nTassanil counts as a Mandiblor.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "29/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 55,
      "wisdom": 65,
      "speed": 60,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/F7GBVc5.png"
  },
  {
    "id": "ZOTH-30/100",
    "displayName": "Yondaf",
    "name": "Yondaf",
    "subname": "",
    "set": "zoth",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Controller",
    "ability": "When an opposing Uninfected Creature is targeted by a Mugic you control, Infect that Creature.",
    "flavorText": "Forget your Tribe, forget your friends, forget yourself. You are one of us now!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, David Curiel",
    "serialNumber": "30/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 45,
      "wisdom": 75,
      "speed": 30,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/XUkAdds.png"
  },
  {
    "id": "SS-16/100",
    "displayName": "Hammerdoom Chantcaller, Assimilated",
    "name": "Hammerdoom Chantcaller",
    "subname": "Assimilated",
    "set": "ss",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Mandiblor Warrior",
    "ability": "Hive: Fireproof 10.\r\nAttacks played by Hammerdoom Chantcaller deal an additional 5 damage to UnderWorld Creatures.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent, Anthony Washington",
    "serialNumber": "16/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 50,
      "wisdom": 65,
      "speed": 65,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/8hAioBA.png"
  },
  {
    "id": "SS-17/100",
    "displayName": "Kolmo, Assimilated",
    "name": "Kolmo",
    "subname": "Assimilated",
    "set": "ss",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "Invisibility: Surprise.\r\nIf engaged with a Mipedian Royal Creature, Kolmo has \"Invisibility: Strike 20.\"\r\n:danianmugic:: If Kolmo is not engaged, relocate it to any unoccupied space on the Battleboard.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "17/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 80,
      "wisdom": 40,
      "speed": 70,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/0mZBEtZ.png"
  },
  {
    "id": "SS-18/100",
    "displayName": "Lobanne",
    "name": "Lobanne",
    "subname": "",
    "set": "ss",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Mandiblor Muge",
    "ability": ":danianmugic:: For each Mugic counter on Lobanne, choose \"Fireproof 10,\" \"Airproof 10,\" \"Earthproof 10\" or \"Waterproof 10.\" Target Creature gains the chosen abilities. This ability can only be used once per turn.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, Etienne St.Laurent",
    "serialNumber": "18/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 40,
      "wisdom": 65,
      "speed": 45,
      "energy": 40,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/P1WHK0y.png"
  },
  {
    "id": "SS-19/100",
    "displayName": "Makrabon",
    "name": "Makrabon",
    "subname": "",
    "set": "ss",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Controller",
    "ability": "When Makrabon has a Mugic counter put on it, Infect target Uninfected Creature.\r\n:danianmugic:: Activate or Deactivate Hive",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, Emilio Lopez, Anthony Washington",
    "serialNumber": "19/100",
    "isPast": false,
    "stats": {
      "courage": 30,
      "power": 40,
      "wisdom": 60,
      "speed": 35,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/akG5pul.png"
  },
  {
    "id": "SS-20/100",
    "displayName": "Raznus, Assimilated",
    "name": "Raznus",
    "subname": "Assimilated",
    "set": "ss",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Mandiblor Ambassador",
    "ability": ":danianmugic:: Danian Creatures you control cannot be targeted by Mugic or abilities. This ability can only be used once per turn.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez, Anthony Washington",
    "serialNumber": "20/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 30,
      "wisdom": 85,
      "speed": 40,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/dMqbiw6.png"
  },
  {
    "id": "BTD-29/222",
    "displayName": "Chaac",
    "name": "Chaac",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Squadleader Minion",
    "ability": "Hive: Chaac has an additional 15 Energy.\r\n:danianmugic:: Infect target Uninfected Creature.",
    "flavorText": "",
    "brainwashedText": ":danianmugic:: Target Creature loses an Elemental Type of your choice.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Ryan Bemjamin, Imaginary Friends Studios",
    "serialNumber": "29/222",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 50,
      "wisdom": 60,
      "speed": 45,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/lDZhCqA.png"
  },
  {
    "id": "BTD-30/222",
    "displayName": "Drazz",
    "name": "Drazz",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Mandiblor Minion",
    "ability": "If Drazz is Infected, it has \":earth:Earth 5.\"\r\nHive: Outperform :courage:Courage 5.",
    "flavorText": "",
    "brainwashedText": ":water:Water  5.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, David Curiel",
    "serialNumber": "30/222",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 70,
      "wisdom": 45,
      "speed": 30,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/6xqso5u.png"
  },
  {
    "id": "BTD-31/222",
    "displayName": "Hermatred",
    "name": "Hermatred",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor Minion",
    "ability": "Outperform :courage:Courage 5.\r\nHive: Hermatred has an additional 5 Energy for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "",
    "brainwashedText": ":water:Water  5.\r\nIf engaged with an Infected Creature, Hermatred has an additional 15 Energy.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Ryan Benjamin, John Rauch",
    "serialNumber": "31/222",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 60,
      "wisdom": 55,
      "speed": 40,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/Nnn9J5r.png"
  },
  {
    "id": "BTD-32/222",
    "displayName": "Irrabeq",
    "name": "Irrabeq",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Mandiblor Minion",
    "ability": ":water:Water 5.\r\nHive: Irrabeq has an additional 10 Energy.",
    "flavorText": "",
    "brainwashedText": "If engaged with an Infected Creature, Irrabeq has \"Outperform :courage:Courage  5.\"",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "32/222",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 45,
      "wisdom": 60,
      "speed": 70,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/6BiwD37.png"
  },
  {
    "id": "BTD-33/222",
    "displayName": "Kalanju",
    "name": "Kalanju",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Squadleader Minion",
    "ability": ":danianmugic:: Infect target Uninfected Creature.\r\nHive: If Kalanju is Infected, it has an additional 30 Energy.",
    "flavorText": "",
    "brainwashedText": ":danianmugic:: Infect target Uninfected Creature. \r\n:danianmugic:: Uninfect target Infected Creature.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, Anthony Washington",
    "serialNumber": "33/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 45,
      "wisdom": 65,
      "speed": 50,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/GxdP7z0.png"
  },
  {
    "id": "BTD-34/222",
    "displayName": "Katharaz",
    "name": "Katharaz",
    "subname": "",
    "set": "btd",
    "rarity": "ultra rare",
    "tribe": "danian",
    "subtype": "Elementalist",
    "ability": "Hive: Katharaz has \"Elementproof all Elemental Types 15.\"",
    "flavorText": "\"Unite and fight! If we lose the Reservoir, the rest of Mount Pillar will fall!\" — Katharaz",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "34/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 40,
      "wisdom": 55,
      "speed": 45,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/Q1NMJ6d.png"
  },
  {
    "id": "BTD-35/222",
    "displayName": "Lendai",
    "name": "Lendai",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Squadleader",
    "ability": "If Lendai is Uninfected, it has \":water:Water 5.\"\r\nIf Lendai is Infected, it has \"Untargetable.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Reggie Bulter",
    "serialNumber": "35/222",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 50,
      "wisdom": 70,
      "speed": 50,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/xIQDCaH.png"
  },
  {
    "id": "BTD-36/222",
    "displayName": "Mivindal",
    "name": "Mivindal",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Battlemaster Minion",
    "ability": "Sacrifice Mivindal: Return target Mandiblor Creature Card in your general discard pile to play to any unoccupied space on your side of the Battleboard.",
    "flavorText": "",
    "brainwashedText": "Sacrifice Mivindal: When target Chieftain Creature is destroyed this turn, return it to play in an unoccupied space.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Anthony Washington",
    "serialNumber": "36/222",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 40,
      "wisdom": 55,
      "speed": 50,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/B8pT1Af.png"
  },
  {
    "id": "BTD-37/222",
    "displayName": "Necrabe",
    "name": "Necrabe",
    "subname": "",
    "set": "btd",
    "rarity": "ultra rare",
    "tribe": "danian",
    "subtype": "Noble",
    "ability": ":danianmugic:: Infect target Uninfected Creature.\r\nIf a Creature Card would be returned to play from a general discard pile, remove it from the game and put 2 Mugic counters on Necrabe instead.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "37/222",
    "isPast": false,
    "stats": {
      "courage": 110,
      "power": 35,
      "wisdom": 80,
      "speed": 45,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/2pX9EXr.png"
  },
  {
    "id": "BTD-38/222",
    "displayName": "Nimmei",
    "name": "Nimmei",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Noble",
    "ability": "Hive: Nimmei has an additional 5 Energy and 5 in all Disciplines for each Mandiblor you control and each Infected Creature in play.",
    "flavorText": "Though young and untested, Nimmei's heart more than makes up for years of experience.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Gustavo, John Rauch",
    "serialNumber": "38/222",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 55,
      "wisdom": 45,
      "speed": 60,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/aiM1jkd.png"
  },
  {
    "id": "BTD-39/222",
    "displayName": "Rebant",
    "name": "Rebant",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Battlemaster Minion Muge",
    "ability": ":danianmugic:: Activate Hive.",
    "flavorText": "",
    "brainwashedText": ":danianmugic:: Heal 10 damage to target Uninfected Creature.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, David Curiel",
    "serialNumber": "39/222",
    "isPast": false,
    "stats": {
      "courage": 105,
      "power": 30,
      "wisdom": 75,
      "speed": 50,
      "energy": 35,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/lrVl73e.png"
  },
  {
    "id": "BTD-40/222",
    "displayName": "Tabaal",
    "name": "Tabaal",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Mandiblor Minion",
    "ability": ":danianmugic:: Infect target Uninfected Creature.",
    "flavorText": "",
    "brainwashedText": "Sacrifice a Mandiblor: Infect up to three target Uninfected Creatures.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Anthony Washington",
    "serialNumber": "40/222",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 40,
      "wisdom": 50,
      "speed": 70,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/SzDSYyN.png"
  },
  {
    "id": "BTD-41/222",
    "displayName": "Uholdan",
    "name": "Uholdan",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Squadleader Minion",
    "ability": ":danianmugic:: Activate Hive.\r\nHive: Uholdan has an additional 10 Energy.",
    "flavorText": "",
    "brainwashedText": ":danianmugic:: Relocate target opposing unengaged Creature to any unoccupied space on the Battleboard adjacent to it.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, Anthony Washington",
    "serialNumber": "41/222",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 60,
      "wisdom": 50,
      "speed": 65,
      "energy": 60,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/FPQ5Fyy.png"
  },
  {
    "id": "BTD-42/222",
    "displayName": "Ulmquad",
    "name": "Ulmquad",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Battlemaster Minion",
    "ability": ":danianmugic:: Deal 10 damage to target Creature and Ulmquad gains 10 Energy.",
    "flavorText": "",
    "brainwashedText": ":danianmugic:: Deal 10 damage to target Creature and it loses 20 :courage:Courage.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, Anthony Washington",
    "serialNumber": "42/222",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 60,
      "wisdom": 50,
      "speed": 70,
      "energy": 60,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/jdbMwPH.png"
  },
  {
    "id": "ROTO-15/100",
    "displayName": "Agrino Jaldar",
    "name": "Agrino Jaldar",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Minion Warrior",
    "ability": "Hive: Agrino Jaldar has an additional 5 Energy for each Danian Creature you control.\r\nDamage dealt by Agrino Jaldar to Minion Creatures is icreased by 5.",
    "flavorText": "",
    "brainwashedText": "Agrino Jaldar has an additional 5 Energy for each Minion Creature you control.\r\nDamage dealt by Agrino Jaldar to Infected Creatures is icreased by 5.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "15/100",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 60,
      "wisdom": 50,
      "speed": 65,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/lQXxZUn.png"
  },
  {
    "id": "ROTO-16/100",
    "displayName": "Aureban",
    "name": "Aureban",
    "subname": "",
    "set": "roto",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Battlemaster Minion",
    "ability": "Waterproof 10.\r\nHive: Aureban has an additional 10 Energy for each Infected Creature your opponent controls.",
    "flavorText": "",
    "brainwashedText": "Uninfect an Infected Creature you control: Deactivate Hive.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, David Curiel",
    "serialNumber": "16/100",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 60,
      "wisdom": 50,
      "speed": 65,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/iemqsDR.png"
  },
  {
    "id": "ROTO-17/100",
    "displayName": "Dhilas",
    "name": "Dhilas",
    "subname": "",
    "set": "roto",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Noble Muge",
    "ability": ":danianmugic:: Heal 10 damage to target Mandiblor Creature.\r\nHive: Danian Mugic played by Creatures you control which deals damage deal an additional 5 damage.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, Etienne St.Laurent",
    "serialNumber": "17/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 55,
      "wisdom": 70,
      "speed": 40,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/vsyQMcN.png"
  },
  {
    "id": "ROTO-18/100",
    "displayName": "Fliandar",
    "name": "Fliandar",
    "subname": "",
    "set": "roto",
    "rarity": "ultra rare",
    "tribe": "danian",
    "subtype": "Squadleader",
    "ability": "Uninfect 3 Infected Creatures: Activate Hive and heal all damage on Fliandar.",
    "flavorText": "Part Squadleader, part Parasite, all Danian.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "18/100",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 55,
      "wisdom": 85,
      "speed": 45,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/xSNwh4P.png"
  },
  {
    "id": "ROTO-19/100",
    "displayName": "Klencka",
    "name": "Klencka",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor Minion",
    "ability": "Waterproof 10.\r\nHive: Outperform :courage:Courage 5",
    "flavorText": "",
    "brainwashedText": "Outperform :courage:Courage  5",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, Anthony Washington",
    "serialNumber": "19/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 65,
      "wisdom": 60,
      "speed": 95,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/JZySMYf.png"
  },
  {
    "id": "ROTO-20/100",
    "displayName": "Tarbok",
    "name": "Tarbok",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "Waterproof 15.\r\nHive: Tarbok has an additional 15 Energy.",
    "flavorText": "\"My only fear is that I have no fear.\" — Tarbok",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, David Curiel",
    "serialNumber": "20/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 45,
      "wisdom": 55,
      "speed": 50,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/LbVIM5R.png"
  },
  {
    "id": "ROTO-21/100",
    "displayName": "Wamma, Hive Ordnance",
    "name": "Wamma",
    "subname": "Hive Ordnance",
    "set": "roto",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "When a Mandiblor Creature Card is put into play from a general discard pile, put a Mugic counter on Wamma.\r\nBattlegear equipped to Infected Creatures are not flipped face-up when those Creatures become engaged.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "21/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 55,
      "wisdom": 75,
      "speed": 45,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/KVOBMIC.png"
  },
  {
    "id": "TOTT-22/100",
    "displayName": "Elhadd",
    "name": "Elhadd",
    "subname": "",
    "set": "tott",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Mandiblor Scout",
    "ability": "If Elhadd is in your general discard pile, Mandiblor Creatures you control have \"Outperform :courage:Courage 5.\"",
    "flavorText": "To everyone's great surprise, it was Elhadd who discovered a link between the Kha'rall and their shards.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "22/100",
    "isPast": false,
    "stats": {
      "courage": 110,
      "power": 60,
      "wisdom": 85,
      "speed": 90,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/4KeR2HS.png"
  },
  {
    "id": "TOTT-23/100",
    "displayName": "Hiadrom",
    "name": "Hiadrom",
    "subname": "",
    "set": "tott",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor Warrior",
    "ability": "Hive: Hiadrom has an additional 15 Energy and Creatures engaged with it have 15 less Energy.",
    "flavorText": "Hiadrom excavates a new area of the UnderWorld, searching for a new home for the Danians.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "23/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 45,
      "wisdom": 65,
      "speed": 50,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/5EvAQF3.png"
  },
  {
    "id": "TOTT-24/100",
    "displayName": "Ivelaan",
    "name": "Ivelaan",
    "subname": "",
    "set": "tott",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "If Ivelaan is in your general discard pile, Mandiblor Creatures you control have an additional 25 in all Disciplines.",
    "flavorText": "On his first venture into the OverWorld, Ivelaan discovered something that changed the course of Danian history forever.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Axer",
    "serialNumber": "24/100",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 60,
      "wisdom": 75,
      "speed": 85,
      "energy": 65,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/29dcf5I.png"
  },
  {
    "id": "TOTT-25/100",
    "displayName": "Makanaz",
    "name": "Makanaz",
    "subname": "",
    "set": "tott",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor Warrior",
    "ability": "If Makanaz is in your general discard pile, Mandiblor Creatures you control have an additional 15 Energy.",
    "flavorText": "\"I pound and pummel with this arm while I slam and smash with the other... and I still have limbs to spare!\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "25/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 100,
      "wisdom": 60,
      "speed": 85,
      "energy": 70,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/gjyRuk0.png"
  },
  {
    "id": "TOTT-26/100",
    "displayName": "Neekwin",
    "name": "Neekwin",
    "subname": "",
    "set": "tott",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Mandiblor Elementalist",
    "ability": "If Neekwin is unequipped, it has \":water:Water 5\" and \"Untargetable.\"",
    "flavorText": "\"The only battles the Danians ever lost were ones that I didn't fight.\" — Neekwin",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Axer",
    "serialNumber": "26/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 50,
      "wisdom": 100,
      "speed": 45,
      "energy": 70,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/Ljlu9ys.png"
  },
  {
    "id": "TOTT-14/100",
    "displayName": "Topar",
    "name": "Topar",
    "subname": "",
    "set": "tott",
    "rarity": "ultra rare",
    "tribe": "danian",
    "subtype": "Mandiblor Muge",
    "ability": "At the beginning of your turn, Infect target Uninfected Creature.\r\nWhen an Infected Danian Creature you control is targeted by a Mugic or ability, Uninfect that Creature and negate the Mugic or ability.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Axer",
    "serialNumber": "14/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 55,
      "wisdom": 55,
      "speed": 40,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/RNH3rAe.png"
  },
  {
    "id": "TOTT-35/100",
    "displayName": "Vilrik Landfarer",
    "name": "Vilrik Landfarer",
    "subname": "",
    "set": "tott",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Mandiblor Minion Elementalist",
    "ability": ":danianmugic:: Target Elemental Attack loses all abilities.",
    "flavorText": "",
    "brainwashedText": "Sacrifice a Minion Creature: Reveal a new active Location.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Sanford Greene, Axer",
    "serialNumber": "35/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 45,
      "wisdom": 80,
      "speed": 50,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/4dRNpQ1.png"
  },
  {
    "id": "FUN-17/100",
    "displayName": "Elna",
    "name": "Elna",
    "subname": "",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Mandiblor Muge",
    "ability": "If Elna is in your general discard pile, at the beginning of combat, activate Hive.",
    "flavorText": "The Cothica binds us all: the living and breathing with the dead and decaying.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "serialNumber": "17/100",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 65,
      "wisdom": 55,
      "speed": 55,
      "energy": 70,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/6jrUY26.png"
  },
  {
    "id": "FUN-18/100",
    "displayName": "Glapaal",
    "name": "Glapaal",
    "subname": "",
    "set": "fun",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor Muge",
    "ability": ":danianmugic:: Heal 10 damage to target engaged Mipedian Creature and deal 10 damage to the opposing engaged Creature.",
    "flavorText": "\"Wamma says only fools rush into battle. In that case... call me a fool!?\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Reggie Butler",
    "serialNumber": "18/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 35,
      "wisdom": 70,
      "speed": 50,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/kcUwwuj.png"
  },
  {
    "id": "FUN-19/100",
    "displayName": "Gorram, Danian General",
    "name": "Gorram",
    "subname": "Danian General",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Noble Elementalist",
    "ability": "While your general discard pile has:\r\nAn OverWorld Creature Card, your Creatures have \":water:Water 5.\"\r\nAn UnderWorld Creature Card, your Creatures have \":fire:Fire 5.\"\r\nA Mipedian Creature Card, your Creatures have \":air:Air 5.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": true,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Bob Rivard",
    "serialNumber": "19/100",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 60,
      "wisdom": 85,
      "speed": 45,
      "energy": 35,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/x1o1bz3.png"
  },
  {
    "id": "FUN-20/100",
    "displayName": "Kepiaan, Danian Lieutenant",
    "name": "Kepiaan",
    "subname": "Danian Lieutenant",
    "set": "fun",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Battlemaster",
    "ability": "Kepiaan has an additional 10 Energy and 10 in all Disciplines for each Tribe you control.",
    "flavorText": "Though hundreds of Danians perish to defeat a single Kha'rall, Kepiaan willingly accepts those losses.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Reggie Butler",
    "serialNumber": "20/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 50,
      "wisdom": 50,
      "speed": 50,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/mDMXijd.png"
  },
  {
    "id": "FUN-21/100",
    "displayName": "Klencka, Avenger",
    "name": "Klencka",
    "subname": "Avenger",
    "set": "fun",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Mandiblor Warrior",
    "ability": "While you control an OverWorld Creature, when Klencka deals damage with its first attack each combat, it gains Energy equal to the damage it dealt.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "21/100",
    "isPast": false,
    "stats": {
      "courage": 100,
      "power": 70,
      "wisdom": 70,
      "speed": 50,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/BnpWSbC.png"
  },
  {
    "id": "FUN-22/100",
    "displayName": "Lore, Ancestral Caller",
    "name": "Lore",
    "subname": "Ancestral Caller",
    "set": "fun",
    "rarity": "ultra rare",
    "tribe": "danian",
    "subtype": "Muge",
    "ability": ":danianmugic:: Deal 5 damage to the opposing engaged Creature and heal 5 damage to Lore.\r\nIf an opposing Creature would go to their general discard pile, remove it from the game and put a Mugic counter on Lore instead.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "22/100",
    "isPast": false,
    "stats": {
      "courage": 110,
      "power": 50,
      "wisdom": 70,
      "speed": 40,
      "energy": 60,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/e4tRWNI.png"
  },
  {
    "id": "FUN-23/100",
    "displayName": "Masilbaat",
    "name": "Masilbaat",
    "subname": "",
    "set": "fun",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Battlemaster Muge",
    "ability": "While you control an UnderWorld Creature, if Masilbaat would take damage from a Mugic or activated ability, it gains that amount of Energy instead.\r\n\r\n",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, Etienne St.Laurent",
    "serialNumber": "23/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 55,
      "wisdom": 65,
      "speed": 40,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/t0BrrM6.png"
  },
  {
    "id": "FUN-24/100",
    "displayName": "Vunhra",
    "name": "Vunhra",
    "subname": "",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Squadleader Minion",
    "ability": "Non-Danian Creatures you control deal 5 additional attack damage to Infected Creatures.",
    "flavorText": "",
    "brainwashedText": "Creatures you control deal an additional 5 attack damage to Creatures that are a M'arrillian or a Minion.",
    "brainwashed": true,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Jimmy Tran",
    "serialNumber": "24/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 55,
      "wisdom": 90,
      "speed": 35,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/VQmYf0b.png"
  },
  {
    "id": "AU-33/200",
    "displayName": "Ambolx",
    "name": "Ambolx",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Elementalist Muge",
    "ability": "Expend :water:Water: Infect target Creature.",
    "flavorText": "Ambolx had his eyes set on a mysterious Danian project northwest of Mount Pillar, when he suddenly was moved to the Citadel Grounds.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Reggie Butler",
    "serialNumber": "33/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 50,
      "wisdom": 90,
      "speed": 50,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/fx3zLhX.png"
  },
  {
    "id": "AU-34/200",
    "displayName": "Gareep",
    "name": "Gareep",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Muge",
    "ability": ":danianmugic:: Activate Hive.\r\nThe first time a Creature you control is put into your general discard pile each turn, put a Mugic counter on Gareep.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Anthony Washington",
    "serialNumber": "34/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 60,
      "wisdom": 80,
      "speed": 40,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Z7bSZEo.png"
  },
  {
    "id": "AU-35/200",
    "displayName": "Ghundac",
    "name": "Ghundac",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Squadleader Scout",
    "ability": "Hive: Ghundac has \"Range\" and \"Swift 3.\"",
    "flavorText": "Ghundac is one of Oipoint's officers and was assigned as Tharc's personal guard during the translation of the Cothica tablet.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "35/200",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 50,
      "wisdom": 50,
      "speed": 90,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/g9E41ja.jpeg"
  },
  {
    "id": "AU-36/200",
    "displayName": "Hiadrom, Rock Ripper",
    "name": "Hiadrom",
    "subname": "Rock Ripper",
    "set": "au",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor Warrior",
    "ability": "Expend :earth:Earth: Hiadrom gains 20 Energy.",
    "flavorText": "The minerals and metals contained in the ore of the Citadel Grounds beckoned Hiadrom to them, and left the excavation of a new Danian home for another day.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Reggie Butler",
    "serialNumber": "36/200",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 70,
      "wisdom": 60,
      "speed": 40,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/caoxb1k.png"
  },
  {
    "id": "AU-37/200",
    "displayName": "Ketun",
    "name": "Ketun",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Mandiblor Elementalist Warrior",
    "ability": "Elemental Attacks deal 5 less damage to Ketun.",
    "flavorText": "He has been sent far from home to defend the Danian scholars and Muges who visit the Citadel of the Elements.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Reggie Butler",
    "serialNumber": "37/200",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 70,
      "wisdom": 90,
      "speed": 65,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/lDpWlQD.png"
  },
  {
    "id": "AU-38/200",
    "displayName": "Lore, High Muge of the Hive",
    "name": "Lore",
    "subname": "High Muge of the Hive",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "danian",
    "subtype": "Muge",
    "ability": "Lore can play Mugic Cards in your general discard pile as if they were in your hand. Mugic Cards played in this way are removed from the game when they leave the burst.",
    "flavorText": "Burdened with tasks that would break others, Lore is never fazed by a challenge.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent, Reggie Butler",
    "serialNumber": "38/200",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 40,
      "wisdom": 100,
      "speed": 40,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/p4rGSze.png"
  },
  {
    "id": "AU-S13/26",
    "displayName": "Makromil",
    "name": "Makromil",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Warrior",
    "ability": "Makromil has an additional 5 Energy for each other Danian Creature you control.\r\nMakromil has an additional 5 Energy for each other Past Creature you control.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Reggie Butler",
    "serialNumber": "S13/26",
    "isPast": true,
    "stats": {
      "courage": 75,
      "power": 35,
      "wisdom": 45,
      "speed": 80,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/s6Iixpf.png"
  },
  {
    "id": "AU-39/200",
    "displayName": "Mhein",
    "name": "Mhein",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor Warrior",
    "ability": "Mhein has an additional 5 Energy for each Creature Card in all general discard piles.",
    "flavorText": "\"Let the determination of the defeated empower the standing to do right for one and for all.\" — Inscription on the Danian Hive Gallery",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Bob Rivard",
    "serialNumber": "39/200",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 70,
      "wisdom": 50,
      "speed": 40,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/Rge7OC3.png"
  },
  {
    "id": "AU-40/200",
    "displayName": "Nimmei, Expedition Overseer",
    "name": "Nimmei",
    "subname": "Expedition Overseer",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "danian",
    "subtype": "Noble Warrior",
    "ability": "When Nimmei takes attack damage, it gains all Elemental Types that attack had. When Nimmei gains an Elemental Type this way, it gains \"Element 5\" in the corresponding Elemental Type.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Bob Rivard",
    "serialNumber": "40/200",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 60,
      "wisdom": 80,
      "speed": 40,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Q3ejBdi.png"
  },
  {
    "id": "AU-41/200",
    "displayName": "Nom, Servant of Earth",
    "name": "Nom",
    "subname": "Servant of Earth",
    "set": "au",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Elementalist",
    "ability": ":danianmugic:: Target Creature gains :earth:Earth.",
    "flavorText": "\"Lore, let me guide and assist you with the Citadel exploration, and serve as a reminder that the Tree of Life has its roots in the elemental earth.\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "41/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 40,
      "wisdom": 70,
      "speed": 40,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/HqUNAuE.png"
  },
  {
    "id": "AU-42/200",
    "displayName": "Nunk'worn, Assimilated",
    "name": "Nunk'worn",
    "subname": "Assimilated",
    "set": "au",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Fluidmorpher",
    "ability": "Fluidmorph\r\nWhen combat ends, remove all Mugic counters from Nunk'worn.",
    "flavorText": "\"Parasites subjugate giants, crumble mountains and make servants of masters.\" — Infectionist motto",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "42/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 70,
      "wisdom": 80,
      "speed": 50,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/hsF4Nli.png"
  },
  {
    "id": "AU-43/200",
    "displayName": "Odu-Bathax, Reservoir Reclaimer",
    "name": "Odu-Bathax",
    "subname": "Reservoir Reclaimer",
    "set": "au",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Battlemaster Warrior",
    "ability": ":earth:Earth 5\r\nExpend :earth:Earth: Odu-Bathax gains \"Outperform :courage:Courage 5.\"",
    "flavorText": "Odu-Bathax never looks for trouble, but he always seems to find it.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Chris FIsher",
    "serialNumber": "43/200",
    "isPast": false,
    "stats": {
      "courage": 100,
      "power": 60,
      "wisdom": 40,
      "speed": 40,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/kZhAVuf.png"
  },
  {
    "id": "AU-44/200",
    "displayName": "Orbaat",
    "name": "Orbaat",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Muge",
    "ability": "If Orbaat is in your general discard pile, if you would reveal a new active Location, instead look at the top two cards of your Location Deck and choose one. It becomes the new active Location.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "44/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 45,
      "wisdom": 70,
      "speed": 35,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/ZVlTUvl.png"
  },
  {
    "id": "AU-45/200",
    "displayName": "Tarin",
    "name": "Tarin",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Mandiblor Scout",
    "ability": "Your other Creatures with :earth:Earth have an additional 10 Energy.",
    "flavorText": "Even though they are the least respected, Danian society would crumble in days without the hard-working Mandiblors.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Robert Dizon, Stone Perales",
    "serialNumber": "45/200",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 50,
      "wisdom": 45,
      "speed": 50,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/lmUWIt1.png"
  },
  {
    "id": "AU-46/200",
    "displayName": "Tharc, Tablet Translator",
    "name": "Tharc",
    "subname": "Tablet Translator",
    "set": "au",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Noble Muge",
    "ability": ":danianmugic:: Target Creature gains 50 :courage:Courage. If that Creature has :earth:Earth, it gains an additional 50 :courage:Courage.",
    "flavorText": "\"It pains me to admit that we could not have translated the tablet without the bugs' help.\" — Prince Mudeenu",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Bob Rivard",
    "serialNumber": "46/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 40,
      "wisdom": 90,
      "speed": 40,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/KUjcIWy.png"
  },
  {
    "id": "AU-47/200",
    "displayName": "Valban",
    "name": "Valban",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Warrior Elementalist",
    "ability": "At the beginning of combat, Valban gains all Elemental Types Infected Creatures have.",
    "flavorText": "Parasites feed off the strength of their host.\r\n",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Reggie Butler",
    "serialNumber": "47/200",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 50,
      "wisdom": 75,
      "speed": 50,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Jluh5RD.png"
  },
  {
    "id": "AU-48/200",
    "displayName": "Yondaf, Symbiotic Infector",
    "name": "Yondaf",
    "subname": "Symbiotic Infector",
    "set": "au",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Controller",
    "ability": "At the beginning of each turn, if Yondaf is Uninfected, Infect it.\r\nUninfect 3 Creatures: Deal 10 damage to target Creature.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Reggie Butler",
    "serialNumber": "48/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 45,
      "wisdom": 75,
      "speed": 40,
      "energy": 55,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/dif9zMW.png"
  },
  {
    "id": "FAS-26/100",
    "displayName": "Aszil, the Young Queen",
    "name": "Aszil",
    "subname": "the Young Queen",
    "set": "fas",
    "rarity": "ultra rare",
    "tribe": "danian",
    "subtype": "Noble",
    "ability": "At the beginning of combat, Danian Creatures you control gain :earth:Earth.\r\nHive: Mandiblor Creatures you control have \":earth:Earth 5.\"",
    "flavorText": "Queen of the Danians. Ruler of the Hive. Fate of Perim.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Stone Perales",
    "serialNumber": "26/100",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 40,
      "wisdom": 95,
      "speed": 45,
      "energy": 65,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/QyUCmdc.png"
  },
  {
    "id": "FAS-13/100",
    "displayName": "Riggan",
    "name": "Riggan",
    "subname": "",
    "set": "fas",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor Muge",
    "ability": "Expend :earth:Earth while engaged: The active player reveals a new active Location.",
    "flavorText": "As the first through the Tremor Gate, he was the first to learn its secrets.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Jimmy Tran",
    "serialNumber": "13/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 50,
      "wisdom": 75,
      "speed": 45,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/cAfGlhQ.png"
  },
  {
    "id": "FAS-24/100",
    "displayName": "Tassanil, High Elementalist",
    "name": "Tassanil",
    "subname": "High Elementalist",
    "set": "fas",
    "rarity": "super rare",
    "tribe": "danian",
    "subtype": "Noble Elementalist",
    "ability": "Expend any Elemental Type: Target Danian Creature gains the expended Elemental Type. Use this ability only once per turn.",
    "flavorText": "\"Challenge me!? That's like challenging nature itself!\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Axer",
    "serialNumber": "24/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 50,
      "wisdom": 80,
      "speed": 50,
      "energy": 35,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/hgmpdTg.png"
  },
  {
    "id": "FAS-20/100",
    "displayName": "Wamma, Flame Guard",
    "name": "Wamma",
    "subname": "Flame Guard",
    "set": "fas",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "Defender: :fire:Fire.\r\nDefender: :earth:Earth.",
    "flavorText": "When assigned a task, Wamma feels obligated to do a good job... at least for an hour.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Bob Rivard",
    "serialNumber": "20/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 75,
      "wisdom": 50,
      "speed": 35,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ycYvAcn.png"
  },
  {
    "id": "OP-OP1-7/20",
    "displayName": "Aimukk",
    "name": "Aimukk",
    "subname": "",
    "set": "op",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "",
    "flavorText": "What Aimukk lacks in strength he more than makes up for in willpower.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent ",
    "serialNumber": "OP1-7/20",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 60,
      "wisdom": 30,
      "speed": 40,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/2tHyIzF.png"
  },
  {
    "id": "OP-OP1-8/20",
    "displayName": "Nakal",
    "name": "Nakal",
    "subname": "",
    "set": "op",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": "",
    "flavorText": "Maintaining the crumbling walls of Mount Pillar is the most important - and most thankless - job of the Mandiblors.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "OP1-8/20",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 60,
      "wisdom": 40,
      "speed": 65,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/bT8V0t0.png"
  },
  {
    "id": "OP-LR05/10",
    "displayName": "Nukasai",
    "name": "Nukasai",
    "subname": "",
    "set": "op",
    "rarity": "rare",
    "tribe": "danian",
    "subtype": "Battlemaster Minion",
    "ability": ":danianmugic:: Uninfect all opposing Creatures. For each Creature Uninfected this way, Infect an Uninfected Creature you control.",
    "flavorText": "",
    "brainwashedText": "Uninfect all Creatures you control. For each Creature Uninfected this way, Infect an opposing Uninfected Creature.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, David Curiel",
    "serialNumber": "LR05/10",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 55,
      "wisdom": 70,
      "speed": 45,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ufR3iDe.png"
  },
  {
    "id": "OP-LR06/10",
    "displayName": "Gazarbash, Infecting Terraformer",
    "name": "Gazarbash",
    "subname": "Infecting Terraformer",
    "set": "op",
    "rarity": "uncommon",
    "tribe": "danian",
    "subtype": "Squadleader",
    "ability": "Uninfect three Infected Creatures: Reveal a new active Location.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, David Curiel",
    "serialNumber": "LR06/10",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 45,
      "wisdom": 55,
      "speed": 55,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/CMjkc2T.png"
  },
  {
    "id": "OP-gvw4rils",
    "displayName": "Tarteme",
    "name": "Tarteme",
    "subname": "",
    "set": "op",
    "rarity": "common",
    "tribe": "danian",
    "subtype": "Mandiblor",
    "ability": ":air:Air 5.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 75,
      "wisdom": 45,
      "speed": 50,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/GgfCYju.png"
  },
  {
    "id": "DOP-P-018",
    "displayName": "Kapalor",
    "name": "Kapalor",
    "subname": "",
    "set": "dop",
    "rarity": "promo",
    "tribe": "danian",
    "subtype": "Mandiblor Warrior",
    "ability": "Kapalor has an additional 5 Energy for each Mandiblor you control and each Infected Creature in play.\r\nIf Kapalor is unequipped, it has an additional 10 Energy.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "P-018",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 85,
      "wisdom": 50,
      "speed": 40,
      "energy": 40,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/uXbRgYV.png"
  },
  {
    "id": "AU-S01/26",
    "displayName": "Cromaxx",
    "name": "Cromaxx",
    "subname": "",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "tribeless",
    "subtype": "Warrior",
    "ability": "Damage dealt to Cromaxx by Mugic is reduced to 0.\r\nCromaxx's Energy cannot be reduced by Mugic.\r\n(Cromaxx can still take damage and have its Energy reduced by triggered abilities created by Mugic.)",
    "flavorText": "Cromaxx and Maxxor: different branches, same tree.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres. Emilio Lopez",
    "serialNumber": "S01/26",
    "isPast": true,
    "stats": {
      "courage": 100,
      "power": 70,
      "wisdom": 30,
      "speed": 60,
      "energy": 75,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/zGRyJiu.png"
  },
  {
    "id": "AU-S02/26",
    "displayName": "Proboscar",
    "name": "Proboscar",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "tribe": "tribeless",
    "subtype": "Beast",
    "ability": "Proboscar can move into any unoccupied space as if it were adjacent.\r\nIf Proboscar would move into an opposing Creature's space, it relocates that opposing Creature into Proboscar's space instead.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Reggie Butler",
    "serialNumber": "S02/26",
    "isPast": true,
    "stats": {
      "courage": 60,
      "power": 75,
      "wisdom": 35,
      "speed": 95,
      "energy": 70,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/3R9aQfi.png"
  },
  {
    "id": "AU-S03/26",
    "displayName": "Smildon",
    "name": "Smildon",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "tribe": "tribeless",
    "subtype": "Warrior Beast",
    "ability": "Defender: :earth:Earth \r\n:genericmugic:: The active Location loses all abilities.",
    "flavorText": "Though Smildon faced many worthy foes, none was as deadly as \"The Blight!\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Emilio Lopez",
    "serialNumber": "S03/26",
    "isPast": true,
    "stats": {
      "courage": 70,
      "power": 100,
      "wisdom": 45,
      "speed": 70,
      "energy": 65,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/QLrSAjg.png"
  },
  {
    "id": "AU-S04/26",
    "displayName": "Ursis",
    "name": "Ursis",
    "subname": "",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "tribeless",
    "subtype": "Warrior Muge",
    "ability": "",
    "flavorText": "Though Ursis appears ferocious, in reality, he is much fiercer than you can imagine.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, Emilio Lopez",
    "serialNumber": "S04/26",
    "isPast": true,
    "stats": {
      "courage": 70,
      "power": 95,
      "wisdom": 55,
      "speed": 55,
      "energy": 85,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/dEpaOqj.png"
  },
  {
    "id": "BTD-57/222",
    "displayName": "Ebena'bakku",
    "name": "Ebena'bakku",
    "subname": "",
    "set": "btd",
    "rarity": "ultra rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "If your engaged Creature has more Mugic counters than the opposing engaged Creature, your opponent must play Attack Cards at random.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Keron Grant, Reggie Butler",
    "serialNumber": "57/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 60,
      "speed": 60,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/46Ky4pg.png"
  },
  {
    "id": "BTD-58/222",
    "displayName": "Erak'tabb",
    "name": "Erak'tabb",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Attacks played by Creatures you control have \"Challenge :wisdom:Wisdom 50: Deal 10 damage.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Hotshots VFX",
    "serialNumber": "58/222",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 65,
      "wisdom": 95,
      "speed": 35,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/NciDcVY.png"
  },
  {
    "id": "BTD-59/222",
    "displayName": "Gan'trak",
    "name": "Gan'trak",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Attacks played by Creatures you control reduce the opposing engaged Creature's Disciplines by an amount equal to the damage they would deal instead of dealing damage.\r\nIf a Creature has 0 in all Disciplines, destroy it.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Hotshots VFX",
    "serialNumber": "59/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 60,
      "speed": 60,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/gcofpFc.png"
  },
  {
    "id": "BTD-60/222",
    "displayName": "Ihun'kalin",
    "name": "Ihun'kalin",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard two Mugic Cards: Destroy target engaged Creature with 0 :speed:Speed.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "60/222",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 70,
      "wisdom": 50,
      "speed": 95,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/7eLsVgU.png"
  },
  {
    "id": "BTD-61/222",
    "displayName": "Klar'nok",
    "name": "Klar'nok",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard a Mugic Card: Target Elemental Attack deals 15 less damage.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Keron Grant, Hotshots VFX",
    "serialNumber": "61/222",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 50,
      "wisdom": 65,
      "speed": 90,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/bkCJ9KQ.png"
  },
  {
    "id": "BTD-62/222",
    "displayName": "Milla'iin",
    "name": "Milla'iin",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard two Mugic Cards: Destroy target engaged Creature with 0 :power:Power.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Hotshots VFX",
    "serialNumber": "62/222",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 95,
      "wisdom": 75,
      "speed": 40,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/WwX6kJi.png"
  },
  {
    "id": "BTD-63/222",
    "displayName": "Neth'uar",
    "name": "Neth'uar",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Attacks played by Creatures you control have \"Challenge :courage:Courage 50: Deal 10 damage.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Keron Grant, David Curiel",
    "serialNumber": "63/222",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 65,
      "wisdom": 55,
      "speed": 75,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/OfGb7OL.png"
  },
  {
    "id": "BTD-64/222",
    "displayName": "Rath'tab",
    "name": "Rath'tab",
    "subname": "",
    "set": "btd",
    "rarity": "ultra rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard a Mugic Card: Remove all Mugic counters on target engaged Creature.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Hotshots VFX",
    "serialNumber": "64/222",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 30,
      "wisdom": 110,
      "speed": 50,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/NZ6DSmn.png"
  },
  {
    "id": "BTD-65/222",
    "displayName": "Ritzu'dag",
    "name": "Ritzu'dag",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "At the beginning of combat, your engaged Creature gains 50 to its lowest Discipline.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Hotshots VFX",
    "serialNumber": "65/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 60,
      "speed": 60,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/mFeTdig.png"
  },
  {
    "id": "BTD-66/222",
    "displayName": "Xis'torq",
    "name": "Xis'torq",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Creatures you control have \"Elementproof all Elemental Types 10.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Keron Grant, Hotshots VFX",
    "serialNumber": "66/222",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 60,
      "wisdom": 80,
      "speed": 60,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/b0iPClD.png"
  },
  {
    "id": "ROTO-29/100",
    "displayName": "Aa'une the Oligarch, Projection",
    "name": "Aa'une the Oligarch",
    "subname": "Projection",
    "set": "roto",
    "rarity": "ultra rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Aa'une the Oligarch begins the game and comes into play with this side face-up.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Liz Artinian",
    "serialNumber": "29/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 60,
      "speed": 60,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/S2olBfa.png"
  },
  {
    "id": "ROTO-29/100",
    "displayName": "Aa'une the Oligarch, Avatar",
    "name": "Aa'une the Oligarch",
    "subname": "Avatar",
    "set": "roto",
    "rarity": "ultra rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Outperform all Disciplines 20.\r\nDiscard a Mugic Card: Your opponent sacrifices a Creature.",
    "flavorText": "The source of all nightmares is here. The end of Perim is now.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Chris Fisher",
    "serialNumber": "29/100",
    "isPast": false,
    "stats": {
      "courage": 210,
      "power": 210,
      "wisdom": 210,
      "speed": 210,
      "energy": 105,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/KMFIyV7.png"
  },
  {
    "id": "ROTO-30/100",
    "displayName": "Aer'dak",
    "name": "Aer'dak",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher",
    "ability": "Fluidmorph.\r\n:marrillianmugic:: Target Creature loses Range.\r\n:marrillianmugic::marrillianmugic::marrillianmugic:: Deal 20 damage to target Creature with Swift.\r\n:marrillianmugic10:: Destroy all opposing Creatures with Range.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, Etienne St.Laurent",
    "serialNumber": "30/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 70,
      "wisdom": 60,
      "speed": 75,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/puoQdFf.png"
  },
  {
    "id": "ROTO-31/100",
    "displayName": "Anger'keem",
    "name": "Anger'keem",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher",
    "ability": "Fluidmorph.\r\n:marrillianmugic::marrillianmugic::marrillianmugic::marrillianmugic:: Target attack deals 25 damage.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Robert Dizon",
    "serialNumber": "31/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 65,
      "wisdom": 75,
      "speed": 45,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/7B9QN6b.png"
  },
  {
    "id": "ROTO-32/100",
    "displayName": "Bahrakatan, The Coralsmith",
    "name": "Bahrakatan",
    "subname": "The Coralsmith",
    "set": "roto",
    "rarity": "ultra rare",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall",
    "ability": "Battlegear cannot be destroyed. (Battlegear can still be sacrificed or flipped face-down.)",
    "flavorText": "Once Bahrakatan forged the shards, Aa'une knew that success was guaranteed.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "32/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 85,
      "wisdom": 70,
      "speed": 60,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/K0u9jYC.png"
  },
  {
    "id": "ROTO-33/100",
    "displayName": "Dror'niq",
    "name": "Dror'niq",
    "subname": "",
    "set": "roto",
    "rarity": "uncommon",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher",
    "ability": "Fluidmorph.\r\n:marrillianmugic:: When Dror'niq is next dealt attack damage this turn, deal 10 damage to the Creature which played that attack.\r\n:marrillianmugic::marrillianmugic::marrillianmugic::marrillianmugic:: Whenever target Creature is dealt attack damage this turn, deal 10 damage to the Creature which played that attack.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Robert Dizon",
    "serialNumber": "33/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 60,
      "wisdom": 40,
      "speed": 30,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/IGXODnV.png"
  },
  {
    "id": "ROTO-34/100",
    "displayName": "Fal'makin",
    "name": "Fal'makin",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard two Mugic Cards: Destroy target engaged Creature with 0 :wisdom:Wisdom.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Keron Grant, Etienne St.Laurent",
    "serialNumber": "34/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 65,
      "wisdom": 100,
      "speed": 70,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/kKIaC8N.png"
  },
  {
    "id": "ROTO-35/100",
    "displayName": "Fla'gamp",
    "name": "Fla'gamp",
    "subname": "",
    "set": "roto",
    "rarity": "super rare",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher",
    "ability": "Fluidmorph \r\n:marrillianmugic:: Look at the top card of target player's Location Deck.\r\n:marrillianmugic:: Put the top card of target player's Location Deck on the bottom of that deck.\r\n:marrillianmugic::marrillianmugic:: Your opponent reveals a new active Location.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, David Curiel",
    "serialNumber": "35/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 35,
      "wisdom": 55,
      "speed": 65,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/Sd8owLe.png"
  },
  {
    "id": "ROTO-36/100",
    "displayName": "Ikub'ra",
    "name": "Ikub'ra",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall",
    "ability": "Intimidate: :wisdom:Wisdom 30.\r\nFireproof 25.\r\nIkub'ra deals an additional 5 attack damage to OverWorld Creatures.",
    "flavorText": "\"So there IS someone who despises OverWorlders more than me!\" — Chaor",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, David Curiel",
    "serialNumber": "36/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 50,
      "wisdom": 100,
      "speed": 60,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/3DA1Xjv.png"
  },
  {
    "id": "ROTO-37/100",
    "displayName": "Jus'hebban",
    "name": "Jus'hebban",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Attacks played by Creatures you control have \"Challenge :speed:Speed 50: Deal 10 damage.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Keron Grant, Axer",
    "serialNumber": "37/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 35,
      "wisdom": 100,
      "speed": 105,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/sps9qDs.png"
  },
  {
    "id": "ROTO-38/100",
    "displayName": "Lam'inkal",
    "name": "Lam'inkal",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher Scout",
    "ability": "Fluidmorph.\r\nSwift 2.",
    "flavorText": "Learn to wield water as a weapon and you'll find that you are never unarmed.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, Etienne St.Laurent",
    "serialNumber": "38/100",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 60,
      "wisdom": 65,
      "speed": 35,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/uceWUuh.png"
  },
  {
    "id": "ROTO-39/100",
    "displayName": "Mik'banin",
    "name": "Mik'banin",
    "subname": "",
    "set": "roto",
    "rarity": "uncommon",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall ",
    "ability": "Intimidate: :power:Power 30.\r\nAirproof 25.\r\nMik'banin deals an additional 5 attack damage to UnderWorld Creatures.",
    "flavorText": "The strategy was obvious but efficient: invade, subjugate, annihilate.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, David Curiel",
    "serialNumber": "39/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 100,
      "wisdom": 60,
      "speed": 50,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/5b5WM3n.png"
  },
  {
    "id": "ROTO-40/100",
    "displayName": "Mock'adyn",
    "name": "Mock'adyn",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher Muge",
    "ability": "Fluidmorph\r\n:marrillianmugic::marrillianmugic:: Heal 5 damage to target Creature.\r\n:marrillianmugic::marrillianmugic::marrillianmugic::marrillianmugic:: Heal 25 damage to all Creatures you control.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "40/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 50,
      "wisdom": 60,
      "speed": 45,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/5mQIGBR.png"
  },
  {
    "id": "ROTO-41/100",
    "displayName": "Nunk'worn",
    "name": "Nunk'worn",
    "subname": "",
    "set": "roto",
    "rarity": "super rare",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher Warrior",
    "ability": "Fluidmorph.\r\nAttacks played by Nunk'worn also count as :fire:Fire and :water:Water attacks.\r\nWhen Nunk'worn is destroyed and had exactly three Mugic counters on it, you can return it to play to any unoccupied space on your side of the Battleboard.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, David Curiel",
    "serialNumber": "41/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 80,
      "wisdom": 80,
      "speed": 55,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/VFiXbU9.png"
  },
  {
    "id": "ROTO-42/100",
    "displayName": "Phelphor, Of the Deep",
    "name": "Phelphor",
    "subname": "Of the Deep",
    "set": "roto",
    "rarity": "uncommon",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher Scout",
    "ability": "Fluidmorph.\r\n:marrillianmugic:: Relocate target opposing unengaged Creature to any unoccupied space on the Battleboard adjacent to it.\r\n:marrillianmugic::marrillianmugic::marrillianmugic::marrillianmugic:: Creatures lose Swift and cannot move or relocate into unoccupied spaces.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "42/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 50,
      "wisdom": 70,
      "speed": 65,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/8HECw29.png"
  },
  {
    "id": "ROTO-43/100",
    "displayName": "Ri'oha",
    "name": "Ri'oha",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher",
    "ability": "Fluidmorph.\r\n:marrillianmugic::marrillianmugic:: Swap all Battlegear equipped to two target Kha'rall Creatures controlled by the same player.\r\n:marrillianmugic::marrillianmugic::marrillianmugic::marrillianmugic:: Return target Shard Battlegear Card in your general discard pile to play equipped to an unequipped Kha'rall Creature you control.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "43/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 70,
      "wisdom": 55,
      "speed": 50,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/CfJLYmr.png"
  },
  {
    "id": "ROTO-44/100",
    "displayName": "Rol'doi",
    "name": "Rol'doi",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall Warrior",
    "ability": "Intimidate: :courage:Courage 30.\r\nWaterproof 25.\r\nRol'doi deals an additional 5 attack damage to Danian Creatures.",
    "flavorText": "As the waves crash in his wake, his claws slash through you!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Robert Dizon",
    "serialNumber": "44/100",
    "isPast": false,
    "stats": {
      "courage": 100,
      "power": 60,
      "wisdom": 50,
      "speed": 50,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/l8cz8SU.png"
  },
  {
    "id": "ROTO-45/100",
    "displayName": "Siril'ean, The Songthief",
    "name": "Siril'ean",
    "subname": "The Songthief",
    "set": "roto",
    "rarity": "ultra rare",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher Muge",
    "ability": "Fluidmorph.\r\n:marrillianmugic::marrillianmugic::marrillianmugic::marrillianmugic:: Negate target non-M'arrillian Mugic.\r\nx5:marrillianmugic:: Play a Mugic Card of any tribe or affiliation from the opposing general discard pile without paying its Mugic cost. Mugic Cards played in this way are removed from the game when they leave the burst.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Chris Fisher",
    "serialNumber": "45/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 30,
      "wisdom": 85,
      "speed": 30,
      "energy": 30,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/GWuMQQ9.png"
  },
  {
    "id": "ROTO-46/100",
    "displayName": "Vitar'zu",
    "name": "Vitar'zu",
    "subname": "",
    "set": "roto",
    "rarity": "uncommon",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall",
    "ability": "Intimidate: :speed:Speed 30.\r\nEarthproof 25.\r\nVitar'zu deals an additional 5 attack damage to Mipedian Creatures.",
    "flavorText": "The Stalkers remained invisible. Now they were the ones being stalked.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "46/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 50,
      "wisdom": 50,
      "speed": 100,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/DQMJvBq.png"
  },
  {
    "id": "TOTT-29/100",
    "displayName": "Aval'par",
    "name": "Aval'par",
    "subname": "",
    "set": "tott",
    "rarity": "super rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard a Mugic Card: Target Chieftain Creature gains \"Untargetable.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent, Chris Fisher",
    "serialNumber": "29/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 80,
      "wisdom": 50,
      "speed": 75,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/dlGXNOW.png"
  },
  {
    "id": "TOTT-30/100",
    "displayName": "Dreg'ora",
    "name": "Dreg'ora",
    "subname": "",
    "set": "tott",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall Warrior",
    "ability": "Creatures engaged with Dreg'ora have 10 less Energy for each Discipline they have below 30.",
    "flavorText": "The Kha'rall could care less about the subtleties of brainwashing. Their way is much easier... and messier.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "30/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 75,
      "wisdom": 35,
      "speed": 45,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/CBZRXVu.png"
  },
  {
    "id": "TOTT-31/100",
    "displayName": "Emna'ool",
    "name": "Emna'ool",
    "subname": "",
    "set": "tott",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard two Mugic Cards: Destroy target engaged Creature with 0 :courage:Courage.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "31/100",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 80,
      "wisdom": 40,
      "speed": 55,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/AnAIfAm.png"
  },
  {
    "id": "TOTT-32/100",
    "displayName": "Gal'drad",
    "name": "Gal'drad",
    "subname": "",
    "set": "tott",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Attacks played by Creatures you control have \"Challenge :power:Power 50: Deal 10 damage.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Robert Dizon, Imaginary Friends Studios",
    "serialNumber": "32/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 95,
      "wisdom": 45,
      "speed": 50,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/X7NL8N6.png"
  },
  {
    "id": "TOTT-33/100",
    "displayName": "Ki'bro",
    "name": "Ki'bro",
    "subname": "",
    "set": "tott",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "When a Battlegear you control is flipped face-up, look at the top two cards of your Location Deck. Put one of them on top of that deck and the other on the bottom.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Robert Dizon, Imaginary Friends Studios",
    "serialNumber": "33/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 40,
      "wisdom": 60,
      "speed": 50,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/NotJx9C.png"
  },
  {
    "id": "TOTT-6/100",
    "displayName": "Part'soa",
    "name": "Part'soa",
    "subname": "",
    "set": "tott",
    "rarity": "uncommon",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher",
    "ability": "Fluidmorph\r\n:marrillianmugic::marrillianmugic:: Target Creature loses 20 to all Disciplines.",
    "flavorText": "As the water rises inch by inch, Part'soa knows that victory is one step closer.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "6/100",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 45,
      "wisdom": 90,
      "speed": 50,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/Vgej6Li.png"
  },
  {
    "id": "TOTT-7/100",
    "displayName": "Vix'ben",
    "name": "Vix'ben",
    "subname": "",
    "set": "tott",
    "rarity": "super rare",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher",
    "ability": "Fluidmorph.\r\nWhen a Mugic played by an opposing Creature, remove all Mugic counters from Vix'ben. If the Mugic's cost is less than the number of Mugic counters removed this way, negate that Mugic.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "7/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 50,
      "wisdom": 75,
      "speed": 45,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/n9EAmgF.png"
  },
  {
    "id": "FUN-33/100",
    "displayName": "Bo'aam",
    "name": "Bo'aam",
    "subname": "",
    "set": "fun",
    "rarity": "ultra rare",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall",
    "ability": "When Bo'aam becomes engaged, the opposing engaged Creature loses 5 Energy for each Elemental Type it does not have.",
    "flavorText": "Just make one mistake, a single slight error... and your life is done.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Bob Rivard",
    "serialNumber": "33/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 60,
      "wisdom": 95,
      "speed": 50,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/1dFnHD5.png"
  },
  {
    "id": "FUN-34/100",
    "displayName": "Em'swa",
    "name": "Em'swa",
    "subname": "",
    "set": "fun",
    "rarity": "uncommon",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher",
    "ability": "Fluidmorph.\r\n:marrillianmugic::marrillianmugic::marrillianmugic::marrillianmugic:: Target Creature loses an Elemental Type of your choice.",
    "flavorText": "No one is happier than Em'swa that the Tribes have teamed up. Maybe they'll finally prove to be a challenge.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "34/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 35,
      "wisdom": 80,
      "speed": 60,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/d1BdNA6.png"
  },
  {
    "id": "FUN-35/100",
    "displayName": "Gan'nim",
    "name": "Gan'nim",
    "subname": "",
    "set": "fun",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall",
    "ability": "When any Creature engaged with Gan'nim fails a Stat Check or Challenge on an attack it played, deal 10 damage to it.",
    "flavorText": "Gan'nim loves the squishy sounds he hears each time he steps on an enemy.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Reggie Butler",
    "serialNumber": "35/100",
    "isPast": false,
    "stats": {
      "courage": 100,
      "power": 100,
      "wisdom": 60,
      "speed": 25,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/x9hxHw9.png"
  },
  {
    "id": "FUN-36/100",
    "displayName": "Ghar'lag",
    "name": "Ghar'lag",
    "subname": "",
    "set": "fun",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard a Mugic Card: Opposing Creatures lose and cannot gain Range and Swift.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "36/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 45,
      "wisdom": 75,
      "speed": 85,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/vAZ8Hp1.png"
  },
  {
    "id": "FUN-15/100",
    "displayName": "Tir'baleen",
    "name": "Tir'baleen",
    "subname": "",
    "set": "fun",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Fluidmorpher",
    "ability": "Fluidmorph\r\n:marrillianmugic::marrillianmugic:: Target attack also counts as a :water:Water attack.\r\nx6:marrillianmugic:: Target attack deals 0 damage if it is a :water:Water attack.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "15/100",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 50,
      "wisdom": 95,
      "speed": 45,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/0ogs5nj.png"
  },
  {
    "id": "FUN-38/100",
    "displayName": "Wilt'dred",
    "name": "Wilt'dred",
    "subname": "",
    "set": "fun",
    "rarity": "uncommon",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard a Mugic Card: Target Minion Creature is treated as if its controller did not also control a Chieftain.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Keron Grant, Etienne St.Laurent",
    "serialNumber": "38/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 75,
      "wisdom": 80,
      "speed": 55,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/TG61Fm0.png"
  },
  {
    "id": "AU-65/200",
    "displayName": "Ast'imal",
    "name": "Ast'imal",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall",
    "ability": "Expend :water:Water: Target unengaged Creature swaps spaces on the Battleboard with another unengaged Creature of the same controller's choice.",
    "flavorText": "\"Hard questions require answers too. Hard answers require thought. Sometimes thought calls for motivation. It's name is Ast'imal\" — Fal'makin",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Axer",
    "serialNumber": "65/200",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 55,
      "wisdom": 80,
      "speed": 60,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/JXzPnys.png"
  },
  {
    "id": "AU-66/200",
    "displayName": "Fal'makin, AZAIA Inquisitor",
    "name": "Fal'makin",
    "subname": "AZAIA Inquisitor",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "When Fal'makin deals attack damage, Fal'makin can immediately play a Mugic Card of cost 2 or less without paying its Mugic cost.",
    "flavorText": "Very few expect us.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Axer",
    "serialNumber": "66/200",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 50,
      "wisdom": 100,
      "speed": 40,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/otDhtQd.png"
  },
  {
    "id": "AU-67/200",
    "displayName": "Ihun'kalin, Psionic Master",
    "name": "Ihun'kalin",
    "subname": "Psionic Master",
    "set": "au",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard a Mugic Card: Ihun'kalin deals 10 additional damage with its next attack this turn.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "67/200",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 55,
      "wisdom": 85,
      "speed": 90,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/UegqaZL.png"
  },
  {
    "id": "AU-68/200",
    "displayName": "Klik'ssi",
    "name": "Klik'ssi",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall",
    "ability": "If Klik'ssi is equipped with a Shard Battlegear, it has \":water:Water 5.\"",
    "flavorText": "\"The failure of Erak'tabb and Neth'uar means nothing except higher stakes.\" — Ihun'kalin",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Anthony Washington",
    "serialNumber": "68/200",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 90,
      "wisdom": 80,
      "speed": 60,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/IEgkOfz.png"
  },
  {
    "id": "AU-69/200",
    "displayName": "Milla'iin, Foothold Commander",
    "name": "Milla'iin",
    "subname": "Foothold Commander",
    "set": "au",
    "rarity": "super rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "At the beginning of your turn if all Creatures you control have no Mugic counters, return target Mugic Card from your general discard pile to your hand.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "69/200",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 90,
      "speed": 70,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/wHuoK0q.png"
  },
  {
    "id": "AU-70/200",
    "displayName": "Mock'adyn, Fluid Master",
    "name": "Mock'adyn",
    "subname": "Fluid Master",
    "set": "au",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Elementalist",
    "ability": "Expend :water:Water: Put a Mugic counter on Mock'adyn.",
    "flavorText": "With Aa'une's defeat, Mock'adyn has plans to become the new leader of the M'arrillians. Unfortunately for him, so do many others...",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw Bob rivard",
    "serialNumber": "70/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 75,
      "wisdom": 60,
      "speed": 60,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/cFQ4YTp.png"
  },
  {
    "id": "AU-71/200",
    "displayName": "Rath'tab, Mind Scryer",
    "name": "Rath'tab",
    "subname": "Mind Scryer",
    "set": "au",
    "rarity": "super rare",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard a Mugic Card: Target Creature with 0 in any Discipline loses an Elemental Type of your choice.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Anthony Washington",
    "serialNumber": "71/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 30,
      "wisdom": 100,
      "speed": 35,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/LTCTKG6.png"
  },
  {
    "id": "AU-72/200",
    "displayName": "Son'las",
    "name": "Son'las",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall Scout",
    "ability": "When Son'las becomes engaged, the opposing engaged Creature loses Invisibility and your opponent reveals their attack hand.",
    "flavorText": "\"Some can shade their eyes forever, and still see all.\" — Iflar",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Reggie Butler",
    "serialNumber": "72/200",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 55,
      "wisdom": 70,
      "speed": 80,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/yD5FuTY.png"
  },
  {
    "id": "AU-73/200",
    "displayName": "Thar'lyn, AZAIA Spy",
    "name": "Thar'lyn",
    "subname": "AZAIA Spy",
    "set": "au",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Elementalist",
    "ability": "Expend :water:Water while engaged: When Thar'lyn next deals attack damage this turn, the opposing engaged Creature loses X to all Disciplines, where X is the damage dealt.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Jimmy Tran",
    "serialNumber": "73/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 90,
      "wisdom": 70,
      "speed": 40,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/eOC0fZs.png"
  },
  {
    "id": "FAS-19/100",
    "displayName": "Ginar'rash, The Extinguisher",
    "name": "Ginar'rash",
    "subname": "The Extinguisher",
    "set": "fas",
    "rarity": "rare",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall",
    "ability": "Fireproof 20\r\nWhen Ginar'rash deals :water:Water attack damage to a Creature, that Creature loses :fire:Fire.",
    "flavorText": "\"Some say to fight fire with fire. My plan works much better, I assure you.\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Axer, Jimmy Tran",
    "serialNumber": "19/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 85,
      "wisdom": 80,
      "speed": 40,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/f1xmOeK.png"
  },
  {
    "id": "OP-LR09/10",
    "displayName": "Blak'drin",
    "name": "Blak'drin",
    "subname": "",
    "set": "op",
    "rarity": "super rare",
    "tribe": "m'arrillian",
    "subtype": "Kha'rall",
    "ability": ":air:Air or :water:Water attacks deal an additional 5 damage to Blak'drin.\r\nWhen Blak'drin is dealt :air:Air or :water:Water damage, deal 10 damage to the Creature which played that attack.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "LR09/10",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 75,
      "wisdom": 65,
      "speed": 80,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/MEHc8n8.png"
  },
  {
    "id": "OP-LR10/10",
    "displayName": "Nis'dabba",
    "name": "Nis'dabba",
    "subname": "",
    "set": "op",
    "rarity": "common",
    "tribe": "m'arrillian",
    "subtype": "Chieftain",
    "ability": "Discard a Mugic Card: Swap two Shard Battlegear equipped to two Kha'rall Creatures you control.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "LR10/10",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 45,
      "wisdom": 70,
      "speed": 70,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/8tsZ44F.png"
  },
  {
    "id": "DOP-72/232",
    "displayName": "Ario",
    "name": "Ario",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Royal Warrior",
    "ability": "Invisibility: Strike 15.",
    "flavorText": "Though not in his prime, Ario is always primed for battle.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "72/232",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 65,
      "wisdom": 35,
      "speed": 65,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/hkNzGqI.png"
  },
  {
    "id": "DOP-73/232",
    "displayName": "Biondu",
    "name": "Biondu",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Elite",
    "ability": "Invisibility: Strike 15.",
    "flavorText": "The Mipedian desert may be home, but Biondu covets the land beyond the sand.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Anthony Washington",
    "serialNumber": "73/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 50,
      "wisdom": 40,
      "speed": 45,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/RXJHjuy.png"
  },
  {
    "id": "DOP-74/232",
    "displayName": "Brathe",
    "name": "Brathe",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Elite",
    "ability": "Invisibility: Strike 15.",
    "flavorText": "Because invisible Mipedians cast no reflection, Brathe’s vanity is a dangerous thing.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, David Curiel",
    "serialNumber": "74/232",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 55,
      "wisdom": 75,
      "speed": 65,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/W3o3OWT.png"
  },
  {
    "id": "DOP-75/232",
    "displayName": "Malvadine",
    "name": "Malvadine",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Elite Warrior",
    "ability": "Invisibility: Strike 10.\r\nInvisibility: Surprise.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "75/232",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 85,
      "wisdom": 50,
      "speed": 65,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/I8lbhYn.png"
  },
  {
    "id": "DOP-76/232",
    "displayName": "Marquis Darini",
    "name": "Marquis Darini",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Royal",
    "ability": "Creatures you control with Invisibility deal an additional 5 damage with their first attack each combat.",
    "flavorText": "Proponent of peace but staunch defender of Mipedian sovereignty.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "76/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 50,
      "wisdom": 75,
      "speed": 50,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/HRQxZEy.png"
  },
  {
    "id": "DOP-77/232",
    "displayName": "Prince Mudeenu",
    "name": "Prince Mudeenu",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Royal",
    "ability": "Invisibility: Strike 20.",
    "flavorText": "Obsessed with controlling the Cothica, he will risk the freedom of the Mipedians to find it.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "77/232",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 45,
      "wisdom": 80,
      "speed": 40,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/LYxnvVN.png"
  },
  {
    "id": "DOP-78/232",
    "displayName": "Qwun",
    "name": "Qwun",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Scout",
    "ability": "Invisibility: Surprise.",
    "flavorText": "With Qwun’s blinding Speed, using his Invisibility is rarely necessary.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "78/232",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 50,
      "wisdom": 65,
      "speed": 100,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/vb3R9Mg.png"
  },
  {
    "id": "DOP-79/232",
    "displayName": "Shimmark",
    "name": "Shimmark",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Stalker",
    "ability": "Invisibility: Strike 10.",
    "flavorText": "Shimmark is like a footprint in the sand: quickly gone with the wind.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "79/232",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 60,
      "wisdom": 40,
      "speed": 80,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/eJ8Le6E.png"
  },
  {
    "id": "DOP-80/232",
    "displayName": "Siado",
    "name": "Siado",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Stalker",
    "ability": "Invisibility: Surprise.",
    "flavorText": "Scout, sentry, spy: Siado is a triple threat to every Mipedian enemy.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "80/232",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 55,
      "wisdom": 70,
      "speed": 65,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/VT2Xnm8.png"
  },
  {
    "id": "DOP-81/232",
    "displayName": "Sobtjek",
    "name": "Sobtjek",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Muge",
    "ability": ":mipedianmugic:, Sacrifice Sobtjek: Deal 25 damage to target Creature.",
    "flavorText": "Few Mipedians can outlast Sobtjek in a parfkew eating contest.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keith Conroy, Edwin Nebres, Anthony Washington",
    "serialNumber": "81/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 35,
      "wisdom": 75,
      "speed": 50,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/voltSPi.png"
  },
  {
    "id": "DOP-82/232",
    "displayName": "Tiaane",
    "name": "Tiaane",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Muge",
    "ability": ":mipedianmugic:, Sacrifice Tiaane: Deal 25 damage to target Creature.",
    "flavorText": "Tiaane has studied Mugic with Najarin himself, earning him respect throughout the OverWorld.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "82/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 50,
      "wisdom": 60,
      "speed": 30,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/JPf9d9p.png"
  },
  {
    "id": "DOP-83/232",
    "displayName": "Ubliqun",
    "name": "Ubliqun",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Stalker",
    "ability": ":mipedianmugic:: Ubliqun can move to any space on the Battleboard as if it were adjacent.",
    "flavorText": "When this warrior takes to the air, look out! But looking may do you no good, as you might see nothing …until it’s too late!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "serialNumber": "83/232",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 55,
      "wisdom": 70,
      "speed": 70,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/iwYIDmv.png"
  },
  {
    "id": "DOP-84/232",
    "displayName": "Uro",
    "name": "Uro",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Elementalist",
    "ability": "Invisibility: Strike 5.\r\nInvisibility: Surprise.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "84/232",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 70,
      "wisdom": 50,
      "speed": 70,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/7RzGpbR.png"
  },
  {
    "id": "DOP-85/232",
    "displayName": "Vinta",
    "name": "Vinta",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Stalker",
    "ability": "Invisibility: Strike 10",
    "flavorText": "Many trespassers have felt the breath of Vinta as they breached the Mipedim Oasis. But they have felt it too late.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "85/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 70,
      "wisdom": 45,
      "speed": 50,
      "energy": 40,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/pWZtAS3.png"
  },
  {
    "id": "DOP-86/232",
    "displayName": "Zhade",
    "name": "Zhade",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Stalker",
    "ability": "Invisibility: Surprise.",
    "flavorText": "Some lead. Some follow. Zhade is content just to hang around.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "86/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 70,
      "wisdom": 50,
      "speed": 70,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/I1gPfR5.png"
  },
  {
    "id": "ZOTH-31/100",
    "displayName": "Arkanin",
    "name": "Arkanin",
    "subname": "",
    "set": "zoth",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Muge",
    "ability": ":mipedianmugic:: Deal 5 damage to target Creature.\r\n:mipedianmugic:: Heal 10 damage to target Creature.\r\nArkanin can pay Mugic counters from other Muge Creatures you control to activate its abilities.",
    "flavorText": "Some Muges avoid fighting, but Arkanin jumps into the heat of battle.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keith Conroy, Anthony Washington",
    "serialNumber": "31/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 45,
      "wisdom": 80,
      "speed": 65,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/iQkhTnv.png"
  },
  {
    "id": "ZOTH-32/100",
    "displayName": "Dibanni",
    "name": "Dibanni",
    "subname": "",
    "set": "zoth",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Muge",
    "ability": ":mipedianmugic:: Put a Mugic counter on target adjacent Creature.",
    "flavorText": "\"I can only open the door to understanding the true mysteries of Mugic. I can force no one to walk through it.\" — Dibanni",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keith Conroy, Anthony Washington",
    "serialNumber": "32/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 45,
      "wisdom": 80,
      "speed": 65,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/GHvjhVj.png"
  },
  {
    "id": "ZOTH-33/100",
    "displayName": "Kolmo",
    "name": "Kolmo",
    "subname": "",
    "set": "zoth",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Elite",
    "ability": "Invisibility: Disarm.\r\nIf engaged with a Danian Noble Creature, Kolmo has \"Invisibility: Strike 20.\"\r\nRange.\r\nSwift 1.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "serialNumber": "33/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 65,
      "wisdom": 60,
      "speed": 50,
      "energy": 70,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/vWg53u0.png"
  },
  {
    "id": "ZOTH-34/100",
    "displayName": "Munnari",
    "name": "Munnari",
    "subname": "",
    "set": "zoth",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Stalker",
    "ability": "Invisibility: Disarm.",
    "flavorText": "As Tangath Toborn reached for his blade, his heart sank when he realized he only had his sheath at his side.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keith Conroy, Emilio Lopez",
    "serialNumber": "34/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 60,
      "wisdom": 60,
      "speed": 80,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/FwsfpsJ.png"
  },
  {
    "id": "ZOTH-35/100",
    "displayName": "Ribbian",
    "name": "Ribbian",
    "subname": "",
    "set": "zoth",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Scout",
    "ability": "Invisibility: Disarm.\r\n:air:Air 5.\r\nDamage dealt to a Creature by itself is increased by 5.",
    "flavorText": "Ribbian quickly learned that it's much easier to give orders than to take them.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "35/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 60,
      "wisdom": 50,
      "speed": 55,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/RpRF1sl.png"
  },
  {
    "id": "SS-21/100",
    "displayName": "Blazvatan, The Epic Warbeast",
    "name": "Blazvatan",
    "subname": "The Epic Warbeast",
    "set": "ss",
    "rarity": "ultra rare",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": ":air:Air 5.\r\n:earth:Earth 5.\r\nRecklessness 25.",
    "flavorText": "Conjuring is worthless without control.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "21/100",
    "isPast": false,
    "stats": {
      "courage": 160,
      "power": 85,
      "wisdom": 60,
      "speed": 160,
      "energy": 75,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/VxmUSjd.png"
  },
  {
    "id": "SS-22/100",
    "displayName": "Bylkian",
    "name": "Bylkian",
    "subname": "",
    "set": "ss",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Royal Conjuror",
    "ability": "Damage dealt to Warbeast Creatures you control by Recklessness is reduced by 10.\r\n:mipedianmugic:: Damage dealt to Warbeast Creatures you control by Recklessness is reduced by an additional 10.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez, Etienne St.Laurent",
    "serialNumber": "22/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 25,
      "wisdom": 60,
      "speed": 40,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/rXz6NWt.png"
  },
  {
    "id": "SS-23/100",
    "displayName": "Drimesse",
    "name": "Drimesse",
    "subname": "",
    "set": "ss",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Conjuror",
    "ability": "Damage dealt to Warbeast Creatures you control by Recklessness is reduced by 10.\r\nIf Drimesse has no Mugic counters on it, sacrifice it.",
    "flavorText": "\"Stop this madness! Haven't you learned from your mistakes?!\" — Sobtjek",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez, Etienne St.Laurent",
    "serialNumber": "23/100",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 40,
      "wisdom": 70,
      "speed": 50,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/N9KxbqE.png"
  },
  {
    "id": "SS-24/100",
    "displayName": "Enre-hep",
    "name": "Enre-hep",
    "subname": "",
    "set": "ss",
    "rarity": "ultra rare",
    "tribe": "mipedian",
    "subtype": "Muge",
    "ability": "When a Creature you control is put into your general discard pile, put a Mugic counter on Enre-hep for each Mugic counter on that Creature.\r\n:mipedianmugic:: Target Creature gains \"Recklessness 5.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez, Etienne St.Laurent",
    "serialNumber": "24/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 30,
      "wisdom": 90,
      "speed": 60,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/89FMDzi.png"
  },
  {
    "id": "SS-25/100",
    "displayName": "Ere",
    "name": "Ere",
    "subname": "",
    "set": "ss",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": "Range.\r\nSwift 4.\r\nRecklessness 10.",
    "flavorText": "Born of sand and storm, Ere can traverse the Mipedim Desert in mere seconds.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "25/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 85,
      "wisdom": 30,
      "speed": 110,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/M47BCRX.png"
  },
  {
    "id": "SS-26/100",
    "displayName": "Fivarth",
    "name": "Fivarth",
    "subname": "",
    "set": "ss",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Conjuror",
    "ability": "Damage dealt to Warbeast Creatures you control by Recklessness is reduced by 5.\r\nUntargetable.",
    "flavorText": "\"Our so-called 'leaders' have failed us. Now we must control our own destiny!\" — Fivarth",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "26/100",
    "isPast": false,
    "stats": {
      "courage": 25,
      "power": 25,
      "wisdom": 25,
      "speed": 25,
      "energy": 20,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/woqB9KQ.png"
  },
  {
    "id": "SS-27/100",
    "displayName": "Gnarlus",
    "name": "Gnarlus",
    "subname": "",
    "set": "ss",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Warrior",
    "ability": "Damage dealt to Gnarlus by Mugic is reduced to 0.\r\n:mipedianmugic::mipedianmugic:: Damage dealt to target Creature by Mugic is reduced to 0.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "27/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 40,
      "wisdom": 40,
      "speed": 75,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/PgmPQnG.png"
  },
  {
    "id": "SS-28/100",
    "displayName": "Lanker",
    "name": "Lanker",
    "subname": "",
    "set": "ss",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Warrior",
    "ability": "Lanker loses 5 Energy: Choose :courage:Courage, :power:Power, :wisdom:Wisdom, or :speed:Speed. Target Creature gains 15 in the chosen Discipline.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, David Curiel",
    "serialNumber": "28/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 60,
      "wisdom": 100,
      "speed": 40,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/rgUHKwW.png"
  },
  {
    "id": "SS-29/100",
    "displayName": "Melke",
    "name": "Melke",
    "subname": "",
    "set": "ss",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Stalker",
    "ability": "Invisibility: Strike 10.\r\nIf a Mirage Location is on the Battleboard, Melke has an additional \"Invisibility: Strike 10.\"",
    "flavorText": "Beware when crossing The Hunter's Perimeter. You may become the hunted.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "29/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 40,
      "wisdom": 30,
      "speed": 75,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/JRIaEqh.png"
  },
  {
    "id": "SS-30/100",
    "displayName": "Na-inna",
    "name": "Na-inna",
    "subname": "",
    "set": "ss",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Royal",
    "ability": "0:mipedianmugic:: Remove a Mugic counter from target Creature. If you do, put a Mugic counter on another Creature controlled by the same player. This ability can only be used once per turn. (You must choose a Creature that can have Mugic counters put on it.)",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Dan Norton, Anthony Washington",
    "serialNumber": "30/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 30,
      "wisdom": 60,
      "speed": 60,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ezRFYdW.png"
  },
  {
    "id": "SS-31/100",
    "displayName": "Ranun",
    "name": "Ranun",
    "subname": "",
    "set": "ss",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Conjuror",
    "ability": "Damage dealt to Warbeast Creatures you control by Recklessness is reduced by 10.\r\n:mipedianmugic:: Heal 10 damage to target Creature.",
    "flavorText": "I will not rest until both Maxxor and Chaor pay for their treachery!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "31/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 35,
      "wisdom": 65,
      "speed": 55,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Khh0lyo.png"
  },
  {
    "id": "SS-32/100",
    "displayName": "Saand",
    "name": "Saand",
    "subname": "",
    "set": "ss",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Elite",
    "ability": "Invisibility: Surprise.\r\n:air:Air 5.\r\nAt the beginning of your turn, you can sacrifice Saand. If you do, each player removes a total of 3 Mugic counters from among any Creatures they control.\r\nIf Saand has any Mugic counters on it, sacrifice it.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Ryan Benjamin, Etienne St.Laurent",
    "serialNumber": "32/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 40,
      "wisdom": 60,
      "speed": 85,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/NBqYL5e.png"
  },
  {
    "id": "SS-33/100",
    "displayName": "Titanix",
    "name": "Titanix",
    "subname": "",
    "set": "ss",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": "Intimidate: :courage:Courage 50.\r\nIntimidate: :speed:Speed 50.\r\nRecklessness 20.",
    "flavorText": "\"Sobtjek, admit that the rewards far outweigh the risks.\" — Drimesse",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "33/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 60,
      "wisdom": 30,
      "speed": 85,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Hv5SMOh.png"
  },
  {
    "id": "SS-34/100",
    "displayName": "Uboraan",
    "name": "Uboraan",
    "subname": "",
    "set": "ss",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": "Fireproof 10.\r\nWaterproof 10.\r\nRecklessness 15.",
    "flavorText": "Uboraan is a smallish Warbeast... only about the size of twenty Chaors.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez, Etienne St.Laurent",
    "serialNumber": "34/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 85,
      "wisdom": 30,
      "speed": 85,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/aaRo9Qc.png"
  },
  {
    "id": "SS-35/100",
    "displayName": "Xelfe",
    "name": "Xelfe",
    "subname": "",
    "set": "ss",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Scout",
    "ability": ":mipedianmugic:: Target Creature gains \"Range\" and \"Swift X,\" where X is the number of Mugic counters on Xelfe.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "35/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 50,
      "wisdom": 45,
      "speed": 90,
      "energy": 45,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/BmOswaF.png"
  },
  {
    "id": "BTD-43/222",
    "displayName": "Alazdan",
    "name": "Alazdan",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Minion Muge",
    "ability": ":mipedianmugic::mipedianmugic:, Sacrifice Alazdan: Deal 35 damage to target engaged Creature.",
    "flavorText": "",
    "brainwashedText": ":mipedianmugic::mipedianmugic:, Sacrifice Alazdan: Reduce all Disciplines to target engaged Creature by 35.",
    "brainwashed": true,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, John Rauch",
    "serialNumber": "43/222",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 45,
      "wisdom": 75,
      "speed": 30,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/zDDyJK4.png"
  },
  {
    "id": "BTD-44/222",
    "displayName": "Bivike",
    "name": "Bivike",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Scout",
    "ability": "If Bivike is engaged with a M'arrillian Creature, it has \"Invisibility: Strike 20.\"\r\nIf Bivike is in a space with a Mirage Location, its Disciplines cannot be increased or decreased.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "44/222",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 60,
      "wisdom": 50,
      "speed": 80,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ZKSiAD6.png"
  },
  {
    "id": "BTD-45/222",
    "displayName": "Dakkamal, Melee Trainer",
    "name": "Dakkamal",
    "subname": "Melee Trainer",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Elite Minion",
    "ability": ":mipedianmugic:: Target Creature gains \"Invisibility: Strike 10.\"",
    "flavorText": "",
    "brainwashedText": ":mipedianmugic:: Target Creature loses\r\n25 :speed:Speed.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "45/222",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 30,
      "wisdom": 65,
      "speed": 55,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/PheV2HR.png"
  },
  {
    "id": "BTD-46/222",
    "displayName": "Ebberim",
    "name": "Ebberim",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Stalker Minion",
    "ability": ":mipedianmugic:: Ebberim gains :air:Air.",
    "flavorText": "",
    "brainwashedText": ":mipedianmugic:: Relocate target opposing unengaged Creature to any unoccupied space on the Battleboard adjacent to it.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, David Curiel",
    "serialNumber": "46/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 50,
      "wisdom": 55,
      "speed": 80,
      "energy": 40,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/phkQS0k.png"
  },
  {
    "id": "BTD-47/222",
    "displayName": "Fazkaal",
    "name": "Fazkaal",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Minion Muge",
    "ability": "When a :genericmugic: is removed from the opposing engaged Creature, that Creature loses 20 to all Disciplines.",
    "flavorText": "",
    "brainwashedText": "When a :genericmugic: is removed from the opposing engaged Creature, Fazkaal gains :mipedianmugic:.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "47/222",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 55,
      "wisdom": 60,
      "speed": 40,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/UEKHurd.png"
  },
  {
    "id": "BTD-48/222",
    "displayName": "Jumbad",
    "name": "Jumbad",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Minion Muge",
    "ability": ":mipedianmugic:: Target Creature gains 10 :speed:Speed and 10 :wisdom:Wisdom.",
    "flavorText": "",
    "brainwashedText": ":mipedianmugic:: Target Creature loses 10 :speed:Speed  and 10 :wisdom:Wisdom.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Anthony Washington",
    "serialNumber": "48/222",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 35,
      "wisdom": 70,
      "speed": 85,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/A0tIGqx.png"
  },
  {
    "id": "BTD-49/222",
    "displayName": "Kileron, Warbeast of the Dust Storm",
    "name": "Kileron",
    "subname": "Warbeast of the Dust Storm",
    "set": "btd",
    "rarity": "ultra rare",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": "Recklessness 25. \r\n:air:Air 5.\r\n:earth:Earth 5.\r\nCreatures and Battlegear Cards that would be placed in a general discard pile are removed from the game instead.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "49/222",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 80,
      "wisdom": 40,
      "speed": 80,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/YHHFGoO.png"
  },
  {
    "id": "BTD-50/222",
    "displayName": "Maliph, Guard of the Palace",
    "name": "Maliph",
    "subname": "Guard of the Palace",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Elite Warrior",
    "ability": "Invisibility: Surprise.\r\nInvisibility: Strike 15.\r\nWhen Maliph wins combat, relocate it to any unoccupied space on the Battleboard adjacent to it.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "50/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 50,
      "wisdom": 45,
      "speed": 110,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/C9sPm5s.png"
  },
  {
    "id": "BTD-51/222",
    "displayName": "Mizkio",
    "name": "Mizkio",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Elite Minion",
    "ability": "Invisibility: Surprise.\r\n:earth:Earth 5.",
    "flavorText": "",
    "brainwashedText": "Invisibility: Strike 5 Swift 2",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "51/222",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 55,
      "wisdom": 50,
      "speed": 75,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/hnZdpDy.png"
  },
  {
    "id": "BTD-52/222",
    "displayName": "Owayki",
    "name": "Owayki",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Royal",
    "ability": "Mipedian Creatures you control with Invisibility have an additional 20 :speed:Speed and \"Invisibility: Strike 5.\"\r\n:air:Air 5.",
    "flavorText": "Neither alive nor dead, the ghost of Hunter's Perimeter haunts the haunted.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Keron Grant, Anthony Washington",
    "serialNumber": "52/222",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 60,
      "wisdom": 55,
      "speed": 95,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/K1032Kk.png"
  },
  {
    "id": "BTD-53/222",
    "displayName": "Savell",
    "name": "Savell",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Conjuror Minion",
    "ability": "Damage dealt to Warbeast Creatures you control by Recklessness is reduced by 10 for each Mugic counter on Savell.",
    "flavorText": "",
    "brainwashedText": "Increase Recklessness damage dealt to Warbeasts by 10 for each :mipedianmugic: on Savell.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, Etienne St.Laurent",
    "serialNumber": "53/222",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 40,
      "wisdom": 65,
      "speed": 70,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/vg4APwe.png"
  },
  {
    "id": "BTD-54/222",
    "displayName": "Sirri",
    "name": "Sirri",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Minion Scout",
    "ability": "Invisibility: Strike 10.",
    "flavorText": "",
    "brainwashedText": "Outperform :speed:Speed  5",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, Etienne St.Laurent",
    "serialNumber": "54/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 45,
      "speed": 90,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/RXicQZn.png"
  },
  {
    "id": "BTD-55/222",
    "displayName": "Tinnoi",
    "name": "Tinnoi",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Stalker Minion",
    "ability": "Invisibility: Strike 15.",
    "flavorText": "",
    "brainwashedText": "Intimidate: All Disciplines 10",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Etienne St.Laurent",
    "serialNumber": "55/222",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 70,
      "wisdom": 30,
      "speed": 70,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/jKCBOYf.png"
  },
  {
    "id": "BTD-56/222",
    "displayName": "Wistanne",
    "name": "Wistanne",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Minion Muge",
    "ability": ":mipedianmugic:: Heal 10 damage to target Creature and it loses 25 :speed:Speed.",
    "flavorText": "",
    "brainwashedText": ":mipedianmugic:: Heal 15 damage to target adjacent Creature.\r\nSwift 1",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, Anthony Washington",
    "serialNumber": "56/222",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 55,
      "wisdom": 55,
      "speed": 60,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/uZWhtrH.png"
  },
  {
    "id": "ROTO-22/100",
    "displayName": "Appelai",
    "name": "Appelai",
    "subname": "",
    "set": "roto",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Conjuror",
    "ability": "Damage dealt by Recklessness to Warbeast Creatures you control is reduced by 10 for each Mugic counter on Appelai.\r\nWhen a Warbeast Creature you control is targeted by an opposing Mugic or ability, put a Mugic counter on Appelai.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kizer Grey, David Curiel",
    "serialNumber": "22/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 55,
      "wisdom": 70,
      "speed": 45,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/TH7FwjZ.png"
  },
  {
    "id": "ROTO-23/100",
    "displayName": "Epitrinne",
    "name": "Epitrinne",
    "subname": "",
    "set": "roto",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Minion Muge",
    "ability": "Damage dealt to Epitrinne by Mugic is reduced to 0.",
    "flavorText": "",
    "brainwashedText": "Damage dealt to Chieftain Creatures you control by Mugic is reduced to 0.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kizer Grey, Etienne St.Laurent",
    "serialNumber": "23/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 40,
      "wisdom": 55,
      "speed": 105,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/98WlXDA.png"
  },
  {
    "id": "ROTO-24/100",
    "displayName": "Glost",
    "name": "Glost",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": "Glost has an additional 5 Energy, \":earth:Earth 5\", and \":air:Air 5\" for each Conjuror Creature Card in your general discard pile.\r\nRecklessness 20.",
    "flavorText": "If more Warbeasts are our only hope for survival, I fear for our future!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Kizer Grey, Reggie Butler",
    "serialNumber": "24/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 60,
      "wisdom": 40,
      "speed": 85,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Ctv07Yj.png"
  },
  {
    "id": "ROTO-25/100",
    "displayName": "Headmaster Ankhyja",
    "name": "Headmaster Ankhyja",
    "subname": "",
    "set": "roto",
    "rarity": "ultra rare",
    "tribe": "mipedian",
    "subtype": "Stalker",
    "ability": "Invisibility: Strike 15.\r\nCreatures cannot lose Invisibility from Mugic or abilities.\r\nInvisibility abilities work against Creatures with Invisibility.\r\nIf you lost Initiative, your engaged Creature has \"Strike 10.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "25/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 85,
      "wisdom": 55,
      "speed": 110,
      "energy": 70,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/EEA2fHV.png"
  },
  {
    "id": "ROTO-26/100",
    "displayName": "Otinee",
    "name": "Otinee",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Minion Scout",
    "ability": "Swift 2.",
    "flavorText": "",
    "brainwashedText": ":water:Water  5",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kizer Grey, Etienne St.Laurent",
    "serialNumber": "26/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 50,
      "wisdom": 65,
      "speed": 75,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/XkIx5dl.png"
  },
  {
    "id": "ROTO-27/100",
    "displayName": "Rasbma Darini",
    "name": "Rasbma Darini",
    "subname": "",
    "set": "roto",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Royal Minion",
    "ability": "Invisibility: Surprise.\r\nInvisibility: Strike 10.\r\n:earth:Earth 5.",
    "flavorText": "",
    "brainwashedText": "Creatures do not have and cannot gain Invisibility.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "27/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 65,
      "wisdom": 60,
      "speed": 95,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/1Ru2KdS.png"
  },
  {
    "id": "ROTO-28/100",
    "displayName": "Taffial",
    "name": "Taffial",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Royal Stalker",
    "ability": "Attacks played by Creatures you control deal an additional 5 damage if there is an Attack Card with the same name in your Attack Discard pile.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "28/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 60,
      "wisdom": 70,
      "speed": 75,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/zmbSmhC.png"
  },
  {
    "id": "TOTT-15/100",
    "displayName": "Ailav",
    "name": "Ailav",
    "subname": "",
    "set": "tott",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Conjuror Warrior",
    "ability": "Damage dealt to Warbeast Creatures you control is reduced by 5.",
    "flavorText": "\"Warbeasts the size of palaces are under my control. Why would I ever fear a M'arrillian!?\" — Ailav",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, David Curiel",
    "serialNumber": "15/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 40,
      "wisdom": 70,
      "speed": 85,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/xJO5Hjt.png"
  },
  {
    "id": "TOTT-16/100",
    "displayName": "Gaffat-ra",
    "name": "Gaffat-ra",
    "subname": "",
    "set": "tott",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": "Defender: Conjuror.\r\nNon-attack damage dealt to adjacent Royal Creatures is dealt to Gaffat-ra instead.\r\nRecklessness 10.",
    "flavorText": "As the war turns grim, even Royals have begun to accept the Warbeasts.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "16/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 110,
      "wisdom": 110,
      "speed": 60,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/H1k5raH.png"
  },
  {
    "id": "TOTT-17/100",
    "displayName": "Iflar, The Crown Prince",
    "name": "Iflar",
    "subname": "The Crown Prince",
    "set": "tott",
    "rarity": "ultra rare",
    "tribe": "mipedian",
    "subtype": "Royal",
    "ability": "Invisibility: Surprise.\r\nInvisibility: Strike 20.\r\nUntargetable.",
    "flavorText": "\"If he's so weak and scrawny, why am I the one covered in bruises!?\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "17/100",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 30,
      "wisdom": 60,
      "speed": 85,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/DLSE3Fg.png"
  },
  {
    "id": "TOTT-18/100",
    "displayName": "Na-inna, Rebel of the Rao'Pa Sahkk",
    "name": "Na-inna",
    "subname": "Rebel of the Rao'Pa Sahkk",
    "set": "tott",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Royal Minion",
    "ability": "At the beginning of your turn, each player puts a Mugic counter on a Creature they control with no Mugic counters.",
    "flavorText": "",
    "brainwashedText": "At the beginning of your turn, each player removes a Mugic counter from any Creature they control.",
    "brainwashed": true,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "18/100",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 30,
      "wisdom": 65,
      "speed": 40,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/SoAgG1y.png"
  },
  {
    "id": "TOTT-19/100",
    "displayName": "Noaz, Mipedian Cavalerist",
    "name": "Noaz",
    "subname": "Mipedian Cavalerist",
    "set": "tott",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Stalker Warrior",
    "ability": "At the beginning of your turn, Noaz gains \":air:Air 10\" and \"Invisibility: Surprise.\"\r\nSwift 1",
    "flavorText": "No fugitive has ever escaped from his mount's speed... or his blade!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, Chris Fisher",
    "serialNumber": "19/100",
    "isPast": false,
    "stats": {
      "courage": 100,
      "power": 50,
      "wisdom": 45,
      "speed": 105,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/i0qZRhS.png"
  },
  {
    "id": "TOTT-27/100",
    "displayName": "Ruhban",
    "name": "Ruhban",
    "subname": "",
    "set": "tott",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Stalker Scout",
    "ability": "Invisibility: Surprise\r\nSwift 1",
    "flavorText": "\"You cowards! We don't need Maxxor's help! We can defeat the M'arrillians on our own!\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "27/100",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 55,
      "wisdom": 65,
      "speed": 95,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/52UcC4R.png"
  },
  {
    "id": "TOTT-5/100",
    "displayName": "Yterio",
    "name": "Yterio",
    "subname": "",
    "set": "tott",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Warrior",
    "ability": "Sacrifice Yterio: Target attack deals 0 damage.",
    "flavorText": "\"You can't save everyone. But if you save just one, he will save another, and he another, until everyone is saved.\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "5/100",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 70,
      "wisdom": 50,
      "speed": 60,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/5X0oRyF.png"
  },
  {
    "id": "FUN-25/100",
    "displayName": "Akkalbi",
    "name": "Akkalbi",
    "subname": "",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Minion Muge",
    "ability": "Damage dealt by Recklessness to Creatures you control is reduced by 10.",
    "flavorText": "",
    "brainwashedText": "Damage dealt to Creatures by Recklessness is increased by 10.",
    "brainwashed": true,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, Bob Rivard",
    "serialNumber": "25/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 30,
      "wisdom": 80,
      "speed": 45,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/CngHBQN.png"
  },
  {
    "id": "FUN-26/100",
    "displayName": "Ebbikka",
    "name": "Ebbikka",
    "subname": "",
    "set": "fun",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Scout",
    "ability": "Battlegear equipped to OverWorld Creatures you control have \"Untargetable.\"",
    "flavorText": "Though master of countless Mipedian weapons, something about OverWorld craftsmanship resonates with her.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "26/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 45,
      "wisdom": 75,
      "speed": 95,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/wmHEyZm.png"
  },
  {
    "id": "FUN-27/100",
    "displayName": "Grantkae, Mipedian General",
    "name": "Grantkae",
    "subname": "Mipedian General",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Royal Elite",
    "ability": "On your turn, other Creatures you control gain 25 to all Disciplines if you control an OverWorlder;\r\n\"Intimidate Energy: 10\" if you control an UnderWorlder;\r\n\"Waterproof 25\" if you control a Danian.\r\n<b>Legendary</b>",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": true,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez, Anthony Washington",
    "serialNumber": "27/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 75,
      "speed": 95,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ihija6l.png"
  },
  {
    "id": "FUN-28/100",
    "displayName": "Jorre, Mipedian Lieutenant",
    "name": "Jorre",
    "subname": "Mipedian Lieutenant",
    "set": "fun",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Stalker Muge",
    "ability": ":mipedianmugic:: Target Creature gains \"Range\" and \"Swift X,\" where X is the number of Tribes you control.",
    "flavorText": "At home on the battlefield, Jorre wishes the war would never end.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez, Anthony Washington",
    "serialNumber": "28/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 40,
      "wisdom": 35,
      "speed": 90,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/S1l0RLi.png"
  },
  {
    "id": "FUN-29/100",
    "displayName": "Khorror",
    "name": "Khorror",
    "subname": "",
    "set": "fun",
    "rarity": "ultra rare",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": "Recklessness 50",
    "flavorText": "\"I realize the battle is necessary, but this... this is too much. Even if we win the war, Perim is doomed.\" — Sobtjek",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "29/100",
    "isPast": false,
    "stats": {
      "courage": 110,
      "power": 110,
      "wisdom": 25,
      "speed": 110,
      "energy": 135,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ZQ8OG3F.png"
  },
  {
    "id": "FUN-30/100",
    "displayName": "Majjcan",
    "name": "Majjcan",
    "subname": "",
    "set": "fun",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Elementalist",
    "ability": "While you control a Danian Creature, Majjcan has \":earth:Earth 5.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "30/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 50,
      "wisdom": 60,
      "speed": 90,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/3FDhFHW.png"
  },
  {
    "id": "FUN-31/100",
    "displayName": "Raquanni",
    "name": "Raquanni",
    "subname": "",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Minion Muge",
    "ability": ":mipedianmugic:: Target equipped Creature gains \"Outperform :speed:Speed 5.\"",
    "flavorText": "",
    "brainwashedText": ":mipedianmugic:: Target equipped Creature gains \":water:Water  5.\"",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Jimmy Tran",
    "serialNumber": "31/100",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 35,
      "wisdom": 90,
      "speed": 60,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/f0i3eZE.png"
  },
  {
    "id": "FUN-32/100",
    "displayName": "Shinadd",
    "name": "Shinadd",
    "subname": "",
    "set": "fun",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Scout",
    "ability": "If Shinadd would become engaged on your turn, you can swaps spaces on the Battleboard of it with an UnderWorld Creature you control. If you do, that Creature becomes engaged instead.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grand, Keith Conroy, Reggie Butler",
    "serialNumber": "32/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 45,
      "wisdom": 40,
      "speed": 110,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/2aRuUTU.png"
  },
  {
    "id": "AU-S14/26",
    "displayName": "Ajara",
    "name": "Ajara",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Scout",
    "ability": "Attack damage dealt by Past Creatures you control to Creatures with fewer Mugic counters is icreased by 5.",
    "flavorText": "Though the first to discover the problem, she was the last to be believed.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Bob Rivard",
    "serialNumber": "S14/26",
    "isPast": true,
    "stats": {
      "courage": 50,
      "power": 45,
      "wisdom": 50,
      "speed": 90,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/YzES6B0.png"
  },
  {
    "id": "AU-49/200",
    "displayName": "Enre-hep, High Muge of the Desert",
    "name": "Enre-hep",
    "subname": "High Muge of the Desert",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "mipedian",
    "subtype": "Muge",
    "ability": ":mipedianmugic:: Copy target Mugic played by a Creature you control. You may choose new targets for the copy.",
    "flavorText": "The echoes of Mugic can be heard over the desert wind by those who know how to listen.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "49/200",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 40,
      "wisdom": 90,
      "speed": 70,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/JCyHISQ.png"
  },
  {
    "id": "AU-50/200",
    "displayName": "Fasseph",
    "name": "Fasseph",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Warrior",
    "ability": "When a Battlegear equipped to a Creature engaged with Fasseph is flipped face-up or face-down, deal 10 damage to that Creature.",
    "flavorText": "A master craftsman, his repairs are more powerful than the the originals.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "50/200",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 35,
      "wisdom": 70,
      "speed": 90,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/A7jA6uv.png"
  },
  {
    "id": "AU-51/200",
    "displayName": "Gintanai, The Forgotten",
    "name": "Gintanai",
    "subname": "The Forgotten",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": "When Gintanai wins combat, sacrifice another Creature. If you cannot, destroy Gintanai.\r\n:air:Air 10\r\n:earth:Earth 10",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent, Emilio Lopez",
    "serialNumber": "51/200",
    "isPast": false,
    "stats": {
      "courage": 130,
      "power": 130,
      "wisdom": 40,
      "speed": 130,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/XOZEdQn.png"
  },
  {
    "id": "AU-52/200",
    "displayName": "Habekh",
    "name": "Habekh",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Conjuror",
    "ability": "Damage dealt to Warbeast Creatures you control by Recklessness is reduced by 10 for each Elemental Type that Warbeast Creature has.",
    "flavorText": "Habekh has always claimed that the elements themselves can be a stabilizing influence on a conjured Warbeast.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Axer",
    "serialNumber": "52/200",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 45,
      "wisdom": 70,
      "speed": 70,
      "energy": 35,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/zcwiz21.png"
  },
  {
    "id": "AU-53/200",
    "displayName": "Headmaster Ankhyja, Seeker of the Art",
    "name": "Headmaster Ankhyja",
    "subname": "Seeker of the Art",
    "set": "au",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Elite Stalker",
    "ability": "Your other Creatures with :air:Air cannot be targeted by opposing Mugic or abilities.",
    "flavorText": "\"For those of us who hide in plain sight, being sheltered by air is neither strange nor unreal.\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Axer",
    "serialNumber": "53/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 40,
      "wisdom": 55,
      "speed": 105,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/AuT7Ake.png"
  },
  {
    "id": "AU-54/200",
    "displayName": "Ifjann",
    "name": "Ifjann",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Muge",
    "ability": "Expend :air:Air: Target adjacent Creature gains \"Untargetable.\"",
    "flavorText": "Much to the chagrin of his workers, Ifjann was living proof of his \"work harder, not smarter\" philosophy.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Bob Rivard",
    "serialNumber": "54/200",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 40,
      "wisdom": 70,
      "speed": 80,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/veAUAsQ.png"
  },
  {
    "id": "AU-S15/26",
    "displayName": "Ixxik",
    "name": "Ixxik",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": "Other Creatures you control have 10 less Energy.",
    "flavorText": "At one time Warbeasts roamed wild and deserts were jungles.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Chris Fisher",
    "serialNumber": "S15/26",
    "isPast": true,
    "stats": {
      "courage": 100,
      "power": 90,
      "wisdom": 40,
      "speed": 90,
      "energy": 90,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/LITF5l5.png"
  },
  {
    "id": "AU-55/200",
    "displayName": "Khenti",
    "name": "Khenti",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Stalker Warrior",
    "ability": "Invisibility: Strike 10\r\nExpend :air:Air: Khenti gains \"Range\" and \"Swift 1.\"",
    "flavorText": "Born to fight, the war never ends in his unsettled mind.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "serialNumber": "55/200",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 50,
      "wisdom": 45,
      "speed": 100,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/EJIGBQm.png"
  },
  {
    "id": "AU-56/200",
    "displayName": "Kojjbel",
    "name": "Kojjbel",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Warrior",
    "ability": "Expend :earth:Earth while engaged: Target attack deals 15 damage.",
    "flavorText": "As a student of Mudeenu, Kojjbel knows no fear.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Jimmy Tran",
    "serialNumber": "56/200",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 45,
      "wisdom": 45,
      "speed": 95,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/NO3WoWh.png"
  },
  {
    "id": "AU-57/200",
    "displayName": "Kolmo, Purified",
    "name": "Kolmo",
    "subname": "Purified",
    "set": "au",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Elite Stalker",
    "ability": "Range\r\nSwift 1\r\nKolmo has \"Invisibility: Strike 10\" for each Elemental Type the opposing engaged Creature has.",
    "flavorText": "While part of hive, Kolmo learned all the Danians' secrets.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keith Conroy, Bob Rivard",
    "serialNumber": "57/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 55,
      "wisdom": 55,
      "speed": 105,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/2hSTKw7.png"
  },
  {
    "id": "AU-58/200",
    "displayName": "Ninren",
    "name": "Ninren",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Warbeast",
    "ability": "Range\r\nSwift 1\r\nRecklessness 25",
    "flavorText": "Made of lightning and just as quick.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Jimmy Tran",
    "serialNumber": "58/200",
    "isPast": false,
    "stats": {
      "courage": 100,
      "power": 100,
      "wisdom": 35,
      "speed": 160,
      "energy": 75,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/m6LpXuX.png"
  },
  {
    "id": "AU-59/200",
    "displayName": "Qwun, Solitary Scout",
    "name": "Qwun",
    "subname": "Solitary Scout",
    "set": "au",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Scout",
    "ability": "Expend :air:Air while engaged: Flip all Battlegear equipped to the opposing engaged Creature face-down.",
    "flavorText": "Surviving alone in the desert takes a certain kind of cleverness.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "serialNumber": "59/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 40,
      "wisdom": 60,
      "speed": 100,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/6DLh5js.png"
  },
  {
    "id": "AU-60/200",
    "displayName": "Sepmek",
    "name": "Sepmek",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Muge",
    "ability": "At the beginning of your turn, flip all Battlegear equipped to Sepmek face-up.",
    "flavorText": "\"Do not be afraid, for these symbols are as powerful as any shield.\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Reggie Butler",
    "serialNumber": "60/200",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 35,
      "wisdom": 70,
      "speed": 95,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/jnX7LRa.png"
  },
  {
    "id": "AU-61/200",
    "displayName": "Silv, Servant of Air",
    "name": "Silv",
    "subname": "Servant of Air",
    "set": "au",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Elementalist",
    "ability": ":mipedianmugic:: Target Creature gains :air:Air.",
    "flavorText": "\"I am of storm and of gentle breeze. Of elegance, lightness and furious wrath. And now I am of your house, Enre-hep.\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "61/200",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 45,
      "wisdom": 40,
      "speed": 95,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/FQvwetd.png"
  },
  {
    "id": "AU-62/200",
    "displayName": "Taffial, Cothica Hunter",
    "name": "Taffial",
    "subname": "Cothica Hunter",
    "set": "au",
    "rarity": "super rare",
    "tribe": "mipedian",
    "subtype": "Royal Stalker",
    "ability": "Expend :earth:Earth: Discard an Attack Card. If you do, return an Attack Card with Build Points less than or equal to the discarded Attack Card to your hand. If you cannot, draw an Attack Card.\r\n",
    "flavorText": "Archaeology is the search for fact, not truth.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Bob Rivard",
    "serialNumber": "62/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 30,
      "wisdom": 75,
      "speed": 75,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/oIAEhTv.png"
  },
  {
    "id": "AU-63/200",
    "displayName": "Ylinné",
    "name": "Ylinné",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Elite Warrior",
    "ability": ":mipedianmugic:: Target Creature gains \"Invisibility: Strike 10.\" If that Creature has :air:Air, it also gains \"Invisibility: Surprise.\"",
    "flavorText": "None shall pass - at least, not in one piece.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Axer",
    "serialNumber": "63/200",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 40,
      "wisdom": 50,
      "speed": 85,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/qEyL3JP.png"
  },
  {
    "id": "AU-64/200",
    "displayName": "Zhade, Dig Site Defender",
    "name": "Zhade",
    "subname": "Dig Site Defender",
    "set": "au",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Stalker",
    "ability": "Invisibility: Strike 15",
    "flavorText": "Zhade makes sure that those spies unfortunate enough to learn what was unearthed never report their findings.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "64/200",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 55,
      "wisdom": 40,
      "speed": 105,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/eEZdWOB.png"
  },
  {
    "id": "FAS-27/100",
    "displayName": "Malvadine, The King's Herald",
    "name": "Malvadine",
    "subname": "The King's Herald",
    "set": "fas",
    "rarity": "ultra rare",
    "tribe": "mipedian",
    "subtype": "Elite Warrior",
    "ability": "Invisibility: Strike 10 \r\nWhile you control a Royal, Malvadine has \"Defender\" and \":air:Air 5.\"",
    "flavorText": "\"We shall claim this city for Mipedim as we await King Theb-saar's return!\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Axer",
    "serialNumber": "27/100",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 60,
      "wisdom": 55,
      "speed": 110,
      "energy": 70,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/zO3TGxq.png"
  },
  {
    "id": "OP-OP1-9/20",
    "displayName": "Ghatup",
    "name": "Ghatup",
    "subname": "",
    "set": "op",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Scout",
    "ability": "",
    "flavorText": "Traveling far beyond the desert, Ghatup has seen many sights, including those he wishes he never had.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "OP1-9/20",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 30,
      "wisdom": 75,
      "speed": 70,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/eu6dSqr.png"
  },
  {
    "id": "OP-OP1-10/20",
    "displayName": "Vasquin",
    "name": "Vasquin",
    "subname": "",
    "set": "op",
    "rarity": "rare",
    "tribe": "mipedian",
    "subtype": "Muge",
    "ability": ":mipedianmugic:: Deal 5 damage to target Creature.",
    "flavorText": "After stealing Ulmar's top-secret Mugiblade, Vasquin earned himself an eternal enemy... but it was well worth it!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "OP1-10/20",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 50,
      "wisdom": 95,
      "speed": 45,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/iHLaBrR.png"
  },
  {
    "id": "OP-LR07/10",
    "displayName": "Abin-wor",
    "name": "Abin-wor",
    "subname": "",
    "set": "op",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Conjuror",
    "ability": "Damage dealt by Recklessness to Warbeast Creatures you control is reduced by 5.\r\nWarbeast Creatures you control have \"Waterproof: 25.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, Anthony Washington",
    "serialNumber": "LR07/10",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 40,
      "wisdom": 65,
      "speed": 55,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Yf9DivH.png"
  },
  {
    "id": "OP-LR08/10",
    "displayName": "Farhkaj",
    "name": "Farhkaj",
    "subname": "",
    "set": "op",
    "rarity": "uncommon",
    "tribe": "mipedian",
    "subtype": "Elite Warrior",
    "ability": "Damage dealt to Farhkaj by :water:Water attacks is reduced by 5.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "LR08/10",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 65,
      "wisdom": 55,
      "speed": 85,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/nbFukeR.png"
  },
  {
    "id": "OP-9ke2h2e2",
    "displayName": "Kobarri",
    "name": "Kobarri",
    "subname": "",
    "set": "op",
    "rarity": "common",
    "tribe": "mipedian",
    "subtype": "Royal Muge",
    "ability": ":mipedianmugic: :mipedianmugic:: Target Creature you control cannot be targeted by Mugic or abilities.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 35,
      "wisdom": 70,
      "speed": 30,
      "energy": 30,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/oIpsvUx.png"
  },
  {
    "id": "DOP-P-019",
    "displayName": "Epaluo",
    "name": "Epaluo",
    "subname": "",
    "set": "dop",
    "rarity": "promo",
    "tribe": "mipedian",
    "subtype": "Stalker Warrior",
    "ability": "Invisibility: Strike 5.\r\nInvisibility: Surprise.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tom Baxa",
    "serialNumber": "P-019",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 40,
      "wisdom": 85,
      "speed": 70,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/d1eX9h4.png"
  },
  {
    "id": "TOTT-P-005",
    "displayName": "Prince Mudeenu, Champion of the Guard",
    "name": "Prince Mudeenu",
    "subname": "Champion of the Guard",
    "set": "tott",
    "rarity": "promo",
    "tribe": "mipedian",
    "subtype": "Royal Warrior",
    "ability": "Mipedian Creatures you control have \"Invisibility: Surprise.\"",
    "flavorText": "\"You can either surrender or die... and I won't accept your surrender.\" — Prince Mudeenu",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "P-005",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 50,
      "wisdom": 30,
      "speed": 90,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/cvoV1tw.png"
  },
  {
    "id": "DOP-1/232",
    "displayName": "Arias",
    "name": "Arias",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Warrior",
    "ability": "Support: :power:Power 5.",
    "flavorText": "If you think he looks angry now, you should have been at the nose-piercing!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "1/232",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 75,
      "wisdom": 40,
      "speed": 65,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Jn8cs6S.png"
  },
  {
    "id": "DOP-2/232",
    "displayName": "Attacat",
    "name": "Attacat",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Guardian Warrior",
    "ability": "Swift 1.",
    "flavorText": "\"A ferocious warrior — when he finally gets up the nerve to battle.\" — Intress",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "2/232",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 75,
      "wisdom": 70,
      "speed": 115,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/tBbfg1i.png"
  },
  {
    "id": "DOP-3/232",
    "displayName": "Blazier",
    "name": "Blazier",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Scout",
    "ability": ":overworldmugic:: Look at the top two cards of target player's Location Deck. Put one of them on top of that deck and the other on the bottom.",
    "flavorText": "This small, scrappy spy maps enemy territory for the OverWorld’s warriors.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "3/232",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 50,
      "wisdom": 70,
      "speed": 35,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/5nNWyWL.png"
  },
  {
    "id": "DOP-4/232",
    "displayName": "Blügon",
    "name": "Blügon",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": ":water:Water 5.",
    "flavorText": "The Frozen - mysterious Creatures who inhabit Glacier Plains - count Blügon as their friend.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "4/232",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 75,
      "wisdom": 80,
      "speed": 55,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/aFlMIEx.png"
  },
  {
    "id": "DOP-5/232",
    "displayName": "Bodal",
    "name": "Bodal",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Caretaker",
    "ability": "Support: :wisdom:Wisdom 5.",
    "flavorText": "The trouble with Bodal is that Bodal is troubled.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "5/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 50,
      "wisdom": 90,
      "speed": 70,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/vAr7Sif.png"
  },
  {
    "id": "DOP-6/232",
    "displayName": "Crawsectus",
    "name": "Crawsectus",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": ":earth:Earth 5.",
    "flavorText": "His hard exterior hides an even harder interior.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "6/232",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 55,
      "wisdom": 50,
      "speed": 35,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/QvVn1KG.png"
  },
  {
    "id": "DOP-7/232",
    "displayName": "Donmar",
    "name": "Donmar",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Caretaker",
    "ability": ":overworldmugic:: Heal 10 damage to target Creature.",
    "flavorText": "Deciphering the Runic Grove’s mysterious markings is Donmar’s devotion... and the likely cause of his dementia.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "7/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 75,
      "wisdom": 75,
      "speed": 60,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Q7VZWvk.png"
  },
  {
    "id": "DOP-8/232",
    "displayName": "Dractyl",
    "name": "Dractyl",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Scout",
    "ability": "Range.\r\nSwift 1.",
    "flavorText": "The high-flying OverWorld messenger and spy.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "8/232",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 80,
      "wisdom": 60,
      "speed": 85,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/OhtAz44.png"
  },
  {
    "id": "DOP-9/232",
    "displayName": "Frafdo",
    "name": "Frafdo",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": "Support: :courage:Courage 5.",
    "flavorText": "This winged warrior makes his nest at Castle Bodhran.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "9/232",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 90,
      "wisdom": 55,
      "speed": 85,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/DLDmGJu.png"
  },
  {
    "id": "DOP-10/232",
    "displayName": "Gespedan",
    "name": "Gespedan",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Scout",
    "ability": "Support: :speed:Speed 5.\r\nSwift 1.",
    "flavorText": "No matter how swiftly Gespedan sprints, he can’t outrun his one, tragic mistake.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, Andrew Bradshaw, David Curiel",
    "serialNumber": "10/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 60,
      "wisdom": 45,
      "speed": 110,
      "energy": 40,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/MmeC8LW.png"
  },
  {
    "id": "DOP-11/232",
    "displayName": "Heptadd",
    "name": "Heptadd",
    "subname": "",
    "set": "dop",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Guardian Muge",
    "ability": "Heptadd can play Mugic of any tribe.",
    "flavorText": "Some in Perim believe that Heptadd knows where the Cothica is.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "11/232",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 60,
      "speed": 60,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/ePgP5EH.png"
  },
  {
    "id": "DOP-12/232",
    "displayName": "Intress",
    "name": "Intress",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Hero",
    "ability": ":water:Water 5.",
    "flavorText": "The secret behind Maxxor’s bond with Intress is also the wedge that keeps them apart.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "12/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 45,
      "wisdom": 50,
      "speed": 65,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/F8B6EhN.png"
  },
  {
    "id": "DOP-13/232",
    "displayName": "Laarina",
    "name": "Laarina",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Scout",
    "ability": "",
    "flavorText": "\"I don’t steal; I liberate lost valuables. And the only problem I have with what I do is the possibility of getting caught.\" — Laarina",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "13/232",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 30,
      "wisdom": 60,
      "speed": 40,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/gMRkSHS.png"
  },
  {
    "id": "DOP-14/232",
    "displayName": "Maglax",
    "name": "Maglax",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": ":earth:Earth 5.",
    "flavorText": "Mommark’s monstrous creation has one thing going for him: a magnetic personality!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "14/232",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 70,
      "wisdom": 35,
      "speed": 40,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/IclEh7F.png"
  },
  {
    "id": "DOP-15/232",
    "displayName": "Maxxor",
    "name": "Maxxor",
    "subname": "",
    "set": "dop",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Hero",
    "ability": ":overworldmugic:: Heal 10 damage to target Creature.",
    "flavorText": "No OverWorlder has ever seen Maxxor’s face in battle because he is always in the frontline, leading the charge!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "15/232",
    "isPast": false,
    "stats": {
      "courage": 110,
      "power": 75,
      "wisdom": 90,
      "speed": 60,
      "energy": 65,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/V9wEb0y.png"
  },
  {
    "id": "DOP-16/232",
    "displayName": "Najarin",
    "name": "Najarin",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Strategist Muge",
    "ability": ":overworldmugic::overworldmugic:: Return target Mugic Card from your general discard pile to your hand.",
    "flavorText": "\"The search for the Cothica is the means to an end. But finding it may mean the end.\" — Najarin",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "16/232",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 40,
      "wisdom": 100,
      "speed": 45,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ZUDGKDL.png"
  },
  {
    "id": "DOP-17/232",
    "displayName": "Owis",
    "name": "Owis",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": ":overworldmugic:: Heal 5 damage to target Creature. \r\n:overworldmugic:: Heal 10 damage to Owis.",
    "flavorText": "UnderWorlders have made countless attempts to breach Cordac Falls. Owis has repelled all but one... the one that haunts him.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "17/232",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 35,
      "wisdom": 65,
      "speed": 40,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/IwaRJDH.png"
  },
  {
    "id": "DOP-18/232",
    "displayName": "Psimion",
    "name": "Psimion",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Strategist",
    "ability": "Support: :wisdom:Wisdom 5.",
    "flavorText": "\"Simple\" Psimion is not... though his seeming to be so has certain advantages.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "18/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 40,
      "wisdom": 65,
      "speed": 50,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/GbWNLnI.png"
  },
  {
    "id": "DOP-19/232",
    "displayName": "Rellim",
    "name": "Rellim",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Caretaker",
    "ability": "Support: :courage:Courage 5.",
    "flavorText": "\"The Mill is not my only interest. I also enjoy beating on UnderWorlders.\" — Rellim",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "19/232",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 75,
      "wisdom": 70,
      "speed": 50,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/NTAjzQR.png"
  },
  {
    "id": "DOP-20/232",
    "displayName": "Slurhk",
    "name": "Slurhk",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": "",
    "flavorText": "As poison spreads throughout the Mipedian’s body, Slurhk sneers. He will enjoy reclaiming his desert homeland — one lizard at a time.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "20/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 45,
      "wisdom": 45,
      "speed": 50,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/5xupe9K.png"
  },
  {
    "id": "DOP-21/232",
    "displayName": "Staluk",
    "name": "Staluk",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Warrior",
    "ability": ":earth:Earth 5.\r\nSwift 1.",
    "flavorText": "This Mommark creation is slow to start... and difficult to stop.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "21/232",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 55,
      "wisdom": 35,
      "speed": 50,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/1S1Axqn.png"
  },
  {
    "id": "DOP-22/232",
    "displayName": "Tangath Toborn",
    "name": "Tangath Toborn",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Strategist Warrior",
    "ability": ":overworldmugic:: Heal 10 damage to Tangath Toborn.",
    "flavorText": "\"I battle because I must. But in my heart, I know that war is not the answer.\" — Tangath Toborn",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "22/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 55,
      "wisdom": 50,
      "speed": 40,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/X53VvvJ.png"
  },
  {
    "id": "DOP-23/232",
    "displayName": "Tartarek",
    "name": "Tartarek",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Hero",
    "ability": ":overworldmugic:: Target Creature gains \"Swift 1.\"",
    "flavorText": "Brave enough to take on any battle, wise enough to avoid most.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "23/232",
    "isPast": false,
    "stats": {
      "courage": 100,
      "power": 55,
      "wisdom": 100,
      "speed": 35,
      "energy": 40,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/YTqgHpi.png"
  },
  {
    "id": "DOP-24/232",
    "displayName": "Velreth",
    "name": "Velreth",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Warrior",
    "ability": "Swift 1.",
    "flavorText": "Velreth is easy to find: just follow the path of destruction.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "24/232",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 90,
      "wisdom": 50,
      "speed": 35,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ZWavo12.png"
  },
  {
    "id": "DOP-25/232",
    "displayName": "Vidav",
    "name": "Vidav",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Strategist",
    "ability": ":overworldmugic:: Heal 15 damage to target Creature.",
    "flavorText": "he treaty of Vidav could have brought peace to the warring tribes of Perim ... if only its leaders had been willing to accept it.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "25/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 40,
      "wisdom": 60,
      "speed": 45,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/40IHUQO.png"
  },
  {
    "id": "DOP-26/232",
    "displayName": "Xaerv",
    "name": "Xaerv",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": ":air:Air 5.",
    "flavorText": "\"You got Xaerved.\" - Xaerv",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "26/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 35,
      "wisdom": 55,
      "speed": 70,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/x3eSwO9.png"
  },
  {
    "id": "DOP-27/232",
    "displayName": "Yokkis",
    "name": "Yokkis",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Hero",
    "ability": "Support: all Disciplines 5.",
    "flavorText": "He may look funny from a distance, but get too close and the joke’s on you.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "27/232",
    "isPast": false,
    "stats": {
      "courage": 30,
      "power": 30,
      "wisdom": 30,
      "speed": 30,
      "energy": 55,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/VGYVmRG.png"
  },
  {
    "id": "DOP-28/232",
    "displayName": "Zalic",
    "name": "Zalic",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": ":overworldmugic:: Heal 15 damage to Zalic.",
    "flavorText": "This confidant of Intress never sleeps, so Maxxor has appointed him guardian of the Passage between the OverWorld and the UnderWorld.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "28/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 65,
      "wisdom": 50,
      "speed": 50,
      "energy": 50,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/XLpEJyY.png"
  },
  {
    "id": "ZOTH-1/100",
    "displayName": "Aggroar",
    "name": "Aggroar",
    "subname": "",
    "set": "zoth",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Strategist",
    "ability": "Strategist Creatures you control have \"Defender.\"",
    "flavorText": "Flickers like a frozen flame, strikes like a burning shard.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "1/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 45,
      "wisdom": 75,
      "speed": 55,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Xo7Xu1o.png"
  },
  {
    "id": "ZOTH-2/100",
    "displayName": "Garv",
    "name": "Garv",
    "subname": "",
    "set": "zoth",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Caretaker",
    "ability": ":overworldmugic:: Flip target Battlegear face-up or face-down.",
    "flavorText": "Speaker of a thousand languages - from bird to bacteria - the bulbous monk wanders the land and watches life flourish with every step.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gus Vazquez, Anthony Washington",
    "serialNumber": "2/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 35,
      "wisdom": 85,
      "speed": 40,
      "energy": 60,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/hXKLct3.png"
  },
  {
    "id": "ZOTH-3/100",
    "displayName": "Hune Marquard",
    "name": "Hune Marquard",
    "subname": "",
    "set": "zoth",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Muge",
    "ability": "When a Danian Mugic is played by an opposing Creature, put a Mugic counter on Hune Marquard.",
    "flavorText": "As the foremost authority on Danian Mugic, he works to unlock their mysteries... and how to exploit them.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, David Curiel",
    "serialNumber": "3/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 45,
      "wisdom": 75,
      "speed": 60,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/uLVl2r6.png"
  },
  {
    "id": "ZOTH-4/100",
    "displayName": "Lomma",
    "name": "Lomma",
    "subname": "",
    "set": "zoth",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": "Defender.\r\n:water:Water 5.\r\nThe first attack against Lomma each combat deals 10 less damage.",
    "flavorText": "After losing her family as a child, Lomma vowed that none would terrorize her tribe again.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "4/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 60,
      "wisdom": 70,
      "speed": 45,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/dtNjrcT.png"
  },
  {
    "id": "ZOTH-5/100",
    "displayName": "Raznus, Ambassador to the Danians",
    "name": "Raznus",
    "subname": "Ambassador to the Danians",
    "set": "zoth",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Ambassador",
    "ability": "Danian Creatures you control can play OverWorld Mugic.\r\nFireproof 10.",
    "flavorText": "Raznus yearned to forge an alliance. The Danians had other ideas.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "5/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 30,
      "wisdom": 80,
      "speed": 50,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/rdN6fa0.png"
  },
  {
    "id": "SS-1/100",
    "displayName": "Arbeid",
    "name": "Arbeid",
    "subname": "",
    "set": "ss",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": ":overworldmugic:: Target attack deals 5 damage. This ability can only be used once per turn.",
    "flavorText": "\"Keep attacking. I'll let you know when it stops tickling.\" — Arbeid",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Axer",
    "serialNumber": "1/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 40,
      "wisdom": 60,
      "speed": 45,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/EZIBZHo.png"
  },
  {
    "id": "SS-2/100",
    "displayName": "Clodor",
    "name": "Clodor",
    "subname": "",
    "set": "ss",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Warrior",
    "ability": "When Clodor wins a :wisdom:Wisdom Challenge on an attack it plays, put a Mugic counter on it.",
    "flavorText": "Without the harness, Clodor's unstable spark would have exploded and destroyed Perim long ago.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Gustavo, Etienne St.Laurent",
    "serialNumber": "2/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 65,
      "wisdom": 105,
      "speed": 45,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/MHJH2wy.png"
  },
  {
    "id": "SS-3/100",
    "displayName": "Hifdan",
    "name": "Hifdan",
    "subname": "",
    "set": "ss",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Scout",
    "ability": "When a Creature you control has Mugic counter put on it, Hifdan gains \"Range\" and \"Swift 2.\"",
    "flavorText": "Though feared by many for looking like an UnderWorlder, Hifdan is as loyal to Maxxor as they come.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Ryan Benjamin, Anthony Washington",
    "serialNumber": "3/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 35,
      "wisdom": 45,
      "speed": 45,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Vn2TYcj.png"
  },
  {
    "id": "SS-4/100",
    "displayName": "Iparu",
    "name": "Iparu",
    "subname": "",
    "set": "ss",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": "At the beginning of combat, Iparu gains or loses :courage:Courage, :power:Power, :wisdom:Wisdom and :speed:Speed so those values become equal to the opposing engaged Creature's Scanned :courage:Courage, :power:Power, :wisdom:Wisdom and :speed:Speed.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "4/100",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 35,
      "wisdom": 35,
      "speed": 35,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/1DHZIc1.png"
  },
  {
    "id": "SS-5/100",
    "displayName": "Kalt",
    "name": "Kalt",
    "subname": "",
    "set": "ss",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Elementalist Muge",
    "ability": ":overworldmugic:: Another target Creature gains an Elemental Type of your choice. If the target is an Elementalist Creature, put a Mugic counter on it. This ability can only be used once per turn.\r\n",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Hotshots VFX",
    "serialNumber": "5/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 40,
      "wisdom": 45,
      "speed": 50,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/1YCx5Vn.png"
  },
  {
    "id": "SS-6/100",
    "displayName": "Karraba",
    "name": "Karraba",
    "subname": "",
    "set": "ss",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Muge",
    "ability": ":overworldmugic:: Heal 10 damage to target Creature for each Mugic counter on Karraba. This ability can only be used once per turn.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, Anthony Washington",
    "serialNumber": "6/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 40,
      "wisdom": 50,
      "speed": 50,
      "energy": 40,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/vkN3Cao.png"
  },
  {
    "id": "SS-7/100",
    "displayName": "Kinnianne, Ambassador to the Mipedians",
    "name": "Kinnianne",
    "subname": "Ambassador to the Mipedians",
    "set": "ss",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Ambassador",
    "ability": "Mipedian Creatures you control are healed an additional 5 damage.\r\nKinnianne can play Mipedian Mugic.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez, David Curiel",
    "serialNumber": "7/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 45,
      "wisdom": 75,
      "speed": 70,
      "energy": 55,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/gyURTfp.png"
  },
  {
    "id": "SS-8/100",
    "displayName": "Olkiex",
    "name": "Olkiex",
    "subname": "",
    "set": "ss",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Strategist",
    "ability": "When a Creature you control has a Mugic counter put on it, flip target face-up Battlegear face-down.",
    "flavorText": "Though Bodal takes credit for the repairs, Olkiex loves working for such a \"charismatic\" boss.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, John Rauch",
    "serialNumber": "8/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 75,
      "wisdom": 80,
      "speed": 40,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/WKTLMlj.png"
  },
  {
    "id": "SS-9/100",
    "displayName": "Viqtarr",
    "name": "Viqtarr",
    "subname": "",
    "set": "ss",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Strategist",
    "ability": "If Viqtarr has both higher :courage:Courage and :wisdom:Wisdom than the opposing engaged Creature, the first attack against it each combat deals 0 damage.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "9/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 55,
      "wisdom": 85,
      "speed": 45,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/5FfAlfS.png"
  },
  {
    "id": "SS-10/100",
    "displayName": "Wytod",
    "name": "Wytod",
    "subname": "",
    "set": "ss",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Muge",
    "ability": "Sacrifice Wytod: Choose a new target for target Mugic which only targets a single Creature.",
    "flavorText": "Few Creatures have saved both Maxxor and Najarin's lives. None but Wytod have done so twice!\r\n\r\n",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "10/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 35,
      "wisdom": 65,
      "speed": 40,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/MjRdeoX.png"
  },
  {
    "id": "BTD-1/222",
    "displayName": "Accato",
    "name": "Accato",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Minion Warrior",
    "ability": "Support: :wisdom:Wisdom 10.",
    "flavorText": "",
    "brainwashedText": "Outperform :wisdom:Wisdom  5.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, Tim Kane, Anthony Washington",
    "serialNumber": "1/222",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 55,
      "wisdom": 80,
      "speed": 45,
      "energy": 70,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/MfQdTCL.png"
  },
  {
    "id": "BTD-2/222",
    "displayName": "Akkrean",
    "name": "Akkrean",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Guardian Muge",
    "ability": ":overworldmugic:: Deal 10 damage to target Creature on your side of the Battleboard.",
    "flavorText": "Rarely to enemies enter his lands, and almost never do they leave unscathed.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "2/222",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 50,
      "wisdom": 80,
      "speed": 55,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/7FC31s1.png"
  },
  {
    "id": "BTD-3/222",
    "displayName": "Frafdo, The Hero",
    "name": "Frafdo",
    "subname": "The Hero",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Hero Warrior",
    "ability": "While you control no other Creatures, Frafdo has an additional 45 Energy.",
    "flavorText": "\"Thirty against one? It hardly seems fair... for you.\" — Frafdo",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio LopezEtienne St.Laurent",
    "serialNumber": "3/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 80,
      "wisdom": 100,
      "speed": 95,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/cQBtCxM.png"
  },
  {
    "id": "BTD-4/222",
    "displayName": "Grindaald",
    "name": "Grindaald",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Caretaker Minion",
    "ability": ":overworldmugic:: Heal 10 damage to target Creature.",
    "flavorText": "",
    "brainwashedText": ":overworldmugic:: Heal 10 damage to target Creature and it loses 10 :wisdom:Wisdom.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, Anthony Washington",
    "serialNumber": "4/222",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 45,
      "wisdom": 70,
      "speed": 50,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Ko5wRG1.png"
  },
  {
    "id": "BTD-5/222",
    "displayName": "Gronmor",
    "name": "Gronmor",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Guardian Minion",
    "ability": "Support: all Disciplines 5.\r\n:fire:Fire 5.",
    "flavorText": "",
    "brainwashedText": "Support: Energy 5\r\nOutperform :wisdom:Wisdom  5",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Etienne St.Laurent",
    "serialNumber": "5/222",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 60,
      "wisdom": 90,
      "speed": 60,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/MTiPucZ.png"
  },
  {
    "id": "BTD-6/222",
    "displayName": "Ikkatosh, Guardian of Nature",
    "name": "Ikkatosh",
    "subname": "Guardian of Nature",
    "set": "btd",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": "When a Muge or Elementalist Creature you control wins combat, put a Mugic counter on it.",
    "flavorText": "Having lived for ages, Ikkatosh vaguely remembers the last time the Doors were open. It did not end well.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Keron Grant, Reggie Butler",
    "serialNumber": "6/222",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 45,
      "wisdom": 95,
      "speed": 70,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/sqAOliy.png"
  },
  {
    "id": "BTD-7/222",
    "displayName": "Issaley",
    "name": "Issaley",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Caretaker Minion",
    "ability": ":water:Water 5.",
    "flavorText": "",
    "brainwashedText": "Opposing Creatures with :water:Water  have \"Exhaust all Disciplines 10.\"",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "7/222",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 60,
      "wisdom": 85,
      "speed": 50,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/3tcdheR.png"
  },
  {
    "id": "BTD-8/222",
    "displayName": "Lystone",
    "name": "Lystone",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Minion Muge",
    "ability": ":overworldmugic::overworldmugic:: Target Creature gains 30 to all Disciplines.",
    "flavorText": "",
    "brainwashedText": ":overworldmugic:: Target Creature gains 10 to all Disciplines.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "8/222",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 40,
      "wisdom": 70,
      "speed": 35,
      "energy": 35,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/LmryGcT.png"
  },
  {
    "id": "BTD-9/222",
    "displayName": "Okaxor",
    "name": "Okaxor",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Caretaker Minion",
    "ability": ":overworldmugic:: Target Creature gains 25 to a Discipline of your choice.",
    "flavorText": "",
    "brainwashedText": ":overworldmugic:: Target Mugic or ability cannot increase or decrease any Creature's Disciplines.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "9/222",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 35,
      "wisdom": 85,
      "speed": 40,
      "energy": 45,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/PCiISR1.png"
  },
  {
    "id": "BTD-10/222",
    "displayName": "Tangath Toborn, In Training",
    "name": "Tangath Toborn",
    "subname": "In Training",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Hero Warrior",
    "ability": ":overworldmugic:: Tangath Toborn gains or loses :courage:Courage, :power:Power, :wisdom:Wisdom and :speed:Speed to make its Disciplines equal to its Scanned Disciplines.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "10/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 85,
      "wisdom": 95,
      "speed": 45,
      "energy": 70,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/lHo9ZgZ.png"
  },
  {
    "id": "BTD-11/222",
    "displayName": "Targubaj",
    "name": "Targubaj",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Minion Muge",
    "ability": ":overworldmugic:: Heal 10 damage to target engaged Creature.",
    "flavorText": "",
    "brainwashedText": ":overworldmugic:: Relocate target opposing unengaged Creature to any unoccupied space on the Battleboard adjacent to it.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "11/222",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 65,
      "wisdom": 75,
      "speed": 60,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/GMMueqZ.png"
  },
  {
    "id": "BTD-12/222",
    "displayName": "Tartarek, Psi Overloader",
    "name": "Tartarek",
    "subname": "Psi Overloader",
    "set": "btd",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Hero Minion",
    "ability": ":overworldmugic:: Target Creature gains 35 :wisdom:Wisdom. \r\nDiscard an OverWorld Mugic Card: Destroy target Chieftain Creature with 100 or more :wisdom:Wisdom. ",
    "flavorText": "",
    "brainwashedText": "Tartarek can activate its normal abilities.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "12/222",
    "isPast": false,
    "stats": {
      "courage": 110,
      "power": 50,
      "wisdom": 110,
      "speed": 70,
      "energy": 70,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/PBnLOL0.png"
  },
  {
    "id": "BTD-13/222",
    "displayName": "Trimdaal",
    "name": "Trimdaal",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Minion Elementalist",
    "ability": ":fire:Fire 5.",
    "flavorText": "",
    "brainwashedText": ":water:Water  5",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Etienne St.Laurent",
    "serialNumber": "13/222",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 60,
      "wisdom": 90,
      "speed": 50,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/7Mlz2Ah.png"
  },
  {
    "id": "BTD-14/222",
    "displayName": "Wrenges",
    "name": "Wrenges",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Minion Muge",
    "ability": ":overworldmugic:: Heal 15 damage to target engaged Creature.",
    "flavorText": "",
    "brainwashedText": ":overworldmugic: Heal 10 damage to target Creature. If that Creature is on your side of the Battleboard, it also gains 10 to all Disciplines.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, David Curiel",
    "serialNumber": "14/222",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 35,
      "wisdom": 55,
      "speed": 50,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/WXMyH9e.png"
  },
  {
    "id": "ROTO-1/100",
    "displayName": "Aivenna",
    "name": "Aivenna",
    "subname": "",
    "set": "roto",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Hero Warrior",
    "ability": "Outperform :courage:Courage 5.\r\nOutperform :wisdom:Wisdom 5.\r\nWhile you control a Muge Creature, Aivenna has \"Support: all Disciplines 5.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "1/100",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 60,
      "wisdom": 100,
      "speed": 50,
      "energy": 75,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/WkEWX1F.png"
  },
  {
    "id": "ROTO-2/100",
    "displayName": "Arrthoa",
    "name": "Arrthoa",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Minion Scout",
    "ability": "While an opposing Creature has :water:Water, Arrthoa has \"Range\" and \"Swift 1.\"",
    "flavorText": "",
    "brainwashedText": "While an opposing Creature has Swift, Arrthoa has \"Defender.\"",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "2/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 60,
      "wisdom": 75,
      "speed": 70,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/tvsXijD.png"
  },
  {
    "id": "ROTO-3/100",
    "displayName": "Attacat, Tactical Aide",
    "name": "Attacat",
    "subname": "Tactical Aide",
    "set": "roto",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Strategist Minion",
    "ability": ":overworldmugic:: Heal 10 damage to target adjacent OverWorld Creature.\r\nSwift 2.",
    "flavorText": "",
    "brainwashedText": ":overworldmugic:: Heal 10 damage to target adjacent M'arrillian Creature.\r\nRange, Swift 1",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "3/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 45,
      "wisdom": 65,
      "speed": 110,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/PTSY3Hd.png"
  },
  {
    "id": "ROTO-4/100",
    "displayName": "Biakan",
    "name": "Biakan",
    "subname": "",
    "set": "roto",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Caretaker Minion",
    "ability": "If an opponent would reveal a new active Location on your turn, instead you reveal a new active Location.",
    "flavorText": "",
    "brainwashedText": "When an opposing Creature wins Initiative, reveal the top card of your Location Deck and it becomes the new active Location.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, VJ Comando",
    "serialNumber": "4/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 55,
      "wisdom": 85,
      "speed": 50,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/x8yZ2WU.png"
  },
  {
    "id": "ROTO-5/100",
    "displayName": "Gimwei",
    "name": "Gimwei",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Minion Elementalist",
    "ability": ":fire:Fire 5.\r\nWhen Gimwei is dealt 20 or more damage from a single source, deal 5 damage to target Creature.",
    "flavorText": "",
    "brainwashedText": "Outperform :wisdom:Wisdom  5.\r\nWhen Gimwei deals 20 or more damage with a single attack, it gains 20 to all Disciplines.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Axer",
    "serialNumber": "5/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 50,
      "wisdom": 95,
      "speed": 45,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ytAjT6x.png"
  },
  {
    "id": "ROTO-6/100",
    "displayName": "Hune Paltanin",
    "name": "Hune Paltanin",
    "subname": "",
    "set": "roto",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Caretaker",
    "ability": "When a Mugic counter is removed from an opposing non-OverWorld Creature, heal 10 damage to target Creature.",
    "flavorText": "She is rarely seen outside the Library, but Maxxor needs all the help he can get.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Keron Grant, Anthony Washington",
    "serialNumber": "6/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 25,
      "wisdom": 120,
      "speed": 25,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/JCQq99d.png"
  },
  {
    "id": "ROTO-7/100",
    "displayName": "Najarin, Fluidmorphers' Foe",
    "name": "Najarin",
    "subname": "Fluidmorphers' Foe",
    "set": "roto",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Hero Strategist",
    "ability": "When an opposing Creature not named Najarin has a Mugic counter put on it, put a Mugic counter on Najarin.\r\n:overworldmugic:: Target Creature gains 5 Energy.\r\n:overworldmugic::overworldmugic:: Negate target M'arrillian Mugic.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "7/100",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 45,
      "wisdom": 80,
      "speed": 55,
      "energy": 30,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/flW5rXo.png"
  },
  {
    "id": "TOTT-1/100",
    "displayName": "Drabe",
    "name": "Drabe",
    "subname": "",
    "set": "tott",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Caretaker Muge",
    "ability": ":overworldmugic:: Target Creature gains 15 Energy.",
    "flavorText": "Each tattoo symbolizes a fallen friend. Drabe fears he will add several more before the fighting is done.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "1/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 40,
      "wisdom": 75,
      "speed": 45,
      "energy": 55,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/jlnrNXb.png"
  },
  {
    "id": "TOTT-2/100",
    "displayName": "Intress, Natureforce",
    "name": "Intress",
    "subname": "Natureforce",
    "set": "tott",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": ":overworldmugic:: Creatures you control gain 5 Energy for each Elemental Type they have.",
    "flavorText": "\"Despite our differences, since the Cothica flows through each of us, we are all united.\"— Intress",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "2/100",
    "isPast": false,
    "stats": {
      "courage": 105,
      "power": 75,
      "wisdom": 100,
      "speed": 80,
      "energy": 60,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/PEbOdN2.png"
  },
  {
    "id": "TOTT-3/100",
    "displayName": "Jaidwarl",
    "name": "Jaidwarl",
    "subname": "",
    "set": "tott",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Minion Elementalist",
    "ability": ":overworldmugic:: Target Creature gains all Elemental Types your Creatures have.",
    "flavorText": "",
    "brainwashedText": ":overworldmugic:: Target Creature loses all Elemental Types your Creatures have.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "3/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 55,
      "wisdom": 80,
      "speed": 40,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/we4S9Qs.png"
  },
  {
    "id": "TOTT-4/100",
    "displayName": "Olkiex, Driver Extraordinaire",
    "name": "Olkiex",
    "subname": "Driver Extraordinaire",
    "set": "tott",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Strategist",
    "ability": "When Olkiex plays an Attack Card while equipped, it gains 5 Energy.",
    "flavorText": "It only took six straight Prototype Demolition Field victories for Bodal to acknowledge that Olkiex was a \"capable\" driver.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, Axer",
    "serialNumber": "4/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 60,
      "wisdom": 50,
      "speed": 45,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Ome3qEX.png"
  },
  {
    "id": "TOTT-13/100",
    "displayName": "Ørth, The Empowerer",
    "name": "Ørth",
    "subname": "The Empowerer",
    "set": "tott",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": "If the Initiative of the active Location is an Elemental Type, your engaged Creature has \"Element 5\" in that Elemental Type.",
    "flavorText": "Alliances can be forged in the heat of battle, but trust? That is not as easy.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, David Curiel",
    "serialNumber": "13/100",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 110,
      "wisdom": 50,
      "speed": 30,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/UCXs13Z.png"
  },
  {
    "id": "TOTT-20/100",
    "displayName": "Rellim, Watermaster",
    "name": "Rellim",
    "subname": "Watermaster",
    "set": "tott",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Caretaker Minion",
    "ability": "Other Creatures you control with :water:Water have an additional 10 Energy.",
    "flavorText": "",
    "brainwashedText": "M'arrillian Creatures you control have \":water:Water  5.\"",
    "brainwashed": true,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "20/100",
    "isPast": false,
    "stats": {
      "courage": 95,
      "power": 85,
      "wisdom": 65,
      "speed": 35,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/mGZmkuE.png"
  },
  {
    "id": "TOTT-21/100",
    "displayName": "Xaerv, Monsoon Defender",
    "name": "Xaerv",
    "subname": "Monsoon Defender",
    "set": "tott",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": "Waterproof 10 \r\nXaerv deals an additional 5 attack damage to Creatures with :water:Water.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Axer",
    "serialNumber": "21/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 40,
      "wisdom": 90,
      "speed": 80,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/4pMX4eP.png"
  },
  {
    "id": "FUN-1/100",
    "displayName": "Aivenna, OverWorld Lieutenant",
    "name": "Aivenna",
    "subname": "OverWorld Lieutenant",
    "set": "fun",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Hero Warrior",
    "ability": ":overworldmugic:: Heal 5 damage to target Creature for each Tribe you control. \r\nWhile you control only Aivenna and Nivenna, Aivenna has an additional 20 Energy and \"Defender.\" ",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "1/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 75,
      "wisdom": 100,
      "speed": 45,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/WJPCV3y.png"
  },
  {
    "id": "FUN-2/100",
    "displayName": "Akkerbal",
    "name": "Akkerbal",
    "subname": "",
    "set": "fun",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": "While you control a Mipedian Creature, damage dealt by the first Attack to Akkerbal each combat is reduced to 0.",
    "flavorText": "The M'arrillians were confused why Akkerbal hated them so much. Don't cactuses like water?",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, David Curiel",
    "serialNumber": "2/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 40,
      "wisdom": 85,
      "speed": 65,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/P5aEZAv.png"
  },
  {
    "id": "FUN-3/100",
    "displayName": "Blügon, Winter Warrior",
    "name": "Blügon",
    "subname": "Winter Warrior",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Minion Warrior",
    "ability": ":overworldmugic::overworldmugic:: Target attack counts as the first attack played this combat.",
    "flavorText": "",
    "brainwashedText": ":overworldmugic::overworldmugic:: Target attack does not count as the first attack played this combat.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "serialNumber": "3/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 50,
      "wisdom": 85,
      "speed": 55,
      "energy": 55,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/kclkHmc.png"
  },
  {
    "id": "FUN-4/100",
    "displayName": "Hune Marquard, Brainwashed Scholar",
    "name": "Hune Marquard",
    "subname": "Brainwashed Scholar",
    "set": "fun",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Minion Muge",
    "ability": "Danian Creatures you control can play OverWorld Mugic.",
    "flavorText": "",
    "brainwashedText": "Creatures you control that are a M'arrillian or a Minion cannot be Infected.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, David Curiel",
    "serialNumber": "4/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 40,
      "wisdom": 80,
      "speed": 55,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/GUy2aQZ.png"
  },
  {
    "id": "FUN-5/100",
    "displayName": "Loderool",
    "name": "Loderool",
    "subname": "",
    "set": "fun",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Warrior",
    "ability": "While you control an UnderWorld Creature, Loderool has \":fire:Fire 5.\"",
    "flavorText": "\"This alliance changes nothing! I've still never met an UnderWorlder that I liked!\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, David Curiel",
    "serialNumber": "5/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 80,
      "wisdom": 60,
      "speed": 40,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/XuizC06.png"
  },
  {
    "id": "FUN-6/100",
    "displayName": "Maxxor, Protector of Perim",
    "name": "Maxxor",
    "subname": "Protector of Perim",
    "set": "fun",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Hero Warrior",
    "ability": "When Maxxor is dealt attack damage, it gains \"Maxxor deals an additional 5 attack damage.\"",
    "flavorText": "\"I don't just fight for the OverWorld! I fight for all of Perim!\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "6/100",
    "isPast": false,
    "stats": {
      "courage": 120,
      "power": 65,
      "wisdom": 90,
      "speed": 55,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/H2jqzfR.png"
  },
  {
    "id": "FUN-7/100",
    "displayName": "Tangath Toborn, OverWorld General",
    "name": "Tangath Toborn",
    "subname": "OverWorld General",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Strategist Warrior",
    "ability": "Defender.\r\nOn an opponent's turn, Tangath Toborn has:\r\n\":fire:Fire 5\" while you control an UnderWorld Creature.\r\n\"Disarm\" while you control a Mipedian Creature.\r\n\"Elementproof all Elemental Types 5\" while you control a Danian Creature.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": true,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington, Emilio Lopez",
    "serialNumber": "7/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 85,
      "wisdom": 105,
      "speed": 45,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/QD9rLXB.png"
  },
  {
    "id": "FUN-8/100",
    "displayName": "Vidav, Master Strategist",
    "name": "Vidav",
    "subname": "Master Strategist",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Strategist",
    "ability": ":overworldmugic:: Choose a Tribe. Target Creature also counts as the chosen Tribe.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "8/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 35,
      "wisdom": 115,
      "speed": 40,
      "energy": 45,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/U9Z2ZwY.png"
  },
  {
    "id": "AU-S05/26",
    "displayName": "Afjak",
    "name": "Afjak",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Muge",
    "ability": "Sacrifice Afjak: Put a Mugic counter on target Creature you control.",
    "flavorText": "Najarin's apprentice was his proudest success... and his greatest sadness.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent, Chris Fisher",
    "serialNumber": "S05/26",
    "isPast": true,
    "stats": {
      "courage": 90,
      "power": 50,
      "wisdom": 75,
      "speed": 40,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/tMNmpyK.png"
  },
  {
    "id": "AU-1/200",
    "displayName": "Arrthoa, Captain of the Ezoa",
    "name": "Arrthoa",
    "subname": "Captain of the Ezoa",
    "set": "au",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Hero Scout",
    "ability": "Your other Creatures with :water:Water succeed on all Stat Checks on attacks they play.",
    "flavorText": "\"Avast me hearties! Come about, hard starboard! The citadel is taking flight!\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Reggie Butler",
    "serialNumber": "1/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 55,
      "wisdom": 80,
      "speed": 70,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/O5poqns.png"
  },
  {
    "id": "AU-2/200",
    "displayName": "Blazier, Citadel Cartographer",
    "name": "Blazier",
    "subname": "Citadel Cartographer",
    "set": "au",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Scout",
    "ability": "Expend :earth:Earth: Look at the top card of your Location Deck. You can put that card on the bottom of that deck.",
    "flavorText": "Blazier strives to be the first to discover new lands. History doesn't care about whoever comes second.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Bob Rivard",
    "serialNumber": "2/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 50,
      "wisdom": 70,
      "speed": 50,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/tpCDkAN.png"
  },
  {
    "id": "AU-3/200",
    "displayName": "Dalgad",
    "name": "Dalgad",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Elementalist Scout",
    "ability": "Dalgad deals an additional 5 damage with Elemental Attacks.",
    "flavorText": "\"The powers of the elements can make even the smallest Creatures mighty.\" — Heptadd",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "3/200",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 80,
      "wisdom": 85,
      "speed": 50,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/oKW5XO1.png"
  },
  {
    "id": "AU-4/200",
    "displayName": "Donmar, Tablet Translator",
    "name": "Donmar",
    "subname": "Tablet Translator",
    "set": "au",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Caretaker",
    "ability": "Expend :water:Water: Heal 10 damage to target Creature.",
    "flavorText": "The glyphs on the First Tree which stands at the center of the Runic Grove speak only to him. They cry, \"Change is coming!\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Bob Rivard",
    "serialNumber": "4/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 50,
      "wisdom": 85,
      "speed": 40,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/iMysnJw.png"
  },
  {
    "id": "AU-5/200",
    "displayName": "Eremia",
    "name": "Eremia",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Elementalist Warrior",
    "ability": "When another Creature you control loses an Elemental Type, Eremia gains that Elemental Type.",
    "flavorText": "\"Those who deplete the powers of the elements must pay a tax to nature itself, and I am here to ensure it gets collected.\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios Emilio Lopez",
    "serialNumber": "5/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 70,
      "wisdom": 75,
      "speed": 55,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/QF4Zhcz.png"
  },
  {
    "id": "AU-6/200",
    "displayName": "Herken",
    "name": "Herken",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Caretaker",
    "ability": ":overworldmugic:: Heal 10 damage to target Creature. If that Creature has :water:Water, heal 20 damage instead.",
    "flavorText": "Despite numerous pleas, Herken refuses to reveal his secret ingredient.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Reggie Bulter",
    "serialNumber": "6/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 35,
      "wisdom": 85,
      "speed": 40,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/ZleuUaz.png"
  },
  {
    "id": "AU-7/200",
    "displayName": "Hune Canin",
    "name": "Hune Canin",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Muge",
    "ability": "Expend :fire:Fire: Target Creature gains or loses all Disciplines so they become their scanned values.",
    "flavorText": "Calm, contemplative, subdued: the exact opposite of his daughter, Kinnianne. He blames that on her mother.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "7/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 60,
      "wisdom": 85,
      "speed": 40,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/tQ3TIvM.png"
  },
  {
    "id": "AU-8/200",
    "displayName": "Illiar",
    "name": "Illiar",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Warrior",
    "ability": "Damage dealt to Illiar by Attacks with 2 Build Points is reduced to 0.",
    "flavorText": "While he can wield six weapons at once, few realize his most powerful weapon is his mind.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Reggie Butler",
    "serialNumber": "8/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 50,
      "wisdom": 90,
      "speed": 70,
      "energy": 60,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/YLTjB1s.png"
  },
  {
    "id": "AU-9/200",
    "displayName": "Iparu, Metallic Ally",
    "name": "Iparu",
    "subname": "Metallic Ally",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Hero",
    "ability": "At the beginning of each turn, Iparu becomes a copy of target opposing Creature.\r\n(Iparu's scanned characteristics become the same as the target's including Disciplines, Elemental Types, Energy, and abilities.)",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "9/200",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 60,
      "speed": 60,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/soIKSRD.png"
  },
  {
    "id": "AU-S06/26",
    "displayName": "Korg",
    "name": "Korg",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": ":overworldmugic:: Heal 10 damage to target Creature for each Creature your opponent controls on your side of the Battleboard.",
    "flavorText": "Korg can remain immobile for days to get the jump on his unsuspecting prey.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keith Conroy, Etienne St.Laurent",
    "serialNumber": "S06/26",
    "isPast": true,
    "stats": {
      "courage": 70,
      "power": 45,
      "wisdom": 80,
      "speed": 35,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/5lwWGko.png"
  },
  {
    "id": "AU-10/200",
    "displayName": "Lomma, Desert Wanderer",
    "name": "Lomma",
    "subname": "Desert Wanderer",
    "set": "au",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": "Defender\r\n:overworldmugic::overworldmugic:: Target Elemental Attack deals 0 damage to Lomma.",
    "flavorText": "Catching the scent of the brute who destroyed her family, Lomma can finally get her revenge after all these years. But at what cost?",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Axer",
    "serialNumber": "10/200",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 55,
      "wisdom": 85,
      "speed": 55,
      "energy": 65,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/AzOIIGR.png"
  },
  {
    "id": "AU-11/200",
    "displayName": "Maglax, Lodestone Seeker",
    "name": "Maglax",
    "subname": "Lodestone Seeker",
    "set": "au",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Guardian Scout",
    "ability": "Expend :fire:Fire while engaged: When target attack deals damage, deal the same amount of damage to the Creature that played that attack.",
    "flavorText": "The immense magnetic powers of Maglax revealed the remarkable properties of the Citadel Lodestone.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "11/200",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 70,
      "wisdom": 50,
      "speed": 50,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/An0SvNQ.png"
  },
  {
    "id": "AU-12/200",
    "displayName": "Najarin, High Muge of the Lake",
    "name": "Najarin",
    "subname": "High Muge of the Lake",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Muge",
    "ability": "Najarin pays 1 less Mugic counter to play Mugic Cards to a minimum of 1.",
    "flavorText": "\"After all the marvels I've seen him preform, I still don't know the limits to Najarin's power... or if there are any!\" — Maxxor",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Bob Rivard",
    "serialNumber": "12/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 40,
      "wisdom": 110,
      "speed": 40,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/BXi0OqE.png"
  },
  {
    "id": "AU-S07/26",
    "displayName": "Najarin, Younger",
    "name": "Najarin",
    "subname": "Younger",
    "set": "au",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Muge",
    "ability": ":overworldmugic:: Return target Mugic Card from your general discard pile to your hand, then discard a Mugic Card.",
    "flavorText": "Little did he know then that his name would become synonymous with history itself.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Bob RIvard",
    "serialNumber": "S07/26",
    "isPast": true,
    "stats": {
      "courage": 70,
      "power": 40,
      "wisdom": 100,
      "speed": 40,
      "energy": 30,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/n9zlzC0.png"
  },
  {
    "id": "AU-13/200",
    "displayName": "Porthyn",
    "name": "Porthyn",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": ":overworldmugic:: All non-attack damage that would be dealt to target adjacent Creature is dealt to Porthyn instead.",
    "flavorText": "Najarin looks only ahead, for he has no need to watch his back.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Axer",
    "serialNumber": "13/200",
    "isPast": false,
    "stats": {
      "courage": 100,
      "power": 60,
      "wisdom": 70,
      "speed": 60,
      "energy": 60,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/zb7edP4.png"
  },
  {
    "id": "AU-14/200",
    "displayName": "Silchaw",
    "name": "Silchaw",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": "At the beginning of combat, if the Initiative of the active Location is an Elemental Type, your engaged Creature gains that Elemental Type.",
    "flavorText": "His uncanny ability to smell Vlarium earned him the name \"Major Miner.\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "serialNumber": "14/200",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 50,
      "wisdom": 70,
      "speed": 40,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/xOXBXPi.png"
  },
  {
    "id": "AU-15/200",
    "displayName": "Somnort",
    "name": "Somnort",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Guardian Warrior",
    "ability": "Defender: :water:Water.",
    "flavorText": "Somnort's heart skipped a beat when he realized that Taffial had found the lost city of the ancient Mipedian King Kehn-sep.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "serialNumber": "15/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 40,
      "wisdom": 75,
      "speed": 55,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/zIPchva.png"
  },
  {
    "id": "AU-16/200",
    "displayName": "Unda, Servant of Water",
    "name": "Unda",
    "subname": "Servant of Water",
    "set": "au",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": ":overworldmugic:: Target Creature gains :water:Water.",
    "flavorText": "\"I am the servant to the Emperor of Water, and I am at your service, OverWorlders.\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Axer",
    "serialNumber": "16/200",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 45,
      "wisdom": 90,
      "speed": 55,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/GYs1WxS.png"
  },
  {
    "id": "AU-S08/26",
    "displayName": "Vlar",
    "name": "Vlar",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Scout",
    "ability": "At the beginning of combat, if Vlar is unequipped, all Battlegear equipped to the opposing engaged Creature becomes equipped to Vlar.\r\n(Players control any Battlegear equipped to Creatures they control.)",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Bob Rivard",
    "serialNumber": "S08/26",
    "isPast": true,
    "stats": {
      "courage": 90,
      "power": 70,
      "wisdom": 60,
      "speed": 70,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/lDPMaiy.png"
  },
  {
    "id": "FAS-15/100",
    "displayName": "Bidua",
    "name": "Bidua",
    "subname": "",
    "set": "fas",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Scout",
    "ability": "Expend :earth:Earth while engaged: The opposing engaged Creature loses Invisibility.",
    "flavorText": "With his keen eyesight, Bidua can see even the faint shimmering of invisible Mipedians.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "15/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 40,
      "wisdom": 80,
      "speed": 95,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/YrEcFRl.png"
  },
  {
    "id": "FAS-11/100",
    "displayName": "Bodal, Flamedrill Researcher",
    "name": "Bodal",
    "subname": "Flamedrill Researcher",
    "set": "fas",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Hero",
    "ability": "Expend :earth:Earth: Return target Battlegear Card in your general discard pile to play equipped to another unequipped Creature you control.\r\nExpend :fire:Fire: Destroy a Battlegear you control. If you do, destroy target Battlegear.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Axer",
    "serialNumber": "11/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 30,
      "wisdom": 90,
      "speed": 40,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/eOTf2US.png"
  },
  {
    "id": "FAS-7/100",
    "displayName": "Maxxor, Elemental Champion",
    "name": "Maxxor",
    "subname": "Elemental Champion",
    "set": "fas",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Hero",
    "ability": "Expend :fire:Fire: The next attack played by Maxxor this turn deals an additional 10 damage.\r\nExpend :earth:Earth: The next attack played by the opposing engaged Creature this turn deals 10 less damage to Maxxor.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez, Anthony Washington",
    "serialNumber": "7/100",
    "isPast": false,
    "stats": {
      "courage": 110,
      "power": 60,
      "wisdom": 80,
      "speed": 60,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/Se7b4Od.png"
  },
  {
    "id": "OP-OP1-1/20",
    "displayName": "Nebres",
    "name": "Nebres",
    "subname": "",
    "set": "op",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Warrior",
    "ability": "Support: :power:Power 5.",
    "flavorText": "As the three-time reigning champion of the Perim Battle Royal, Nebres is one of the few OverWorlders who has earned the respect of all tribes, even the UnderWorlders.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Various Artists",
    "serialNumber": "OP1-1/20",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 90,
      "wisdom": 55,
      "speed": 60,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/emvYdcV.png"
  },
  {
    "id": "OP-OP1-2/20",
    "displayName": "Neffa",
    "name": "Neffa",
    "subname": "",
    "set": "op",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Strategist",
    "ability": "Support: :wisdom:Wisdom 5.",
    "flavorText": "No matter how many times he recalculated the ancient equations, the solution always added up to seven.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "OP1-2/20",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 35,
      "wisdom": 90,
      "speed": 45,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/xKmJRZt.png"
  },
  {
    "id": "OP-OP1-3/20",
    "displayName": "Sukoval",
    "name": "Sukoval",
    "subname": "",
    "set": "op",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": "Swift 1.",
    "flavorText": "The thin layer of mucus secreted from his pores not only keeps Sukoval warm, but it also allows him to slither on land.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "OP1-3/20",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 65,
      "wisdom": 90,
      "speed": 65,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/arHZoyO.png"
  },
  {
    "id": "DOP-BR-01",
    "displayName": "Ettala",
    "name": "Ettala",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Guardian",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios",
    "serialNumber": "BR-01",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 60,
      "wisdom": 30,
      "speed": 40,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/UBXVukQ.png"
  },
  {
    "id": "DOP-BR-03",
    "displayName": "Hoton",
    "name": "Hoton",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Strategist",
    "ability": "Support: :wisdom:Wisdom 5.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, David Curiel, David Rodriguez",
    "serialNumber": "BR-03",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 35,
      "wisdom": 90,
      "speed": 45,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ONC4x13.png"
  },
  {
    "id": "DOP-BR-02",
    "displayName": "Mezzmarr",
    "name": "Mezzmarr",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Scout",
    "ability": "Swift 1.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "BR-02",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 65,
      "wisdom": 65,
      "speed": 65,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/yA4aM2R.png"
  },
  {
    "id": "DOP-BR-10",
    "displayName": "Mommark",
    "name": "Mommark",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Caretaker",
    "ability": ":overworldmugic:: Heal 10 damage to target Creature.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, Etienne St.Laurent",
    "serialNumber": "BR-10",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 30,
      "wisdom": 55,
      "speed": 45,
      "energy": 35,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/AvVCrmR.png"
  },
  {
    "id": "DOP-BR-05",
    "displayName": "Prantix",
    "name": "Prantix",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Caretaker",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "BR-05",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 60,
      "wisdom": 40,
      "speed": 50,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/1apY0zO.png"
  },
  {
    "id": "DOP-BR-06",
    "displayName": "Quadore",
    "name": "Quadore",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "overworld",
    "subtype": "Muge",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "BR-06",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 30,
      "wisdom": 75,
      "speed": 70,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/fKTvtez.png"
  },
  {
    "id": "DOP-BR-07",
    "displayName": "Ulfhedinn",
    "name": "Ulfhedinn",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "overworld",
    "subtype": "Warrior",
    "ability": "Support: :power:Power 5.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "BR-07",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 90,
      "wisdom": 55,
      "speed": 60,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/SC3oLmx.png"
  },
  {
    "id": "OP-LR01/10",
    "displayName": "Ebkeex, Patchwork Minion",
    "name": "Ebkeex",
    "subname": "Patchwork Minion",
    "set": "op",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Minion Elementalist",
    "ability": "At the beginning of combat, Ebkeex gains all Elemental Types your Creatures have.",
    "flavorText": "",
    "brainwashedText": "At the beginning of combat, Ebkeex gains all Elemental Types opposing Creatures have.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, David Curiel",
    "serialNumber": "LR01/10",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 50,
      "wisdom": 90,
      "speed": 90,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/OHOiRSt.png"
  },
  {
    "id": "OP-LR02/10",
    "displayName": "Mommark, Clonemaster",
    "name": "Mommark",
    "subname": "Clonemaster",
    "set": "op",
    "rarity": "ultra rare",
    "tribe": "overworld",
    "subtype": "Muge",
    "ability": "At the beginning of your turn, put a Mugic counter on Mommark.\r\nWhen another Creature you control is sent to the discard, remove all Mugic counters from Mommark. If you have removed 5 or more Mugic counters this way, return that Creature to play in an unoccupied space.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, Andrew Bradshaw, Etienne St.Laurent",
    "serialNumber": "LR02/10",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 40,
      "wisdom": 95,
      "speed": 95,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/AvVCrmR.png"
  },
  {
    "id": "DOP-P-002",
    "displayName": "Antidaeon",
    "name": "Antidaeon",
    "subname": "",
    "set": "dop",
    "rarity": "promo",
    "tribe": "overworld",
    "subtype": "Scout",
    "ability": "",
    "flavorText": "With thousands of hidden waterways linking the OverWorld and UnderWorld, Antidaeon remains in constant alert against enemy invasion.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, John Rauch",
    "serialNumber": "P-002",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 70,
      "wisdom": 50,
      "speed": 80,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/vvlkSQe.png"
  },
  {
    "id": "DOP-P-016",
    "displayName": "Ettala, Mind Controlled Brute",
    "name": "Ettala",
    "subname": "Mind Controlled Brute",
    "set": "dop",
    "rarity": "promo",
    "tribe": "overworld",
    "subtype": "Guardian Minion",
    "ability": ":earth:Earth 5.",
    "flavorText": "",
    "brainwashedText": "Ettala has an additional 30 :power:Power  and 30 less :wisdom:Wisdom.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Axer",
    "serialNumber": "P-016",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 95,
      "wisdom": 50,
      "speed": 40,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/pC1wtG4.png"
  },
  {
    "id": "DOP-P-010",
    "displayName": "Ikkatosh, The Aich King",
    "name": "Ikkatosh",
    "subname": "The Aich King",
    "set": "dop",
    "rarity": "promo",
    "tribe": "overworld",
    "subtype": "Guardian Hero",
    "ability": "At the beginning of combat, if your engaged Creature has no Elemental Types, it gains 20 Energy.",
    "flavorText": "The Aich King brings the power of nature even to those who cannot touch it themselves.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, Chris Fisher",
    "serialNumber": "P-010",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 30,
      "wisdom": 90,
      "speed": 50,
      "energy": 30,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/cYfXRtC.png"
  },
  {
    "id": "DOP-P-001",
    "displayName": "Raimusa",
    "name": "Raimusa",
    "subname": "",
    "set": "dop",
    "rarity": "promo",
    "tribe": "overworld",
    "subtype": "Warrior",
    "ability": "",
    "flavorText": "The vicious winds of the Crystal Range slash the flesh but sharpen the soul.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "P-001",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 75,
      "wisdom": 50,
      "speed": 55,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/rfooNei.png"
  },
  {
    "id": "FUN-P-015",
    "displayName": "Simalin",
    "name": "Simalin",
    "subname": "",
    "set": "fun",
    "rarity": "promo",
    "tribe": "overworld",
    "subtype": "Elementalist Warrior",
    "ability": "The first attack against Simalin each combat deals 20 less damage.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Jay Axer",
    "serialNumber": "P-015",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 60,
      "wisdom": 50,
      "speed": 70,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/ooDWlRs.png"
  },
  {
    "id": "TOTT-P-006",
    "displayName": "Yokkis, Spooker",
    "name": "Yokkis",
    "subname": "Spooker",
    "set": "tott",
    "rarity": "promo",
    "tribe": "overworld",
    "subtype": "Hero Scout",
    "ability": "Surprise.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tom Baxa",
    "serialNumber": "P-006",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 40,
      "wisdom": 60,
      "speed": 85,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Lh9l6SJ.png"
  },
  {
    "id": "FAS-newclxw4",
    "displayName": "Arctus, Heptadd's Squire",
    "name": "Arctus",
    "subname": "Heptadd's Squire",
    "set": "fas",
    "rarity": "super rare",
    "tribe": "overworld",
    "subtype": "Elementalist",
    "ability": "At the beginning of combat, Arctus gains all Elemental Types your adjacent Creatures have.",
    "flavorText": "As Arctus launched his Allmageddon attack, Bodal calculated that in 14.9 seconds, Rath'tab would become a very wise pool of blue jelly.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 110,
      "power": 60,
      "wisdom": 85,
      "speed": 50,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ccyuO1K.png"
  },
  {
    "id": "DOP-29/232",
    "displayName": "Barath Beyond",
    "name": "Barath Beyond",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Ethereal Warrior",
    "ability": ":fire:Fire 5.\r\nIntimidate: :power:Power 10.\r\nRecklessness 5.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "29/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 95,
      "wisdom": 25,
      "speed": 75,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ShAshqe.png"
  },
  {
    "id": "DOP-30/232",
    "displayName": "Borth-Majar",
    "name": "Borth-Majar",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "Intimidate: :power:Power 10.\r\nIntimidate: :wisdom:Wisdom 10.",
    "flavorText": "Brains or Brawn? One can’t decide ... and one doesn’t need to.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Reggie Butler",
    "serialNumber": "30/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 95,
      "wisdom": 95,
      "speed": 50,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/vwbHfcG.png"
  },
  {
    "id": "DOP-31/232",
    "displayName": "Chaor",
    "name": "Chaor",
    "subname": "",
    "set": "dop",
    "rarity": "ultra rare",
    "tribe": "underworld",
    "subtype": "Conqueror Warrior",
    "ability": ":underworldmugic::underworldmugic::underworldmugic:: Negate target OverWorld Mugic or ability that targets Chaor.",
    "flavorText": "\"We’ll take Kiru City, and the UnderWorld will rule all of Perim!\" - Chaor",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "31/232",
    "isPast": false,
    "stats": {
      "courage": 105,
      "power": 100,
      "wisdom": 80,
      "speed": 70,
      "energy": 75,
      "mugic": 3
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/QJFMpxn.png"
  },
  {
    "id": "DOP-32/232",
    "displayName": "Dardemus",
    "name": "Dardemus",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Intimidate: :courage:Courage 10.",
    "flavorText": "This UnderWorld prison guard has a simple policy that works: whip first, whip fast, whip last.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "32/232",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 85,
      "wisdom": 30,
      "speed": 75,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/bqTt0RK.png"
  },
  {
    "id": "DOP-33/232",
    "displayName": "Drakness",
    "name": "Drakness",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Ethereal",
    "ability": "Mugic played by Creatures you control that deal damage deal an additional 5 damage.",
    "flavorText": "Trust not your own shadow - for Drakness dwells there before he strikes",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "33/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 55,
      "wisdom": 95,
      "speed": 60,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/LtLL3cN.png"
  },
  {
    "id": "DOP-34/232",
    "displayName": "Ghuul",
    "name": "Ghuul",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Range.\r\nSwift 1.",
    "flavorText": "\"How many more until you’re satisfied, Mommark? Every mistake grows their number!\" - Maxxor",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "34/232",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 95,
      "wisdom": 25,
      "speed": 45,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/DqAGWEf.png"
  },
  {
    "id": "DOP-35/232",
    "displayName": "Grook",
    "name": "Grook",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Intimidate: :power:Power 10.",
    "flavorText": "\"Mugic? Bah! What can a Mugician do that I can’t do with my fists?\" — Grook",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, Etienne St.Laurent, David Rodriguez",
    "serialNumber": "35/232",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 120,
      "wisdom": 30,
      "speed": 70,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/0prhebE.png"
  },
  {
    "id": "DOP-36/232",
    "displayName": "H'earring",
    "name": "H'earring",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Scout",
    "ability": ":underworldmugic:: Look at the top three cards of target player's Location Deck and put them back in any order.",
    "flavorText": "Perhaps the most effective of the UnderWorld spies, H’earring mainly puts his supersonic skills to work for himself.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "36/232",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 40,
      "wisdom": 65,
      "speed": 55,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ESULIRi.png"
  },
  {
    "id": "DOP-37/232",
    "displayName": "Kerric",
    "name": "Kerric",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Scout",
    "ability": "Range\r\nSwift 1",
    "flavorText": "Provides crucial aerial surveillance of the Cordac Plungepool.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "37/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 40,
      "wisdom": 55,
      "speed": 75,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/0W5dIEQ.png"
  },
  {
    "id": "DOP-38/232",
    "displayName": "Khybon",
    "name": "Khybon",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Intimidate: :courage:Courage 10.\r\nIntimidate: :wisdom:Wisdom 10.",
    "flavorText": "\"Yeah, I could build that.\" — Khybon",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, David Curiel",
    "serialNumber": "38/232",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 35,
      "wisdom": 95,
      "speed": 30,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/EzzvRVG.png"
  },
  {
    "id": "DOP-39/232",
    "displayName": "Klasp",
    "name": "Klasp",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Recklessness 5\r\nSacrifice Klasp: Deal 10 damage to target Creature.",
    "flavorText": "If you find yourself seeing eye-to-eye with Klasp, it means you previously had not.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "39/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 105,
      "wisdom": 40,
      "speed": 75,
      "energy": 70,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/L94bcGQ.png"
  },
  {
    "id": "DOP-40/232",
    "displayName": "Krekk",
    "name": "Krekk",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Commander Scout",
    "ability": "Intimidate: :power:Power 10\r\nRange ",
    "flavorText": "\"Fear is a great motivator. Just look at Krekk.\" — Lord Van Bloot",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "40/232",
    "isPast": false,
    "stats": {
      "courage": 20,
      "power": 95,
      "wisdom": 30,
      "speed": 70,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/VbyRkym.png"
  },
  {
    "id": "DOP-41/232",
    "displayName": "Kughar",
    "name": "Kughar",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Intimidate: :power:Power 10.",
    "flavorText": "On bad days, Kughar is angry, furious and enraged. On good days, he’s just angry and furious.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "41/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 95,
      "wisdom": 35,
      "speed": 55,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/4xzSHJF.png"
  },
  {
    "id": "DOP-42/232",
    "displayName": "Lord Van Bloot",
    "name": "Lord Van Bloot",
    "subname": "",
    "set": "dop",
    "rarity": "ultra rare",
    "tribe": "underworld",
    "subtype": "Conqueror Muge",
    "ability": "If any Creature engaged with Lord Van Bloot has less than 65 :courage:Courage, that Creature has 10 less Energy.",
    "flavorText": "\"I may serve Chaor, but in time, Chaor will serve me!\" — Lord Van Bloot",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "42/232",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 125,
      "wisdom": 60,
      "speed": 105,
      "energy": 70,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/u6ARBoT.png"
  },
  {
    "id": "DOP-43/232",
    "displayName": "Magmon",
    "name": "Magmon",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Elementalist",
    "ability": ":fire:Fire 5.\r\nRecklessness 5.",
    "flavorText": "Magmon’s demeanor will melt your heart ... after burning through the rest of you.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "43/232",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 70,
      "wisdom": 30,
      "speed": 45,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/M9VVEfQ.png"
  },
  {
    "id": "DOP-44/232",
    "displayName": "Miklon",
    "name": "Miklon",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "",
    "flavorText": "After the \"accident,\" Khybon crafted the gyropod that keeps this prison guard on patrol.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, Keith Conroy, Etienne St.Laurent",
    "serialNumber": "44/232",
    "isPast": false,
    "stats": {
      "courage": 30,
      "power": 85,
      "wisdom": 40,
      "speed": 70,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/7Hd00zi.png"
  },
  {
    "id": "DOP-45/232",
    "displayName": "Nauthilax",
    "name": "Nauthilax",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Elementalist",
    "ability": "Recklessness 5.",
    "flavorText": "Few UnderWorlders can swim, which makes Nauthilax crucial to Chaor’s maritime intelligence gathering.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "45/232",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 70,
      "wisdom": 50,
      "speed": 65,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/nLaGxLG.png"
  },
  {
    "id": "DOP-46/232",
    "displayName": "Pyrithion",
    "name": "Pyrithion",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "Intimidate: :courage:Courage 10.\r\nIntimidate: :wisdom:Wisdom 10.",
    "flavorText": "\"Telling the truth only goes so far. But lying? That gets you where you’re going.\" — Pyrithion",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Axer",
    "serialNumber": "46/232",
    "isPast": false,
    "stats": {
      "courage": 35,
      "power": 90,
      "wisdom": 50,
      "speed": 75,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/pQ5PnPM.png"
  },
  {
    "id": "DOP-47/232",
    "displayName": "Rarran",
    "name": "Rarran",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Scout",
    "ability": "Range.",
    "flavorText": "A prison guard with Dardemus and Miklon, Rarran has not revealed his secret to them: he is one of Mommark’s creations.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "47/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 70,
      "wisdom": 40,
      "speed": 70,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/GlCWd5Q.png"
  },
  {
    "id": "DOP-48/232",
    "displayName": "Rothar",
    "name": "Rothar",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "Intimidate: :power:Power 10\r\nRecklessness 5",
    "flavorText": "\"I don’t run. I don’t flinch. But I don’t care, either.\" — Rothar",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "48/232",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 100,
      "wisdom": 35,
      "speed": 60,
      "energy": 75,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Z4wfEhB.png"
  },
  {
    "id": "DOP-49/232",
    "displayName": "Skithia",
    "name": "Skithia",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": ":fire:Fire 5",
    "flavorText": "Van Bloot’s most trusted aide, Skithia is also Takinom’s avowed enemy.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "49/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 35,
      "wisdom": 65,
      "speed": 50,
      "energy": 40,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/bbi7WVM.png"
  },
  {
    "id": "DOP-50/232",
    "displayName": "Skreeth",
    "name": "Skreeth",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": "Range\r\nSwift 1",
    "flavorText": "Skreeth’s boldness may be his undoing some day. Spineless he’s not!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "50/232",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 75,
      "wisdom": 70,
      "speed": 30,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/LJKDJjU.png"
  },
  {
    "id": "DOP-51/232",
    "displayName": "Solvis",
    "name": "Solvis",
    "subname": "",
    "set": "dop",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": ":underworldmugic::underworldmugic:: Deal 10 damage to target Creature.",
    "flavorText": "The proof of the theory of natural selection or devolution defined?",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "51/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 70,
      "wisdom": 75,
      "speed": 45,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/5WoVRWN.png"
  },
  {
    "id": "DOP-52/232",
    "displayName": "Takinom",
    "name": "Takinom",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "Sacrifice an UnderWorld Creature: Heal 25 damage to Takinom\r\nSwift 1",
    "flavorText": "Takinom unearthed a shocking secret bond with her archenemy Intress that she’s wisely kept from Chaor…",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "52/232",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 75,
      "wisdom": 30,
      "speed": 100,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ZTz4Ts4.png"
  },
  {
    "id": "DOP-53/232",
    "displayName": "Toxis",
    "name": "Toxis",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Elementalist",
    "ability": "Recklessness 5.",
    "flavorText": "A resident of the Pits outside the UnderWorld prison, escapees beg to return to their cells after enCountering Toxis.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "53/232",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 80,
      "wisdom": 50,
      "speed": 60,
      "energy": 55,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/L5RvFYp.png"
  },
  {
    "id": "DOP-54/232",
    "displayName": "Ulmar",
    "name": "Ulmar",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Conqueror",
    "ability": ":underworldmugic:: Deal 10 damage to target Creature.",
    "flavorText": "Takinom thinks that Chaor’s \"go-to\" guy for Battlegear has a screw loose himself.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "54/232",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 30,
      "wisdom": 80,
      "speed": 45,
      "energy": 30,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ncdKmDv.png"
  },
  {
    "id": "DOP-55/232",
    "displayName": "Xield",
    "name": "Xield",
    "subname": "",
    "set": "dop",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Elementalist",
    "ability": "Deal 10 damage to Xield: Target Creature gains 10 Energy. This ability can only be used once per turn.",
    "flavorText": "When the arrows shattered against his back, Xield knew he had found his calling.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "55/232",
    "isPast": false,
    "stats": {
      "courage": 105,
      "power": 50,
      "wisdom": 45,
      "speed": 25,
      "energy": 25,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/OIHEP2X.png"
  },
  {
    "id": "DOP-56/232",
    "displayName": "Zaur",
    "name": "Zaur",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": "",
    "flavorText": "\"'Failure' is such a harsh word. Let's just say my experiment had unintended consequences.\" — Mommark",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "56/232",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 85,
      "wisdom": 45,
      "speed": 35,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/J352FCH.png"
  },
  {
    "id": "ZOTH-6/100",
    "displayName": "Geltod",
    "name": "Geltod",
    "subname": "",
    "set": "zoth",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Muge",
    "ability": "Discard an UnderWorld Mugic Card: Deal 5 damage to target Creature.",
    "flavorText": "Ah-choo! Oh, gross! I just 'geltodded' into my hands.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, David Curiel",
    "serialNumber": "6/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 80,
      "wisdom": 55,
      "speed": 50,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/YNrB6hV.png"
  },
  {
    "id": "ZOTH-7/100",
    "displayName": "Hammerdoom Chantcaller",
    "name": "Hammerdoom Chantcaller",
    "subname": "",
    "set": "zoth",
    "rarity": "ultra rare",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": "Attacks played by Hammerdoom Chantcaller deal an additional 5 damage to Danian Creatures. If Hive is active, attacks played by Hammerdoom Chantcaller deal an additional 5 damage to UnderWorld Creatures instead.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, Etienne St.Laurent",
    "serialNumber": "7/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 65,
      "wisdom": 50,
      "speed": 65,
      "energy": 70,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/B7EINoV.png"
  },
  {
    "id": "ZOTH-8/100",
    "displayName": "Illazar",
    "name": "Illazar",
    "subname": "",
    "set": "zoth",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Muge",
    "ability": "When a Creature you control is put into your general discard pile, if that Creature had one or more Mugic counters on it, remove a Mugic counter from target Creature.",
    "flavorText": "No one believed Bodal when he said he was struck by a streaking rainbow.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "8/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 80,
      "wisdom": 70,
      "speed": 65,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/iAZVCzm.png"
  },
  {
    "id": "ZOTH-9/100",
    "displayName": "Kamangareth",
    "name": "Kamangareth",
    "subname": "",
    "set": "zoth",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "Deal 15 damage to Kamangareth while engaged: Deactivate Hive.",
    "flavorText": "\"Stalk, isolate, destroy. Do these three things and the Danians are powerless!\" — Kamangareth\r\n\r\n",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, David Curiel",
    "serialNumber": "9/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 80,
      "wisdom": 40,
      "speed": 65,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/CFzmfSH.png"
  },
  {
    "id": "ZOTH-10/100",
    "displayName": "Narfall",
    "name": "Narfall",
    "subname": "",
    "set": "zoth",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Elementalist",
    "ability": "When Narfall becomes engaged, deal 5 damage to opposing engaged Creature for each Elemental Type that Creature has.",
    "flavorText": "The breeze suddenly died, as if all hope left the world.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "serialNumber": "10/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 80,
      "wisdom": 55,
      "speed": 50,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/5cIxgpN.png"
  },
  {
    "id": "ZOTH-11/100",
    "displayName": "Ornathor",
    "name": "Ornathor",
    "subname": "",
    "set": "zoth",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Waterproof 10.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Loprz",
    "serialNumber": "11/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 65,
      "wisdom": 55,
      "speed": 65,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/UTi91WS.png"
  },
  {
    "id": "ZOTH-12/100",
    "displayName": "Slufurah",
    "name": "Slufurah",
    "subname": "",
    "set": "zoth",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Muge",
    "ability": "Muges have \"Sacrifice this Creature: Deal 10 damage to target Creature.\"\r\n\r\n",
    "flavorText": "\"You've run out of Mugicians? Do not fear. I know how you can still be useful.\" — Slufurah",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "12/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 75,
      "wisdom": 75,
      "speed": 30,
      "energy": 45,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/pDBdpeB.png"
  },
  {
    "id": "ZOTH-13/100",
    "displayName": "Strikto",
    "name": "Strikto",
    "subname": "",
    "set": "zoth",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": "When Strikto has a Mugic counter put on it, it loses 10 Energy.\r\nWhen a Creature deals damage to Strikto, that Creature loses 5 Energy.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keith Conroy, David Curiel",
    "serialNumber": "13/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 55,
      "wisdom": 85,
      "speed": 50,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/F6PLyLr.png"
  },
  {
    "id": "ZOTH-14/100",
    "displayName": "Swassa",
    "name": "Swassa",
    "subname": "",
    "set": "zoth",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": "Deal 10 damage to a Creature you control: That Creature gains \"Swift 2.\" This ability can only be used once per turn.",
    "flavorText": "Rule #31: Never disobey a leader who wields four weapons at once.\r\n",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "14/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 75,
      "wisdom": 55,
      "speed": 65,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Wz5r6rP.png"
  },
  {
    "id": "ZOTH-15/100",
    "displayName": "Ultadur",
    "name": "Ultadur",
    "subname": "",
    "set": "zoth",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "Commander Creatures you control have :fire:Fire and \"Recklessness 5.\"\r\nUltadur cannot have Mugic counters put on it.",
    "flavorText": "And in an instant, the village was gone, the land was scorched and the fields would never flower again.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "15/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 95,
      "wisdom": 40,
      "speed": 85,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/KoFdvfb.png"
  },
  {
    "id": "SS-11/100",
    "displayName": "Atrapol",
    "name": "Atrapol",
    "subname": "",
    "set": "ss",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": "When Atrapol wins a :power:Power Challenge on an attack it plays, destroy target Battlegear equipped to the opposing engaged Creature.",
    "flavorText": "Like most UnderWorlders, Atrapol fights best when he's already winning.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Dan Norton, Anthony Washington",
    "serialNumber": "11/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 65,
      "wisdom": 35,
      "speed": 25,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/PurXQ7V.png"
  },
  {
    "id": "SS-12/100",
    "displayName": "Kopond",
    "name": "Kopond",
    "subname": "",
    "set": "ss",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Muge",
    "ability": ":underworldmugic:: Deal 5 damage to target Creature for each Mugic counter on Kopond. This ability can only be used once per turn. ",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "12/100",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 25,
      "wisdom": 60,
      "speed": 30,
      "energy": 25,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/2cEBufK.png"
  },
  {
    "id": "SS-13/100",
    "displayName": "Phelphor",
    "name": "Phelphor",
    "subname": "",
    "set": "ss",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Conqueror Scout",
    "ability": "At the beginning of your turn, you can relocate target Creature to any unoccupied space on the Battleboard adjacent to it.",
    "flavorText": "Everyone wants to know what's behind the Doors, but none more than him.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "13/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 75,
      "wisdom": 70,
      "speed": 60,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/adzSydT.png"
  },
  {
    "id": "SS-14/100",
    "displayName": "Vyll",
    "name": "Vyll",
    "subname": "",
    "set": "ss",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Muge",
    "ability": ":underworldmugic::underworldmugic:: Remove a Mugic counter from target Creature.",
    "flavorText": "As the \"Annihilator of Mugic,\" Vyll prevents the casting of Mugic by targeting the source - the Mugicians themselves.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Gustavo, Etienne St.Laurent",
    "serialNumber": "14/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 45,
      "wisdom": 85,
      "speed": 40,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/NZmAbB6.png"
  },
  {
    "id": "SS-15/100",
    "displayName": "Zapetur",
    "name": "Zapetur",
    "subname": "",
    "set": "ss",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "Sacrifice a Battlegear: Deal 5 damage to target Creature. This ability can only be used once per turn.\r\nSacrifice Zapetur: Destroy target Battlegear.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, David Curiel",
    "serialNumber": "15/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 70,
      "wisdom": 35,
      "speed": 45,
      "energy": 40,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/cLOfSMA.png"
  },
  {
    "id": "BTD-15/222",
    "displayName": "Aokua",
    "name": "Aokua",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "Exhaust all Disciplines 10.",
    "flavorText": "Aokua was the first to learn that if you can get past the hardened shell, Danians are both nutritious and delicious.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, David Curiel",
    "serialNumber": "15/222",
    "isPast": false,
    "stats": {
      "courage": 110,
      "power": 110,
      "wisdom": 110,
      "speed": 110,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/FLfT2hP.png"
  },
  {
    "id": "BTD-16/222",
    "displayName": "Asadab",
    "name": "Asadab",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Minion Muge",
    "ability": ":underworldmugic:: Target Creature gains 15 :power:Power.",
    "flavorText": "",
    "brainwashedText": ":underworldmugic:: Deal 5 damage to target Creature and it loses 10 :power:Power.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "16/222",
    "isPast": false,
    "stats": {
      "courage": 30,
      "power": 65,
      "wisdom": 65,
      "speed": 40,
      "energy": 30,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/ZqYeyM3.png"
  },
  {
    "id": "BTD-17/222",
    "displayName": "Bladez",
    "name": "Bladez",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Minion Warrior",
    "ability": "If an attack played by Bladez would deal 0 damage, it deals 15 damage instead.",
    "flavorText": "",
    "brainwashedText": "Attacks played by Bladez have \"Opposing engaged Creature loses 10 to all Disciplines.\"",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez, Etienne St.Laurent",
    "serialNumber": "17/222",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 100,
      "wisdom": 45,
      "speed": 40,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/cmYHXL2.png"
  },
  {
    "id": "BTD-18/222",
    "displayName": "Brimflame",
    "name": "Brimflame",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Taskmaster Minion",
    "ability": "If Brimflame is equipped,\r\nit has \":fire:Fire 5.\"",
    "flavorText": "",
    "brainwashedText": "Sacrifice Battlegear equipped to Brimflame: destroy target Battlegear",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Ryan Benjamin, Etienne St.Laurent",
    "serialNumber": "18/222",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 100,
      "wisdom": 55,
      "speed": 70,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/LkajWDj.png"
  },
  {
    "id": "BTD-19/222",
    "displayName": "Gambreor",
    "name": "Gambreor",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Taskmaster Minion",
    "ability": ":underworldmugic:, Sacrifice a Battlegear: Heal 15 damage to target Creature.",
    "flavorText": "",
    "brainwashedText": ":underworldmugic:, Sacrifice a Battlegear: Heal 10 damage to target Creature and it gains 10 :power:Power.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Etienne St.Laurent",
    "serialNumber": "19/222",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 60,
      "wisdom": 55,
      "speed": 55,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/5i58nfp.png"
  },
  {
    "id": "BTD-20/222",
    "displayName": "Ilx",
    "name": "Ilx",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Ethereal Conqueror",
    "ability": ":air:Air 5.\r\nRecklessness 5.\r\nIf engaged with an unequipped Creature, Ilx has an additional \":air:Air 5\" and \"Recklessness 5.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Anthony Washington",
    "serialNumber": "20/222",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 100,
      "wisdom": 35,
      "speed": 45,
      "energy": 75,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/c9sxJJI.png"
  },
  {
    "id": "BTD-21/222",
    "displayName": "Kraade",
    "name": "Kraade",
    "subname": "",
    "set": "btd",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Minion Scout",
    "ability": "Swift 2",
    "flavorText": "",
    "brainwashedText": "Intimidate: :power:Power  20",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tim Kane, Etienne St.Laurent",
    "serialNumber": "21/222",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 75,
      "wisdom": 50,
      "speed": 60,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/HMp0zur.png"
  },
  {
    "id": "BTD-22/222",
    "displayName": "Kreaal",
    "name": "Kreaal",
    "subname": "",
    "set": "btd",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Ethereal Warrior",
    "ability": "UnderWorld Creatures you control have \"Intimidate: :power:Power 20\" and \"Exhaust all Disciplines 5.\"",
    "flavorText": "Kreaal cannot be brainwashed because he has no brain to begin with.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Hotshots VFX",
    "serialNumber": "22/222",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 95,
      "wisdom": 25,
      "speed": 60,
      "energy": 70,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/pmJ6oHp.png"
  },
  {
    "id": "BTD-23/222",
    "displayName": "Lyssta",
    "name": "Lyssta",
    "subname": "",
    "set": "btd",
    "rarity": "ultra rare",
    "tribe": "underworld",
    "subtype": "Conqueror Warrior",
    "ability": "When Lyssta wins Initiative, it gains \"Outperform :power:Power 10\" and \":air:Air 10.\" ",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "23/222",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 90,
      "wisdom": 40,
      "speed": 65,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/yq5ONph.png"
  },
  {
    "id": "BTD-24/222",
    "displayName": "Nauthilax, Tainted",
    "name": "Nauthilax",
    "subname": "Tainted",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Minion Scout",
    "ability": "Exhaust all Disciplines 5.\r\nWhen Nauthilax wins a :power:Power Challenge, it gains an Elemental Type of your choice.",
    "flavorText": "",
    "brainwashedText": "Recklessness 5 \r\nWhen Nauthilax deals exactly 25 attack damage, destroy target Battlegear. \r\nOutperform :power:Power  5",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, Axer",
    "serialNumber": "24/222",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 110,
      "wisdom": 50,
      "speed": 75,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/JucvPCU.png"
  },
  {
    "id": "BTD-25/222",
    "displayName": "Ooloo",
    "name": "Ooloo",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Minion Warrior",
    "ability": ":air:Air 5.\r\nRecklessness 5.",
    "flavorText": "",
    "brainwashedText": "Outperform :power:Power  5\r\nExhaust all Disciplines 5",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Ryan Benjamin, Etienne St.Laurent",
    "serialNumber": "25/222",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 80,
      "wisdom": 45,
      "speed": 50,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/vUR3N4r.png"
  },
  {
    "id": "BTD-26/222",
    "displayName": "Ragetrod",
    "name": "Ragetrod",
    "subname": "",
    "set": "btd",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Commander Minion",
    "ability": "Outperform :power:Power 5.\r\nRecklessness 5.",
    "flavorText": "",
    "brainwashedText": ":underworldmugic:: Relocate target opposing unengaged Creature to any unoccupied space on the Battleboard adjacent to it.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, John Rauch",
    "serialNumber": "26/222",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 85,
      "wisdom": 50,
      "speed": 60,
      "energy": 60,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/EMDisfD.png"
  },
  {
    "id": "BTD-27/222",
    "displayName": "Rarran, Tainted",
    "name": "Rarran",
    "subname": "Tainted",
    "set": "btd",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Minion Scout",
    "ability": "Swift 3.",
    "flavorText": "",
    "brainwashedText": "If a Creature with Range moves into a space occupied by a Creature you control, Rarran can intercept as though it had Defender and was adjacent.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Dan Norton, David Curiel",
    "serialNumber": "27/222",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 100,
      "wisdom": 30,
      "speed": 95,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/ZqjkDx3.png"
  },
  {
    "id": "BTD-28/222",
    "displayName": "Tomugar",
    "name": "Tomugar",
    "subname": "",
    "set": "btd",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Minion Muge",
    "ability": ":underworldmugic:: Target Creature gains 25 to a Discipline and loses 10 to another.",
    "flavorText": "",
    "brainwashedText": ":underworldmugic:, Discard a Mugic Card: Target opponent discards a random Mugic Card. Use only once per turn.",
    "brainwashed": true,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "28/222",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 60,
      "wisdom": 70,
      "speed": 35,
      "energy": 45,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/yhRIccf.png"
  },
  {
    "id": "ROTO-8/100",
    "displayName": "Blaaxa",
    "name": "Blaaxa",
    "subname": "",
    "set": "roto",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Ethereal Minion",
    "ability": "Reveal an Attack Card from your hand: Target attack with the same name as the revealed card deals 0 damage.",
    "flavorText": "",
    "brainwashedText": "Reveal a Mugic Card from your hand: Negate target Mugic with the same name as the revealed card.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, Etienne St.Laurent",
    "serialNumber": "8/100",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 45,
      "wisdom": 80,
      "speed": 55,
      "energy": 30,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/cTFKAmw.png"
  },
  {
    "id": "ROTO-9/100",
    "displayName": "H'earring, Tainted",
    "name": "H'earring",
    "subname": "Tainted",
    "set": "roto",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Minion Scout",
    "ability": "At the beginning of combat, look at your opponent's attack hand and choose an Attack Card. They discard it and then draw an Attack Card.",
    "flavorText": "",
    "brainwashedText": ":underworldmugic:: Remove :genericmugic: from each other Creature you control. Look at the top 3 cards of target player's Location Deck and choose one. It becomes the new active Location.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "9/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 75,
      "wisdom": 50,
      "speed": 60,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/DTou1rv.png"
  },
  {
    "id": "ROTO-10/100",
    "displayName": "Khybon, The Renegade",
    "name": "Khybon",
    "subname": "The Renegade",
    "set": "roto",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Taskmaster Minion",
    "ability": "At the beginning of combat, if Khybon is equipped, it gains 10 Energy.",
    "flavorText": "",
    "brainwashedText": "At the beginning of combat, Khybon gains 5 Energy for each Battlegear Card in each general discard pile.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, David Curiel",
    "serialNumber": "10/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 60,
      "wisdom": 80,
      "speed": 30,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/NvwsugH.png"
  },
  {
    "id": "ROTO-11/100",
    "displayName": "Nivenna",
    "name": "Nivenna",
    "subname": "",
    "set": "roto",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Conqueror Muge",
    "ability": ":underworldmugic:: Choose an Elemental Type. Target Creature which dealt attack damage this turn gains \"Element 10\" of the chosen Elemental Type. Use this ability only once per turn.\r\nWarriors you control have an additional 10 in all Disciplines. ",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "11/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 60,
      "wisdom": 100,
      "speed": 70,
      "energy": 35,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/3giOsvc.png"
  },
  {
    "id": "ROTO-12/100",
    "displayName": "Stelgar",
    "name": "Stelgar",
    "subname": "",
    "set": "roto",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Minion Warrior",
    "ability": "When Stelgar deals attack damage, it gains 10 to all Disciplines.\r\nIf Stelgar has more than 125 :power:Power, destroy it.",
    "flavorText": "",
    "brainwashedText": "When Stelgar wins combat, put :underworldmugic: on it.\r\nIf Stelgar has 2 or more Mugic counters on it, destroy it.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, Anthony Washington",
    "serialNumber": "12/100",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 75,
      "wisdom": 75,
      "speed": 75,
      "energy": 70,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/OTyyn77.png"
  },
  {
    "id": "ROTO-13/100",
    "displayName": "Takinom, The Shadowknight",
    "name": "Takinom",
    "subname": "The Shadowknight",
    "set": "roto",
    "rarity": "ultra rare",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "Strike 10.\r\n:underworldmugic:: The next attack played by Takinom this turn counts as its first attack this combat.\r\nSwift 2.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "13/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 100,
      "wisdom": 50,
      "speed": 80,
      "energy": 70,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/c2uJmke.png"
  },
  {
    "id": "ROTO-14/100",
    "displayName": "Tasqa",
    "name": "Tasqa",
    "subname": "",
    "set": "roto",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Taskmaster Scout",
    "ability": ":underworldmugic:: Deal 15 damage to target adjacent equipped Creature.",
    "flavorText": "Never attack a fully-armored Drill Dozer head-on when you can simply remove one screw to disable its systems.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, David Curiel",
    "serialNumber": "14/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 65,
      "wisdom": 60,
      "speed": 45,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/UQFETU7.png"
  },
  {
    "id": "TOTT-8/100",
    "displayName": "Agitos, Eloquent Motivator",
    "name": "Agitos",
    "subname": "Eloquent Motivator",
    "set": "tott",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "At the beginning of your turn, UnderWorld Creatures you control gain \"Intimidate: :courage:Courage 20\" and \"Intimidate: :power:Power 20.\"\r\n:underworldmugic::underworldmugic:: Target Creature gains \"Adjacent Creatures must move into this space if able.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, Chris Fisher",
    "serialNumber": "8/100",
    "isPast": false,
    "stats": {
      "courage": 105,
      "power": 50,
      "wisdom": 85,
      "speed": 35,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/NhHoJyF.png"
  },
  {
    "id": "TOTT-9/100",
    "displayName": "Eximiar",
    "name": "Eximiar",
    "subname": "",
    "set": "tott",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": "Outperform :power:Power 5.\r\nIf Eximiar is engaged with an UnderWorld Creature, it has \":fire:Fire 5\" and \"Recklessness 5.\"",
    "flavorText": "\"You call them weak-minded. I call them traitors!\" — Eximiar",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Chris Fisher",
    "serialNumber": "9/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 80,
      "wisdom": 40,
      "speed": 25,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/dcgmXv1.png"
  },
  {
    "id": "TOTT-10/100",
    "displayName": "Galmedar",
    "name": "Galmedar",
    "subname": "",
    "set": "tott",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Commander Minion",
    "ability": "If any Creature engaged with Galmedar has :power:Power less than 65, that Creature cannot be healed or gain Energy from non-innate abilities.",
    "flavorText": "",
    "brainwashedText": "Each Creature you control deals an additional 5 attack damage to Creatures that share a Tribe with it.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Bob Rivard",
    "serialNumber": "10/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 110,
      "wisdom": 70,
      "speed": 45,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/phFHyk6.png"
  },
  {
    "id": "TOTT-11/100",
    "displayName": "Klawam",
    "name": "Klawam",
    "subname": "",
    "set": "tott",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Taskmaster Minion",
    "ability": "Sacrifice Klawam: Deal 20 damage to target engaged Creature.",
    "flavorText": "",
    "brainwashedText": "Sacrifice Klawam: Target engaged Creature loses 20 to all Disciplines.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Gustavo, Etienne St.Laurent",
    "serialNumber": "11/100",
    "isPast": false,
    "stats": {
      "courage": 25,
      "power": 105,
      "wisdom": 25,
      "speed": 70,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/9nbScle.png"
  },
  {
    "id": "TOTT-12/100",
    "displayName": "Lord Van Bloot, Servant of Aa'une",
    "name": "Lord Van Bloot",
    "subname": "Servant of Aa'une",
    "set": "tott",
    "rarity": "ultra rare",
    "tribe": "underworld",
    "subtype": "Conqueror Minion",
    "ability": "If any Creature engaged with Lord Van Bloot has less than 65 :courage:Courage, it does not have and cannot gain any Elemental Types.",
    "flavorText": "",
    "brainwashedText": "If any Creature engaged with Lord Van Bloot has less than 65 :courage:Courage, it has \"Recklessness 5\" and \"Exhaust all Disciplines 5.\"",
    "brainwashed": true,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "12/100",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 60,
      "wisdom": 85,
      "speed": 65,
      "energy": 65,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/8H9OTpI.png"
  },
  {
    "id": "TOTT-34/100",
    "displayName": "Ozlai, Chaor's Pilot",
    "name": "Ozlai",
    "subname": "Chaor's Pilot",
    "set": "tott",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Taskmaster Scout",
    "ability": "If Ozlai is equipped, it has \"Outperform :speed:Speed 5.\"\r\nWhen a Battlegear goes to the opposing general discard pile, deal 5 damage to target Creature.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tom Baxa",
    "serialNumber": "34/100",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 50,
      "wisdom": 40,
      "speed": 95,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/RwK29WT.png"
  },
  {
    "id": "TOTT-28/100",
    "displayName": "Ustabe",
    "name": "Ustabe",
    "subname": "",
    "set": "tott",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Ethereal Warrior",
    "ability": "Intimidate: :power:Power 30\r\nIntimidate: :speed:Speed 30\r\nRecklessness 5",
    "flavorText": "\"I don't care what it's made of... as long as it can fight!\" — Chaor",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Imaginary Friends Studios",
    "serialNumber": "28/100",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 95,
      "wisdom": 30,
      "speed": 70,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/wtMPF1p.png"
  },
  {
    "id": "FUN-9/100",
    "displayName": "Anarkiar",
    "name": "Anarkiar",
    "subname": "",
    "set": "fun",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": "Outperform :power:Power 5.\r\nRecklessness 10.\r\nWhile you control an OverWorld Creature, Damage dealt by Recklessness to Anarkiar is reduced to 0.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "serialNumber": "9/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 95,
      "wisdom": 40,
      "speed": 50,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/qcWmTKq.png"
  },
  {
    "id": "FUN-10/100",
    "displayName": "Barath Beyond, UnderWorld General",
    "name": "Barath Beyond",
    "subname": "UnderWorld General",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Ethereal Warrior",
    "ability": "Sacrifice a Creature while Barath Beyond is engaged: If you sacrificed, \r\nAn OverWorld Creature, negate up to one target Mugic.\r\nA Mipedian Creature, the next attack played by Barath Beyond this turn deals an additional 20 damage.\r\nA Danian Creature, Barath Beyond gains 30 Energy.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": true,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "10/100",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 100,
      "wisdom": 30,
      "speed": 85,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/0IPD0xS.png"
  },
  {
    "id": "FUN-11/100",
    "displayName": "Chaor, The Fierce",
    "name": "Chaor",
    "subname": "The Fierce",
    "set": "fun",
    "rarity": "ultra rare",
    "tribe": "underworld",
    "subtype": "Conqueror Warrior",
    "ability": ":fire:Fire 10.",
    "flavorText": "Exiled from the UnderWorld, Chaor has lost his homeland and his throne. But his anger still rages, and it drives him forward.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington, Emilio Lopez",
    "serialNumber": "11/100",
    "isPast": false,
    "stats": {
      "courage": 90,
      "power": 115,
      "wisdom": 55,
      "speed": 55,
      "energy": 70,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/1VNO0Le.png"
  },
  {
    "id": "FUN-12/100",
    "displayName": "Kamangareth, Unstable Ally",
    "name": "Kamangareth",
    "subname": "Unstable Ally",
    "set": "fun",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "While you control a Danian Creature, unequipped Creatures you control have \"Outperform :power:Power 5.\"",
    "flavorText": "Kamangareth has no problem fighting alongside former foes. The Danians are not as forgiving.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Chris Fisher",
    "serialNumber": "12/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 90,
      "wisdom": 55,
      "speed": 70,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/e3gDTei.png"
  },
  {
    "id": "FUN-13/100",
    "displayName": "Magmon, Retalliator",
    "name": "Magmon",
    "subname": "Retalliator",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Minion Elementalist",
    "ability": "Magmon deals an additional 5 attack damage to Creatures that are a M'arrillian or a Minion.\r\nRecklessness 5.",
    "flavorText": "",
    "brainwashedText": "Magmon deals an additional 5 attack damage to non-M'arrillian Creatures.\r\nRecklessness 5",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez, Axer",
    "serialNumber": "13/100",
    "isPast": false,
    "stats": {
      "courage": 65,
      "power": 95,
      "wisdom": 25,
      "speed": 40,
      "energy": 75,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/NquyHwm.png"
  },
  {
    "id": "FUN-14/100",
    "displayName": "Nivenna, UnderWorld Lieutenant",
    "name": "Nivenna",
    "subname": "UnderWorld Lieutenant",
    "set": "fun",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Conqueror Muge",
    "ability": ":underworldmugic::underworldmugic:: Deal 5 damage to target Creature for each Tribe you control.\r\nWhile you control only Nivenna and Aivenna, this ability costs 1 less Mugic counter to play.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "14/100",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 60,
      "wisdom": 90,
      "speed": 70,
      "energy": 40,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/lnJQ9PY.png"
  },
  {
    "id": "FUN-37/100",
    "displayName": "Torrna",
    "name": "Torrna",
    "subname": "",
    "set": "fun",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Scout",
    "ability": "While you control a Mipedian Creature, Torrna has \"Disarm.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "37/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 90,
      "wisdom": 50,
      "speed": 75,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/3k43pYD.png"
  },
  {
    "id": "FUN-16/100",
    "displayName": "Uksum",
    "name": "Uksum",
    "subname": "",
    "set": "fun",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Ethereal Minion Warrior",
    "ability": "At the beginning of combat, Uksum gains Energy equal to the lowest Scanned Energy among other Creatures you control.",
    "flavorText": "",
    "brainwashedText": "Uksum has an additional 40 Energy and Creature Type \"Kha'rall\" in addition to its other types.",
    "brainwashed": true,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Jimmy Tran, David Curiel",
    "serialNumber": "16/100",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 105,
      "wisdom": 25,
      "speed": 45,
      "energy": 25,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/JyBfxsv.png"
  },
  {
    "id": "AU-S09/26",
    "displayName": "Kaal",
    "name": "Kaal",
    "subname": "",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "underworld",
    "subtype": "Conqueror",
    "ability": ":fire:Fire 5\r\n:underworldmugic:: Deal 5 damage to target Creature for each Creature you control on your opponent's side of the Battleboard.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Reggie Butler",
    "serialNumber": "S09/26",
    "isPast": true,
    "stats": {
      "courage": 70,
      "power": 105,
      "wisdom": 40,
      "speed": 70,
      "energy": 55,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/PnhPfmO.png"
  },
  {
    "id": "AU-17/200",
    "displayName": "Ketacc",
    "name": "Ketacc",
    "subname": "",
    "set": "au",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Warrior Scout",
    "ability": "Intimidate: Energy 10\r\nRecklessness 10",
    "flavorText": "\"On my signal, unleash the full wrath of the UnderWorld!\" — Slufurah",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "17/200",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 90,
      "wisdom": 50,
      "speed": 30,
      "energy": 75,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/byjiYrH.png"
  },
  {
    "id": "AU-18/200",
    "displayName": "Khybon, Magma Dam Overseer",
    "name": "Khybon",
    "subname": "Magma Dam Overseer",
    "set": "au",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Expend :fire:Fire: Put a Magma Counter on Khybon.\r\nRemove 5 Magma Counters from Khybon: Deal 40 damage to all engaged Creatures.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "18/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 70,
      "wisdom": 50,
      "speed": 40,
      "energy": 50,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/3KhCmxz.png"
  },
  {
    "id": "AU-S10/26",
    "displayName": "Kiru",
    "name": "Kiru",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Conqueror",
    "ability": "When Kiru wins combat put a Leadership Counter on it.\r\nOther Creatures you control have an additional 10 Energy for each Leadership Counter on Kiru.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Reggie Butler",
    "serialNumber": "S10/26",
    "isPast": true,
    "stats": {
      "courage": 80,
      "power": 100,
      "wisdom": 50,
      "speed": 85,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/b8UqQJ4.png"
  },
  {
    "id": "AU-19/200",
    "displayName": "Kopond, High Muge of the Hearth",
    "name": "Kopond",
    "subname": "High Muge of the Hearth",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "underworld",
    "subtype": "Muge",
    "ability": "Mugic played by Kopond that deals damage deals an additional 10 damage.",
    "flavorText": "\"Tonight we may dine as fellow Muges, but as the sun rises we are enemies once again.\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": true,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Bob Rivard",
    "serialNumber": "19/200",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 80,
      "wisdom": 80,
      "speed": 50,
      "energy": 35,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Z2PB8zD.png"
  },
  {
    "id": "AU-20/200",
    "displayName": "Krekk, Phalanx Recon",
    "name": "Krekk",
    "subname": "Phalanx Recon",
    "set": "au",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Scout",
    "ability": "At the beginning of combat, if the active Location's Initiative is a Discipline, engaged Creatures with less than 60 in that Discipline lose 10 Energy.",
    "flavorText": "Endlessly patrolling Gothos Tower, he waits for Lord Van Bloot's return.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, David Curiel",
    "serialNumber": "20/200",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 65,
      "wisdom": 40,
      "speed": 70,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/OkhDl8F.png"
  },
  {
    "id": "AU-21/200",
    "displayName": "Magmon, Engulfed",
    "name": "Magmon",
    "subname": "Engulfed",
    "set": "au",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Elementalist",
    "ability": "Your other Creatures with :fire:Fire have \"Recklessness 5\" and \":fire:Fire 5.\"",
    "flavorText": "As long as a single coal burns, his flame can never be extinguished.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "21/200",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 85,
      "wisdom": 30,
      "speed": 55,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/JtMi7YQ.png"
  },
  {
    "id": "AU-22/200",
    "displayName": "Nauthilax, Aquatic Spy",
    "name": "Nauthilax",
    "subname": "Aquatic Spy",
    "set": "au",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Elementalist Scout",
    "ability": "Recklessness 5",
    "flavorText": "Hiding impatiently, just out of sight, Nauthilax soon learned that it's hard to let others do the hard work for you.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Reggie Butler",
    "serialNumber": "22/200",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 60,
      "wisdom": 70,
      "speed": 65,
      "energy": 65,
      "mugic": 2
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/UdM5hiK.png"
  },
  {
    "id": "AU-23/200",
    "displayName": "Piddan",
    "name": "Piddan",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Taskmaster Warrior",
    "ability": ":underworldmugic:: Target Creature deals an additional 10 damage with its next attack this turn. If that Creature has :fire:Fire, it also gains \":fire:Fire 5.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Bob Rivard",
    "serialNumber": "23/200",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 70,
      "wisdom": 30,
      "speed": 60,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/lc2d7Gp.png"
  },
  {
    "id": "AU-24/200",
    "displayName": "Rothar, Forceful Negotiator",
    "name": "Rothar",
    "subname": "Forceful Negotiator",
    "set": "au",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "If Rothar can move into an adjacent occupied space, it must do so.",
    "flavorText": "\"Treaties are made to be broken... and so are your bones!\" — Rothar",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Bob Rivard",
    "serialNumber": "24/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 110,
      "wisdom": 60,
      "speed": 70,
      "energy": 75,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 1,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/BzkkEpb.png"
  },
  {
    "id": "AU-25/200",
    "displayName": "Savitsa",
    "name": "Savitsa",
    "subname": "",
    "set": "au",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Elementalist",
    "ability": "Expend :fire:Fire while engaged: Both players discard two Attack Cards and draw two Attack Cards.",
    "flavorText": "Like a burning portent, his flaming hair signals all who see it that they do not have long to live.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Chris Fisher",
    "serialNumber": "25/200",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 80,
      "wisdom": 40,
      "speed": 80,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/qgv0VHU.png"
  },
  {
    "id": "AU-26/200",
    "displayName": "Seeryn, Servant of Fire",
    "name": "Seeryn",
    "subname": "Servant of Fire",
    "set": "au",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Elementalist",
    "ability": ":underworldmugic:: Target Creature gains :fire:Fire.",
    "flavorText": "Of the High Muges who helped raise the city, Seeryn warmed to Kopond and his inclination for destructive mugic.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "26/200",
    "isPast": false,
    "stats": {
      "courage": 55,
      "power": 90,
      "wisdom": 50,
      "speed": 55,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/SUMXQBN.png"
  },
  {
    "id": "AU-27/200",
    "displayName": "Skithia, Gothos Spy",
    "name": "Skithia",
    "subname": "Gothos Spy",
    "set": "au",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Commander Scout",
    "ability": ":underworldmugic:: The controller of target Creature reveals their attack hand. Deal 5 damage to that engaged Creature for each Elemental Type either of those revealed Attack Cards have.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Emilio Lopez",
    "serialNumber": "27/200",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 85,
      "wisdom": 50,
      "speed": 80,
      "energy": 40,
      "mugic": 2
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/QlWaRRx.png"
  },
  {
    "id": "AU-S11/26",
    "displayName": "Skorblust",
    "name": "Skorblust",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Elementalist",
    "ability": "When Skorblust takes damage from a :fire:Fire or :earth:Earth attack, deal 5 damage to opposing engaged Creature.",
    "flavorText": "Wherever Skorblust goes, he leaves a part of himself behind.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Emilio Lopez",
    "serialNumber": "S11/26",
    "isPast": true,
    "stats": {
      "courage": 70,
      "power": 90,
      "wisdom": 30,
      "speed": 60,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/CuyGM8N.png"
  },
  {
    "id": "AU-28/200",
    "displayName": "Slufurah, Treacherous Translator",
    "name": "Slufurah",
    "subname": "Treacherous Translator",
    "set": "au",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Muge",
    "ability": "At the beginning of combat, sacrifice a Battlegear equipped to your engaged Creature. If you do, that Creature gains :fire:Fire and \":fire:Fire 5.\"",
    "flavorText": "\"There! We're done. Not much need for you now, is there? The alliance is broken!\"",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Bob Rivard",
    "serialNumber": "28/200",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 70,
      "wisdom": 45,
      "speed": 40,
      "energy": 35,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/z4JQfcz.png"
  },
  {
    "id": "AU-29/200",
    "displayName": "Stelgar, Vicious Mutation",
    "name": "Stelgar",
    "subname": "Vicious Mutation",
    "set": "au",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": "At the end of each turn, put a Growth Counter on Stelgar.\r\nStelgar has an additional 10 Energy and 10 in all Disciplines for each Growth Counter on it.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Bob Rivard",
    "serialNumber": "29/200",
    "isPast": false,
    "stats": {
      "courage": 30,
      "power": 30,
      "wisdom": 30,
      "speed": 30,
      "energy": 25,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/Wf28LcJ.png"
  },
  {
    "id": "AU-30/200",
    "displayName": "Toadore",
    "name": "Toadore",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Expend :fire:Fire while engaged: Destroy all Battlegear equipped to engaged Creatures.",
    "flavorText": "You think H'earring's breath is bad after a bag of Dractyl scales? Wait 'til you get a whiff of Toadore's belches!",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "30/200",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 80,
      "wisdom": 40,
      "speed": 45,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/LjD6MJu.png"
  },
  {
    "id": "AU-31/200",
    "displayName": "Ulmar, Perithon Racer",
    "name": "Ulmar",
    "subname": "Perithon Racer",
    "set": "au",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Conqueror Muge",
    "ability": "Expend :fire:Fire: Deal 10 damage to target Creature.",
    "flavorText": "To improve the Ulmanator's top speed, Ulmar removed all unnecessary components from the vehicle. Unfortunately, that included the brakes.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "31/200",
    "isPast": false,
    "stats": {
      "courage": 50,
      "power": 40,
      "wisdom": 80,
      "speed": 40,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/KS7QszI.png"
  },
  {
    "id": "AU-S12/26",
    "displayName": "Voorx",
    "name": "Voorx",
    "subname": "",
    "set": "au",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Elementalist",
    "ability": "When Voorx becomes engaged, your opponent can sacrifice a Battlegear. If they do not, Voorx gains \":fire:Fire 5\" and \":water:Water 5.\"",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Bob Rivard",
    "serialNumber": "S12/26",
    "isPast": true,
    "stats": {
      "courage": 50,
      "power": 80,
      "wisdom": 70,
      "speed": 40,
      "energy": 55,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/rCCCgIR.png"
  },
  {
    "id": "AU-32/200",
    "displayName": "Zamool, Lord Van Bloot's Enforcer",
    "name": "Zamool",
    "subname": "Lord Van Bloot's Enforcer",
    "set": "au",
    "rarity": "ultra rare",
    "tribe": "underworld",
    "subtype": "Conqueror",
    "ability": "If Zamool is engaged, opposing Creatures cannot play Mugic or abilities.",
    "flavorText": "Darker than night. Quieter than silence. More terrifying than fear.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Anthony Washington",
    "serialNumber": "32/200",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 70,
      "wisdom": 50,
      "speed": 90,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/GdEUkSi.png"
  },
  {
    "id": "FAS-21/100",
    "displayName": "Cyrenox",
    "name": "Cyrenox",
    "subname": "",
    "set": "fas",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": "If all Creatures you control have :fire:Fire, Cyrenox deals an additional 5 damage with attacks.",
    "flavorText": "Born of darkness, raised in gloom, wielder of sorrow, bringer of doom.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "21/100",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 85,
      "wisdom": 40,
      "speed": 60,
      "energy": 60,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/wHLDWPb.png"
  },
  {
    "id": "OP-OP1-4/20",
    "displayName": "Chargola",
    "name": "Chargola",
    "subname": "",
    "set": "op",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": "Recklessness 5.",
    "flavorText": "Though widely renowned for his meticulous planning, Chargola throws all strategies out the window in the heat of the skirmish.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Jimmy Tran",
    "serialNumber": "OP1-4/20",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 95,
      "wisdom": 75,
      "speed": 60,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/y9ZQPoH.png"
  },
  {
    "id": "OP-OP1-5/20",
    "displayName": "Dyrtax",
    "name": "Dyrtax",
    "subname": "",
    "set": "op",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Scout",
    "ability": "Swift 1.",
    "flavorText": "Treasure hunters constantly try to steal valuable crystals at Jade Pillar. Dyrtax makes sure they don't get too greedy.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Graz Entertainment ",
    "serialNumber": "OP1-5/20",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 70,
      "wisdom": 55,
      "speed": 75,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/DOTNRko.png"
  },
  {
    "id": "OP-OP1-6/20",
    "displayName": "Getterek",
    "name": "Getterek",
    "subname": "",
    "set": "op",
    "rarity": "super rare",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Intimidate: :power:Power 10.",
    "flavorText": "It is recommended that you pay the toll before you cross the bridge.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, David Curiel",
    "serialNumber": "OP1-6/20",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 105,
      "wisdom": 35,
      "speed": 55,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/dcUoExx.png"
  },
  {
    "id": "DOP-BR-08",
    "displayName": "Agitos",
    "name": "Agitos",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Commander",
    "ability": ":underworldmugic:: Deal 5 damage to target Creature.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "serialNumber": "BR-08",
    "isPast": false,
    "stats": {
      "courage": 75,
      "power": 50,
      "wisdom": 95,
      "speed": 45,
      "energy": 60,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/3eyflqR.png"
  },
  {
    "id": "DOP-BR-11",
    "displayName": "Banshor",
    "name": "Banshor",
    "subname": "",
    "set": "dop",
    "rarity": "uncommon",
    "tribe": "underworld",
    "subtype": "Ethereal",
    "ability": "Recklessness 5.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "BR-11",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 95,
      "wisdom": 75,
      "speed": 60,
      "energy": 65,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/rMylyAn.png"
  },
  {
    "id": "DOP-BR-09",
    "displayName": "Cerbie",
    "name": "Cerbie",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Taskmaster",
    "ability": "Intimidate: :power:Power 10.",
    "flavorText": "As the UnderWorld guardian of The Passage, Cerbie is forever vigilant against any potential invasion from the OverWorld.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Kazutoko Matsumoto",
    "serialNumber": "BR-09",
    "isPast": false,
    "stats": {
      "courage": 60,
      "power": 105,
      "wisdom": 35,
      "speed": 55,
      "energy": 65,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/LroZWXd.png"
  },
  {
    "id": "DOP-BR-04",
    "displayName": "Mishmoshmish",
    "name": "Mishmoshmish",
    "subname": "",
    "set": "dop",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Scout",
    "ability": "Swift 1.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph, Etienne St.Laurent",
    "serialNumber": "BR-04",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 70,
      "wisdom": 55,
      "speed": 75,
      "energy": 50,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/8tAvVPB.png"
  },
  {
    "id": "OP-LR03/10",
    "displayName": "Khybon's Engineered Automaton",
    "name": "Khybon's Engineered Automaton",
    "subname": "",
    "set": "op",
    "rarity": "common",
    "tribe": "underworld",
    "subtype": "Taskmaster Warrior",
    "ability": "Sacrifice a Battlegear: Target Taskmaster gains 40 to all Disciplines. Use this ability only once per turn.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios, Anthony Washington",
    "serialNumber": "LR03/10",
    "isPast": false,
    "stats": {
      "courage": 40,
      "power": 60,
      "wisdom": 30,
      "speed": 30,
      "energy": 45,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/60qnqxX.png"
  },
  {
    "id": "OP-LR04/10",
    "displayName": "Ulmar, Wavescrambler",
    "name": "Ulmar",
    "subname": "Wavescrambler",
    "set": "op",
    "rarity": "rare",
    "tribe": "underworld",
    "subtype": "Conqueror",
    "ability": "Minion Creatures cannot play activated abilities if their controller also controls a Chieftain Creature.\r\nUlmar cannot be targeted by Mugic.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keron Grant, VJ Comando",
    "serialNumber": "LR04/10",
    "isPast": false,
    "stats": {
      "courage": 45,
      "power": 65,
      "wisdom": 75,
      "speed": 75,
      "energy": 35,
      "mugic": 0
    },
    "elements": {
      "fire": 1,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/cVcS2VL.png"
  },
  {
    "id": "DOP-P-017",
    "displayName": "Irsenog",
    "name": "Irsenog",
    "subname": "",
    "set": "dop",
    "rarity": "promo",
    "tribe": "underworld",
    "subtype": "Warrior",
    "ability": ":air:Air 5.",
    "flavorText": "Few realize his claws are as sharp as his serrated blade until it is much, much too late.",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw, Bob Rivard",
    "serialNumber": "P-017",
    "isPast": false,
    "stats": {
      "courage": 85,
      "power": 70,
      "wisdom": 40,
      "speed": 50,
      "energy": 55,
      "mugic": 1
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/kgRPKH7.png"
  },
  {
    "id": "DOP-P-003",
    "displayName": "Opto",
    "name": "Opto",
    "subname": "",
    "set": "dop",
    "rarity": "promo",
    "tribe": "underworld",
    "subtype": "Scout",
    "ability": "Creatures engaged with Scouts you control do not have and cannot gain Invisibility.",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin Nebres, Etienne St.Laurent",
    "serialNumber": "P-003",
    "isPast": false,
    "stats": {
      "courage": 80,
      "power": 60,
      "wisdom": 60,
      "speed": 50,
      "energy": 35,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 1,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/TtjN5sl.png"
  },
  {
    "id": "undefined-xh8g4vja",
    "displayName": "Aah'terai",
    "name": "Aah'terai",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "m'arrillian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/cnl3du1.jpeg"
  },
  {
    "id": "undefined-je9if990",
    "displayName": "Aa'une Alt Art",
    "name": "Aa'une Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "m'arrillian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/gugKUqS.jpeg"
  },
  {
    "id": "undefined-k6pv8vsa",
    "displayName": "Ahnem",
    "name": "Ahnem",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Jay Axer",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/5aL0qTm.jpeg"
  },
  {
    "id": "undefined-7us1s9l0",
    "displayName": "Aisgarr",
    "name": "Aisgarr",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Etienne St Laurent",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/7XWwxr9.jpeg"
  },
  {
    "id": "undefined-c1eyirxu",
    "displayName": "Akwi",
    "name": "Akwi",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keith Conroy & Jay Axer",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/pcktz51.jpeg"
  },
  {
    "id": "undefined-so2vjwon",
    "displayName": "Aliecs",
    "name": "Aliecs",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Jimmy Tran",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/4C2dHAH.png"
  },
  {
    "id": "undefined-6k1zdx1k",
    "displayName": "Aztrolar",
    "name": "Aztrolar",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "danian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw & Jimmy Tran",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/D5CX7T3.jpeg"
  },
  {
    "id": "undefined-0bp7a6ok",
    "displayName": "Blugon Alt Art",
    "name": "Blugon Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Etienne St Laurent",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/jCg8Tke.jpeg"
  },
  {
    "id": "undefined-tvj9qg67",
    "displayName": "Borth-Majar Alt Art",
    "name": "Borth-Majar Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Jay Axer",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Ul2N3vW.jpeg"
  },
  {
    "id": "undefined-4d0fgryy",
    "displayName": "Chaor Alt Art",
    "name": "Chaor Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/X5IwljL.jpeg"
  },
  {
    "id": "undefined-clhoe8kc",
    "displayName": "Cirleth",
    "name": "Cirleth",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Bob Rivard & Khary Randolph",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/OxVJ1ff.jpeg"
  },
  {
    "id": "undefined-qc9hpa3d",
    "displayName": "Deenha",
    "name": "Deenha",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Bob Rivard",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/9g216Lr.png"
  },
  {
    "id": "undefined-t709q0tx",
    "displayName": "Dhegahn",
    "name": "Dhegahn",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "m'arrillian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Etienne St Laurent",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/qtdwuCP.jpeg"
  },
  {
    "id": "undefined-lbigh0mn",
    "displayName": "Dractyl Alt Art",
    "name": "Dractyl Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/DPoB0AU.jpeg"
  },
  {
    "id": "undefined-bkkc425s",
    "displayName": "Eerhin",
    "name": "Eerhin",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/p7WlOZQ.jpeg"
  },
  {
    "id": "undefined-h6febn1w",
    "displayName": "Ekuud Alt Art",
    "name": "Ekuud Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "danian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Etienne St Laurent",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/CE93r9s.jpeg"
  },
  {
    "id": "undefined-qb9jrcm7",
    "displayName": "Elira",
    "name": "Elira",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Jay Axer & Keith Conroy",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/WeIdeOp.jpeg"
  },
  {
    "id": "undefined-h3216tkz",
    "displayName": "Fahrkaj Alt Art",
    "name": "Fahrkaj Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Tony Washington & Khary Randolph",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/3hKym4K.jpeg"
  },
  {
    "id": "undefined-e2fpswce",
    "displayName": "Frafdo Alt Art",
    "name": "Frafdo Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/D8bycyE.jpeg"
  },
  {
    "id": "undefined-od74k9f5",
    "displayName": "Ganassaran",
    "name": "Ganassaran",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Jay Axer",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/NESvrt2.jpeg"
  },
  {
    "id": "undefined-ivjnz2ih",
    "displayName": "Getaan",
    "name": "Getaan",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "danian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/kggWBCK.jpeg"
  },
  {
    "id": "undefined-dmddukwj",
    "displayName": "Guernath",
    "name": "Guernath",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Bob Rivard",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/s3Byu8W.png"
  },
  {
    "id": "undefined-asfjij5d",
    "displayName": "Hear'ring",
    "name": "Hear'ring",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Bob Rivard",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Uw97vgd.jpeg"
  },
  {
    "id": "undefined-03q8oooy",
    "displayName": "Iflar Alt Art",
    "name": "Iflar Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Tony Washington",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/pA36nab.jpeg"
  },
  {
    "id": "undefined-rrl4tyi9",
    "displayName": "Illexia, Elder of the Nest",
    "name": "Illexia",
    "subname": "Elder of the Nest",
    "set": "",
    "rarity": "",
    "tribe": "danian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/72L4lDW.png"
  },
  {
    "id": "undefined-7mwdth2c",
    "displayName": "Kemmosh",
    "name": "Kemmosh",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Jay Axer",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/lAGNDVJ.jpeg"
  },
  {
    "id": "undefined-w6i6u708",
    "displayName": "Kienrah",
    "name": "Kienrah",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Keith Conroy & Jay Axer",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/WXIjk1k.jpeg"
  },
  {
    "id": "undefined-fj0dvas1",
    "displayName": "Kughar Alt Art",
    "name": "Kughar Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/Jy8vKvv.jpeg"
  },
  {
    "id": "undefined-aztic1h6",
    "displayName": "Lord Van Bloot Alt Art",
    "name": "Lord Van Bloot Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Jay Axer & Khary Randolph",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/pJZZ0Wn.jpeg"
  },
  {
    "id": "undefined-427frf76",
    "displayName": "Lujah",
    "name": "Lujah",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Jay Axer",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/bUCjfZO.jpeg"
  },
  {
    "id": "undefined-axjvagls",
    "displayName": "Marquis Darini Alt Art",
    "name": "Marquis Darini Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/6QXbjvq.jpeg"
  },
  {
    "id": "undefined-z6di8ar6",
    "displayName": "Mhoork",
    "name": "Mhoork",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Jay Axer",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/NUrvbNa.jpeg"
  },
  {
    "id": "undefined-ub4ttejf",
    "displayName": "Nidding",
    "name": "Nidding",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Bob Rivard",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/gznZOMA.jpeg"
  },
  {
    "id": "undefined-3zo8g7b3",
    "displayName": "Phelphor Alt Art",
    "name": "Phelphor Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "m'arrillian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Bob Rivard",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/2Al4iD7.jpeg"
  },
  {
    "id": "undefined-r08rkcii",
    "displayName": "Prince Mudeenu, Vassal of the King",
    "name": "Prince Mudeenu",
    "subname": "Vassal of the King",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Etienne St Laurent",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/IuzmjWo.jpeg"
  },
  {
    "id": "undefined-kfg6orgr",
    "displayName": "Pyrithion Alt Art",
    "name": "Pyrithion Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Jay Axer",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/I0l1CTG.jpeg"
  },
  {
    "id": "undefined-bzny6hza",
    "displayName": "Raimusa Alt Art a",
    "name": "Raimusa Alt Art a",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Edwin T Nebres & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/SayYPHK.jpeg"
  },
  {
    "id": "undefined-os2kgg03",
    "displayName": "Raimusa Alt Art b",
    "name": "Raimusa Alt Art b",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/B63gs3D.jpeg"
  },
  {
    "id": "undefined-j65ii291",
    "displayName": "Rarran, Night Thief",
    "name": "Rarran",
    "subname": "Night Thief",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Andrew Bradshaw & Etienne St Laurent",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/p2TTv4J.jpeg"
  },
  {
    "id": "undefined-lkiwleol",
    "displayName": "Rhaden",
    "name": "Rhaden",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Adrian Barrios & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/XasndQL.jpeg"
  },
  {
    "id": "undefined-cnfw6sgu",
    "displayName": "Sahrbat",
    "name": "Sahrbat",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Bob Rivard",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/6oVD4px.png"
  },
  {
    "id": "undefined-0mie23wz",
    "displayName": "Siado",
    "name": "Siado",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/g8csw5N.jpeg"
  },
  {
    "id": "undefined-7tr8xnq2",
    "displayName": "Steem",
    "name": "Steem",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Etienne St Laurent",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/JaqYdyq.jpeg"
  },
  {
    "id": "undefined-2j9yujkz",
    "displayName": "Theb-Sarr, King of Mipedim",
    "name": "Theb-Sarr",
    "subname": "King of Mipedim",
    "set": "",
    "rarity": "",
    "tribe": "mipedian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Khary Randolph & Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/PS5IkSU.jpeg"
  },
  {
    "id": "undefined-fwjsdma8",
    "displayName": "Ulfheddin Alt Art",
    "name": "Ulfheddin Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "overworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/qQjEqJl.png"
  },
  {
    "id": "undefined-v3uhgkqh",
    "displayName": "Zalvar",
    "name": "Zalvar",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "underworld",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "Emilio Lopez",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": "https://i.imgur.com/r5DPxit.jpeg"
  },
  {
    "id": "undefined-fu5vzvqn",
    "displayName": "Bahrakatan Alt Art",
    "name": "Bahrakatan Alt Art",
    "subname": "",
    "set": "",
    "rarity": "",
    "tribe": "m'arrillian",
    "subtype": "",
    "ability": "",
    "flavorText": "",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": false,
    "legendary": false,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "",
    "serialNumber": "",
    "isPast": false,
    "stats": {
      "courage": 0,
      "power": 0,
      "wisdom": 0,
      "speed": 0,
      "energy": 0,
      "mugic": 0
    },
    "elements": {
      "fire": 0,
      "air": 0,
      "earth": 0,
      "water": 0
    },
    "imageUrl": ""
  },
  {
    "id": "SAS-1/1",
    "displayName": "Bulba, Perim's #1 Vendor",
    "name": "Bulba",
    "subname": "Perim's #1 Vendor",
    "set": "sas",
    "rarity": "promo",
    "tribe": "overworld",
    "subtype": "Mipedian Merchant",
    "ability": "<b>Barter</b> (1x/turn): Target an engaged creature \r\nyou control. It gains the following based on the tribe of the opposing engaged creature: :overworld:: Heal 10. \r\n:underworld:: Deal 10 Damage. :mipedian:: Invisibility Strike 10. \r\n:danian:: Hive +5 Energy. :marrillian:: Mugic costs -1 :genericmugic: this turn. Opponent then gains 5 Energy.",
    "flavorText": "\"You still believe Maxxor controls the OverWorld? Try surviving a week without the trade routes I supply.\" — Bulba",
    "brainwashedText": "",
    "brainwashed": false,
    "unique": true,
    "legendary": true,
    "loyal": false,
    "loyalRestriction": "",
    "artist": "",
    "serialNumber": "1/1",
    "isPast": false,
    "stats": {
      "courage": 70,
      "power": 70,
      "wisdom": 100,
      "speed": 120,
      "energy": 75,
      "mugic": 3
    },
    "elements": {
      "fire": 0,
      "air": 1,
      "earth": 1,
      "water": 1
    },
    "imageUrl": "https://i.imgur.com/Nkhh5f3.png"
  }
];

// Helper functions to work with the database
export const getCreatureById = (id) => {
  return creatureDatabase.find(creature => creature.id === id);
};

export const getAllCreatureNames = () => {
  return creatureDatabase.map(creature => ({
    id: creature.id,
    displayName: creature.displayName,
    tribe: creature.tribe,
    isPast: creature.isPast,
    set: creature.set || '',
    setDisplay: creature.set ? creature.set.toUpperCase() : ''
  }));
};
